module.exports = {
  message: {
    hello: '您好 ',
    switchLanguage: '切换语言',
    switchSystem: '切换系统',
    logout: '退出',
    restore: '还原',
    theme: '主题',
    uploadFile: "单击或拖动文件到此处上传",
    uploadTemplate: "上传模板",
    selectTemplate: "选择模板",
    templateName: "模板名称",
    import: "导入",
    ActiveorNot:'是否激活',
    ExpiryDate:'有效截止日期',
    Expiry:'激活',
    close:'关闭',
    ActivationCode:'激活码',
    getActivationCode:'获取激活码',
    ActivationType:'激活时长',
    select:'查询',
    tips:'根据AWS建议的最佳实践，不推荐使用AKSK的账户访问方式，推荐使用AssumeRole的访问方式。',
    noPermission: '暂无权限，请联系管理员',
    managementSystem: '管理系统',
    copySuccessfully: '复制成功',
    copyFailed: '复制失败',
    chineseLabel: '中文',
    switchSuccess: '切换为中文!',
    testMenu: '这里是测试菜单',
    week: {
      sun: '天',
      mon: '一',
      tue: '二',
      wed: '三',
      thu: '四',
      fri: '五',
      sat: '六'
    }
  },
  // 账单数据
  BillingServices:{
    BillingRules:'账单规则',
    Dataprocessingrules:'数据处理规则',
    Pleaseselectacompany:'请选择公司',
    Querybyrulename:'请输入规则名称',
    select:'查询',
    AddRule:'添加规则',
    companyName:'公司名称',
    ruleName:'规则名称',
    Cloudplatformtype:'云平台类型',
    Billingdatasource:'账单数据源 ',
    Appliedlabelrules:'应用的标签规则',
    oper:'操作',
    del:'删除',
    Operationlog:'操作日志',
    AddProcessingRule:'添加处理规则',
    company:'公司',
    WhetherRIprocessingisrequired:'是否需要RI处理',
    LabelRules:'标签规则',
    cancel:'取消',
    add:'添加',
    edit: "编辑",
    EditProcessingRule:'编辑处理规则',
    confirm:'确认',
    Operationmodule:'操作模块',
    Operationfield:'操作字段',
    Originalvalue:'原值',
    Newvalue:'新值',
    Operator:'操作人',
    UpdateTime:'更新时间',
    Labelhandlingrules:'标签处理规则',
    conditionsforexecution:'执行条件',
    Conditioncontent:'条件内容',
    Executeaction:'执行动作',
    Satisfyanyone :'满足任意一个',
    Meetall:'满足所有',
    PleaseentertagKey:'请输入tagKey',
    PleaseentertagValue:'请输入tagValue',
    AddLabel:'添加标签',
    tagNoSpecialChar:'标签值前后不能有特殊字符和空格',
    executeActionLabel:'执行动作:',
    tagRuleTooltip:`tag处理规则
                    选择满足任意一个，当对应字段名称和字段值满足任意一个条件则进行修改
                    例如：
                    字段名称：project  字段值：sme
                    执行动作：project  字段值：SME
                    执行结果：将字段名称project的字段值为sme的修改为SME
                    选择满足所有，当标签字段名称和标签字段值满足所有条件时进行修改
                    例如：
                    字段名称：project   字段值：sme
                    字段名称：owner    字段值：gt
                    执行动作：project   字段值：SME
                    执行结果：当标签字段project为sme且标签字段owner为gt时，project的值修改为SME`,
    pleaseInputRuleName:'请输入规则名称',
    pleaseSelectCloudPlatformType:'请选择云平台类型',
    pleaseSelectBillingDataSource:'请选择账单数据源',
    ruleNameDuplicate:'规则名称重复',
    pleaseInputComplete:'请填写完整',
    keepAtLeastOne:'至少保留一项',
    duplicateConditionRow:'执行条件第{row}行为重复项，请删除重复项',
    duplicateActionRow:'执行动作第{row}行为重复项，请删除重复项',
    duplicateActionFieldName:'执行动作字段名称不能重复，请删除重复项',
    actionConditionDuplicate:'执行动作与执行条件不可重复，请删除重复项',
    pleaseInputExportRecordName:'请输入导出记录名称',
    pleaseSelectExportTemplate:'请选择导出模板',
    pleaseSelectBillingTimeRange:'请选择账单时间范围',
    pleaseSelectListFields:'请选择列表字段',
    pleaseSelectStatisticalFields:'请选择统计字段',

    // 新加
    AddLabelRule:'添加标签规则',
    editLabelRule:'编辑标签规则',

    // 导出
    BillExport:'AWS账单导出',
    ExportAWSbill:'导出AWS账单',
    ExportRecords:'导出记录',
    ExportTemplate:'导出模板',
    Querybyrecordname:'请输入记录名称',
    QuerybyTemplateName:'请输入模板名称',
    Pleaseselecttheexportstatus:'请选择导出状态',
    export:'导出',
    Recordname:'记录名称',
    Accountlists:'账号列表',
    Billingtimerange:'账单时间范围',
    status:'状态',
    TemplateName:'模板名称',
    ExportListFields:'导出列表字段',
    ExportStatisticsFields:'导出统计字段',
    Exporttagfield:'导出tag字段',
    Exporttime:'导出时间',
    download:'下载',
    DownloadRecords:'下载记录',
    ExportRecordName:'导出记录名称',
    ListFields:'列表字段',
    Statisticalields:'统计字段',
    Tagfield:'tag字段',
    Downloader:'下载人',
    Downloadtime:'下载时间',
    addtemplate:'添加模板',
    Cloudplatformtype:'云平台类型',
    Billofaccountcloudplatform:'账单云平台',
    AccountList:'账户列表',
    EditTemplate:'编辑模板',
  },
  // 仪表盘菜单
  dashboard: {
    dashboard: '仪表盘',
    tickets: '本月案例数量',
    ticket: '案例',
    averageResponseTime: '平均响应时间',
    maximumLevel: '最高等级事件数量',
    eventCreation: '事件创建',
    currentBacklog: '当前待办总数',
    hosts: '当前主机数目',
    host: '主机',
    running: '运行',
    stopping: '关机',
    hostCreation: '一周主机创建',
    alarms: '当前监控指标总数',
    securityRating: '安全评分',
    security: '安全',
    totalRisks: '总风险数量',
    highRisks: '高风险等级数量',
    baselineProblems: '基线问题数量',
    holes: '漏洞数量',
    sumCost: '当前账务汇总',
    cost: '花费',
    currentCost: '本月当前费用',
    cumulative: '今年累计花费',
    expected: '本月预计花费',
    recharge: '上次充值金额',
    date: '充值日期',
    balance: '账户余额',
    spendingThan: '支出占比（按标签）',
    backlog: '待办事项',
    subject: '主题',
    classification: '分类',
    serious: '严重',
    updateTime: '更新时间',
    status: '状态',
    resourceCreated: '资源创建数量',
    log: '日志',
    netRejection: '网络访问拒绝',
    resourceDeletion: '资源删除',
    resourceChange: '一周资源更新 ',
    exceptionRequest: '本月异常请求总数',
    estimatedTotal: '本月预计费用',
    noMatchRI: '未匹配RI',
    rISaving: '本月RI节省',
    // 待办事项
    theme: '主题',
    resource: '分类',
    priority: '优先级',
    modifiedTime: '更新时间',
    // 图表
    chart: {
      spendingProportion: '支出占比',
      eventTotal: '事件总数',
      startTotal: '启动总数',
      resourceChangeTotal: '资源变更总数',
      unit: '单元',
      quantity: '数量',
      resourceDeletion: '资源删除',
      createdHostTotal: '创建主机总数',
      alarmEvent: '告警事件',
      dailyCost: '日花费',
      cumulativeCost: '费用累计值',
      total: '总量',
      filterByTag: '按标签筛选'
    }
  },
  // 案例菜单
  ticket: {
    // 案例列表
    list: {
      isReply: '是否回复',
      ticket: '案例 ',
      addTicket: '添加案例',
      addComment: '添加评论',
      category: '问题类型',
      subject: '概要',
      status: '状态',
      monitorModule: '监控模块',
      level: '优先级',
      assignee: '经办人',
      attachment: '附件',
      description: '描述',
      cancel: '取消  ',
      confirm: '确定  ',
      ticketEntityID: '案例ID',
      operation: '操作',
      delete: '删除',
      detail: '详情',
      ticketDetail: '案例详情',
      export: '导出',
      return: '返回案例',
      reporter: '报告人',
      date: '日期',
      createdDate: '创建日期',
      modifiedDate: '更新日期',
      comment: '评论',
      addedComments: '添加了评论 ',
      changeRecord: '改动记录 ',
      operator: '操作人 ',
      fieldType: '字段类型 ',
      originalValue: '原值 ',
      newValue: '新值 ',
      modifiedTime: '更新时间',
      attachmentList: '附件列表 ',
      fileName: '文件名',
      storagePath: '存储路径',
      affirmDownload: '下载确认',
      personnel: '人员',
      createdTime: '创建时间',
      handleTime: '处理时间',
      waitTime: '响应时间',
      finishTime: '完成时间',
      Process: '处理',
      selectByCaseId: '请输入案例ID',
      selectByCompany: '请输入公司',
      selectByPriority: '请输入优先级',
      selectByStatus: '请输入状态',
      selectByProblemTypes: '请输入问题类型',
      selectByOperator: '请输入经办人',
      selectByDate: '请输入创建时间',
      closeReason: '关闭理由',
      confirmMan: '确认人',
      editTicket: '编辑案例',
      allocation: '分配',
      keyDistribution: '一键分配',
      enableKeyDistribution: '你确定要使用一键分配吗?',
      Pending: '等待处理',
      Processing: '正在处理',
      Finish: '手动关闭',
      WaitingForTheAuthorization: '等待授权',
      CheckNozzle: '自动完成',
      UnderReview: '审核中',
      TheAuditFails: '审核不通过',
      Approved: '审批通过',
      Confirming: '确认中',
      Confirmed: '已确认',
      updateStatus:'更新状态',
      list:'列表',
      continuePurchase:'是否续买',
      cloudPlatformType: '云平台类型',
      monitorIndex: '监控指标',
      selectCloudPlatformAndModuleFirst: '请先选择云平台类型和监控模块',
      selectAll: '全选',
      query: '查询',
      confirmChangeAiStatus: '确定修改接管状态吗?',
      updateSuccess: '更新成功',
      manual: '人工',
      selectProblemType: '请选择问题类型',
      selectFunctionType: '请选择功能类型',
      selectCompany: '请选择公司',
      selectApprovalFlow: '请选择审批流',
      summaryRequired: '概要不能为空',
      selectPriority: '请选择优先级',
      selectStatus: '请选择状态',
      selectAssignee: '请选择经办人',
      selectConfirmMan: '请选择确认人',
      selectMonitorIndex: '请选择监控指标',
      selectSatisfaction: '请选择满意度',
      enterCloseReason: '请输入关闭理由',
      maxChars1000: '最多输入1000个字符',
      maxChars10000: '最多输入10000个字符',
      selectContinuePurchase: '请选择是否续买',
      assignSuccess: '分配成功',
      templateRequired: '模版不能为空',
      importSuccess: '导入成功',
      importFail: '导入失败',
      selectCreateTime: '请选择创建时间',
      confirm2: '确认',
      confirmRenewal: '确认续购',
      noRenewalNeeded: '无需续购',
      purchaseConfirm: '购买确认',
      workOrderNumber: '工单编号',
      assignTo: '分配给：',
      pleaseSelect: '请选择',
      confirmNoRenewalContent: '确认提交"无需续购"结论吗？该操作会在工单中生成标准评论 "客户已确认无需续购 RI"，AI 识别后将取消未完成的 RI 续购任务并关闭当前工单。',
      selectAssignedPerson: '请选择分配人',
      submitFail: '提交失败',
      confirmRenewalSubmitted: '已提交确认续购',
      noRenewalSubmitted: '已提交无需续购',
      confirmPurchaseContent: '确认已完成 RI 购买操作吗？',
      confirmFail: '确认失败',
      purchaseConfirmSuccess: '购买确认成功',
      requestFail: '请求失败'
    },
    // 评论
    comment: {
      addComments: "添加评论",
      comment: "评论",
      changeRecord: "改动记录",
      attachmentList: "附件列表",
      confirmDownload: "你确定要下载",
      what: "吗",
      download: "下载",
      responsiblePerson: "操作人",
      operationType: "操作类型",
      originValue: "原值",
      newValue: "新值",
      description: "描述",
      updateTime: "更新时间",
      fileName: "文件名称",
      fileType: "文件类型",
      storagePath: "存储路径",
      pleaseEnterDescription: "请输入描述",

    },
    // 案例仪表盘
    dashboard: {
      realTimeStatistics: '案例处理实时统计',
      status: '状态',
      averageResponseTime: '案例处理实时统计',
      responseTime: '响应时间',
      count: '数量'
    }
  },

  // 监控告警管理菜单
  alarms: {
    portForward: {
      search: {
        pleaseSelectAccount: '请选择账号',
        pleaseSelectDatabase: '请选择数据库',
        pleaseSelectTimeRange: '请选择时间范围',
        pleaseSelectDatabaseName: '请选择数据库名称',
      },
    },
    weeklyReport: {
      title: '周报',
      addAlertRule: '添加周报报警规则',
      editAlertRule: '编辑周报报警规则',
      company: '公司',
      account: '账号',
      region: '区域',
      search: {
        pleaseSelectAccount: '请选择账号',
      },
    },
    resourceGroup: {
      msg: {
        resourceGroupNameDuplicate: '资源组名称不能重复!',
        companyRequired: '公司不能为空',
        resourceGroupNameRequired: '资源组名称不能为空',
        accountRequired: '账户不能为空',
        regionsRequired: '区域不能为空',
        tagKeyRequired: '标签关键字不能为空',
        tagValueRequired: '标签值不能为空',
        notificationObjectRequired: '通知对象不能为空',
        alarmWayRequired: '报警方式不能为空',
        delayTypeRequired: '延迟告警不能为空',
        fillAllRequired: '请先填写完所有必填项',
      },
    },
    // 实例
    instance: {
      instance: '实例',
      instanceConfiguration: '实例配置',
      accountType: '账户类型',
      disk: '磁盘 ',
      systemDisk: '系统盘',
      dateDisk: '数据盘',
      hostInformation: '主机信息',
      instanceId: '实例ID',
      addInstanceAlarm: '添加实例报警规则',
      editInstanceAlarm: '编辑实例报警规则',
      instanceName: '实例名称',
      accountName: '账户名称',
      ip: 'IP地址',
      state: '状态',
      region: '区域',
      cpuUsage: 'CPU使用率',
      memoryUsage: '内存使用率',
      diskSpaceUsage: '磁盘空间使用率',
      networkInput: '网络输入',
      networkOutput: '网络输出',
      instanceHealthCheck: '实例健康状态检查',
      systemHealthCheck: '系统健康状态检查',
      instanceMaintenanceInformation: '实例维护信息',
      frequentLoginFailures: '频繁登录失败',
      linuxInodeUsage: 'Linux Inode 使用率',
      instanceList: '实例列表',
      total: '共',
      diskSize: '块磁盘',
      publicIp:"弹性IP",
      allocationId:"分配id",
      privateIp:"私有ip",
      // 折线图
      line:{
        MemoryAvailability:'内存可用量',
        swapUsage:'交换空间大小',
        volumeReadIOPs:'磁盘读IOPS',
        volumeWriteIOPs:'磁盘写IOPS',
        ReadIOPs:'读IOPS',
        WriteIOPs:'写IOPS',
        readLatency:'读取延迟',
        writeLatency:'写入延迟',
        CPUUtilizationPercent:'CPU利用率 (百分比)',
        CPUUtilization:'CPU利用率',
        CPUUtilizationForecast:'CPU利用率预测',
        MemoryUsagePercentage:'内存使用率 (百分比)',
        MemoryUsage:'内存使用率',
        MemoryUsageForecast:'内存使用率预测',
        DiskUtilizationPercent:'磁盘利用率 (百分比)',
        DiskUtilizationPercentForecast:'磁盘利用率预测 (百分比)',
        DiskUtilization:'磁盘利用率',
        LinuxInodeUtilizationPercentage:'Linux Inode 利用率 (百分比)',
        DiskReadAndWriteBytes:'磁盘读写 (字节)',
        DiskRead:'磁盘读',
        DiskWrite:'磁盘写',
        DiskReadForecast:'磁盘读预测',
        DiskWriteForecast:'磁盘写预测',
        ReadAndWriteDiskOperationsOperations:'读写磁盘操作 (操作)',
        DiskReadOperation:'磁盘读操作',
        DiskWriteOperation:'磁盘写操作',
        DiskReadOperationForecast:'磁盘读操作预测',
        DiskWriteOperationForecast:'磁盘写操作预测',
        NetworkInputAndOutputBytes:'网络输入输出 (字节)',
        NetworkInput:'网络输入',
        NetworkOutput:'网络输出',
        NetworkInputForecast:'网络输入预测',
        NetworkOutputForecast:'网络输出预测',
        IncomingAndOutgoingNetworkPacketsNumber:'网络数据包传入传出 (数量)',
        IncomingNetworkPackets:'网络数据包传入',
        OutgoingNetworkPackets:'网络数据包传出',
        IncomingNetworkPacketsForecast:'网络数据包传入预测',
        OutgoingNetworkPacketsForecast:'网络数据包传出预测',
        StatusCheckFailedArbitraryQuantity:'状态检查失败(任意)(数量)',
        StatusCheckFailedOptional:'状态检查失败(任意)',
        StatusCheckFailedInstanceQuantity:'状态检查失败(实例) (数量)',
        StatusCheckFailedExample:'状态检查失败(实例)',
        StatusCheckFailedSystemQuantity:'状态检查失败(系统) (数量)',
        StatusCheckFailedSystem:'状态检查失败(系统)',
        CPUQuotaUsageQuantity:'CPU额度使用 (数量)',
        CPUCreditUsage:'CPU额度使用',
        CPUQuotaBalanceQuantity:'CPU额度余额 (数量)',
        CPUQuotaBalance:'CPU额度余额',
        DiskSpaceUsagePercentage:'磁盘空间使用率（百分比）',
        DiskSpaceUsage:'磁盘空间使用率',
        NetworkIncomingBandwidthBit:'网络流入带宽(bit/s)',
        IncomingInternetBandwidth:'公网流入带宽',
        InboundBandwidthFromPrivateNetwork:'私网流入带宽',
        NetworkOutgoingBandwidthBit:'网络流出带宽(bit/s)',
        PublicNetworkOutgoingBandwidth:'公网流出带宽',
        PrivateNetworkOutgoingBandwidth:'私网流出带宽',
        AverageDiskBPSBps:'磁盘平均BPS (Bps)',
        DiskTotalReadBPS:'磁盘总读BPS',
        DiskTotalWriteBPS:'磁盘总写BPS',
        DiskAverageIOPSTimesSec:'磁盘平均IOPS (次/秒)',
        DiskReadIOPS:'磁盘读IOPS',
        DiskWriteIOPS:'磁盘写IOPS',
        StandardCpuUsage:"CPU使用率",
        StandardMemoryUsage:"内存使用率",
        StandardConnectionUsage:"连接数使用率",
        StandardQPSUsage:"QPS使用率",
        StandardIntranetRatio:"宽带使用率",
        StandardIntranetInRatio:"流入宽带使用率",
        StandardIntranetOutRatio:"流出带宽使用率",
        VpcPublicIpInternetOutRatePercent:"公网流出带宽使用率(bit/s)",
        TotalCPUCurrentlyPercent:"当前消耗的总CPU(百分比)",
        TotalCPUCurrently:"当前消耗的总CPU",
        NetWorkPackage:"网络流入流出数据包数(pps)(Count/s)",
        NetworkinPackages:"网络流入数据包数",
        NetworkoutPackages:"网络流出数据包数",
        TcpConnection:"TCP连接数(个)",
        ESTABLISHED:"ESTABLISHED",
        NON_ESTABLISHED:"NON_ESTABLISHED",
       TCP_TOTAL:"TCP_TOTAL",
       AverageSystemLoad:"系统平均负载",
       load1m:"load1m",
       load5m:"load5m",
       load15m:"load15m",
       NetworkRate:"网络输入输出",
       NetworkinRate:"网络输入",
       NetworkoutRate:"网络输出",
       CpuUsageTimeSecond:"CPU使用时间(秒)",
       CpuUsageTime:"CPU使用时间",
       DiskReadBytesCountKiBS:"磁盘读取字节数(KiB/s)",
       DiskReadBytesCount:"磁盘读取字节数",
       DiskWriteBytesCountKIBs:"磁盘写入字节数(KiB/s)",
       DiskWriteBytesCount:"磁盘写入字节数",
       DiskMaxWriteOpsCount:"峰值磁盘写入操作",
       DiskMaxReadOpsCount:"峰值磁盘读取操作",
       DiskReadOpsCountTimesSec:"磁盘读取IO操作的计数(次/秒)",
       DiskReadOpsCount:"磁盘读取IO操作的计数",
       DiskPercentUsedPercentage:"磁盘使用率(百分比)",
       DiskPercentUsed:"磁盘使用率",
       CacheHitRatio:"缓存命中率",
       RedisCpuUtilization:"CPU使用率",
       KeyspaceMisses:"未命中次数",
       SystemMemoryUsageRatio:"系统内存使用率",
       UsageRatio:"内存使用率",
       ConnectionsTotal:"收到的总连接数",
        UpTime :"实例正常运行时间(s)",
        SystemUpTime:"操作系统正常运行时间(h)",
        }
    },
    // 磁盘
    disk: {
      disk: '磁盘',
      addDiskAlarm: '添加磁盘报警规则',
      editDiskAlarm: '编辑磁盘报警',
      name: '磁盘名称',
      diskId: '磁盘ID',
      capacity: '容量',
      type: '类型',
      iops: '读取速度',
      encrypted: '加密',
      region: '区域',
      state: '状态',
      deviceName: '设备名',
      volumeNotAttached: '卷未挂载',
      volumeReadWritePRIOPS: '卷读写IOPS标准值',
      volumeReadWriteOps: '卷读写IOPS',
      readIOPS: '读IOPS',
      writeIOPS: '写IOPS',
      diskList: "卷列表",
      filterByDiskId:'请输入磁盘ID',
      filterByDiskName:'请输入磁盘名称',
      diskDescription:'磁盘描述',
      diskConfig:'磁盘配置',
      diskInformation:'磁盘信息',
      // 折线图
      line:{
        DiskReadAndWriteIOPSIOPS:'磁盘读写IOPS(IOPS)',
        DiskReadIOPS:'磁盘读IOPS',
        DiskWriteIOPS:'磁盘写IOPS',
        DiskReadIOPSIOPS:'磁盘读IOPS(IOPS)',
        DiskWriteIOPSIOPS:'磁盘写IOPS(IOPS)',
        // DiskReadIOPSIOPSForecast:'磁盘读IOPS预测(IOPS)',
        // DiskWriteIOPSIOPSForecast:'磁盘写IOPS预测(IOPS)',
        DiskSpaceUsage:'磁盘空间使用率(%)',
        // DiskSpaceUsageForecast:'磁盘空间使用率预测(%)',
        TheTotalNumberOfSecondsSpentInReadAndWriteOperationsSeconds:'读取和写入操作耗费的总秒数（秒）',
        TheTotalNumberOfSecondsSpentInTheReadOperation:'读取操作耗费的总秒数',
        TheTotalNumberOfSecondsSpentInWriteOperations:'写入操作耗费的总秒数',
        TheTotalNumberOfSecondsSpentInTheReadOperationForecast:'读取操作耗费的总秒数预测',
        TheTotalNumberOfSecondsSpentInWriteOperationsForecast:'写入操作耗费的总秒数预测',
        ReadAndWriteThroughputOpss:'读写吞吐量（Ops/s）',
        ReadThroughput:'读取吞吐量',
        WriteThroughput:'写入吞吐量',
        ReadThroughputForecast:'读取吞吐量预测',
        WriteThroughputForecast:'写入吞吐量预测',
        ReadAndWriteBandwidthBytes:'读写宽带（字节）',
        ReadBandwidth:'读取带宽',
        WriteBandwidth:'写入带宽',
        ReadBandwidthForecast:'读取带宽预测',
        WriteBandwidthForecast:'写入带宽预测',
        BurstBalancePercentage:'突发余额（百分比）',
        BurstBalance:'突发余额',
        AverageQueueLengthSeconds:'平均队列长度（秒）',
        AverageQueueLength:'平均队列长度',
        PercentageOfIdleTimeSeconds:'空闲花费时间百分比（秒）',
        PercentageOfIdleTime:'空闲花费时间百分比',
        SpaceUsage:"磁盘空间使用量(MB)",
        // SpaceUsageForecast:"磁盘空间使用量预测(MB)",
        InodeUtilization:"Inode使用率(%)",
        DiskReadAndWriteBPS:"磁盘读写字节数(bytes/s)",
        DiskReadBPS:"磁盘读字节数",
        DiskWriteBPS:"磁盘写字节数",
        // DiskReadBPSForecast:"磁盘读字节数预测",
        // DiskWriteBPSForecast:"磁盘写字节数预测",
        DiskReadAndWriteRequestCount:"磁盘读写请求数(count/s)",
        DiskReadRequestCount:"磁盘读请求数",
        DiskWriteRequestCount:"磁盘写请求数",
        // DiskReadRequestCountForecast:"磁盘读请求数预测",
        // DiskWriteRequestCountForecast:"磁盘写请求数预测",
        gcpDiskBytesUsed:"已使用的磁盘字节数(GiB)",
        gcpDiskIOTime:"磁盘 I/O 时间(ms/s)",
        gcpDiskOperationCount:"磁盘操作总数(count/s)"
      }
    },
    // 数据库
    database: {
      accountName: '账户',
      database: '数据库',
      name: '数据库名称',
      databaseId: '数据库实例',
      engine: '数据库引擎',
      type: '数据库类型',
      databaseInformation: '数据库信息',
      databaseConfiguration: '数据库配置',
      storage: '存储',
      storageType: '存储类型',
      addDatabaseAlarm: '添加数据库报警规则',
      editDatabaseAlarm: '编辑数据库报警规则',
      instanceType: '实例类型',
      cpuUsage: 'CPU使用率',
      memoryUsage: '内存使用率',
      diskSpaceUsage: '磁盘空间使用率',
      databaseConnections: '数据库连接数',
      instanceMaintenanceInformation: '实例维护信息',
      readThroughput: '读吞吐量',
      writeThroughput: '写吞吐量',
      readWriteIOPS: '读写IOPS',
      ioConsumptionPercent: 'IO消耗百分比',
      instanceId: '实例ID',
      state: '状态',
      region: '区域',
      filterByDBInstance: '请输入数据库实例',
      databaseList: '数据库列表',
      // 折线图
      line:{
        CPUUtilizationPercent:'CPU利用率 (百分比)',
        CPUUtilization:'CPU利用率',
        CPUUtilizationForecast:'CPU利用率预测',
        NumberOfDatabaseConnectionsNumber:'数据库连接数 (数量)',
        NumberOfDatabaseConnectionsNumberForecast:'数据库连接数预测',
        CpucreditBalance:'CPU额度余额（Count）',
        CpucreditUsage:'CPU额度使用（Count)',
        EbsbyteBalance:'EBS 字节余额（%)',
        EbsioBalance:'EBS IO 余额 (%)',
        EbsioBalancePercent:'EBS IO余额',
        NetworkReceiveThroughputMB:'网络接收吞吐量',
        NetworkTransmitThroughputMB:'网络传输吞吐量',
        NetworkReceiveTransmitThrough:'网络接收传输吞吐量(MB)',
        WriteReadLatency:'读写延迟(ms)',
        ReadLatencyMS:'读取延迟',
        WriteLatencyMS:'写入延迟',
        BufferCacheHitRatio:'缓冲区缓存命中率（%）',
        BufferCacheHitRatioPercent:'缓冲区缓存命中率',
        NumberOfDatabaseConnections:'数据库连接数',
        AvailableStorageSpaceBytes:'可用存储空间 (字节)',
        AvailableStorageSpace:'可用存储空间',
        AvailableStorageSpaceBytesForecast:'可用存储空间预测',
        AvailableMemoryMB:'可用内存 (%)',
        AvailableMemory:'可用内存',
        AvailableMemoryForecast:'可用内存预测',
        ReadAndWriteIOPSTimesSecond:'读写IOPS (%)',
        ReadIOPS:'读写IOPS',
        WriteIOPS:'写IOPS',
        ReadIOPSForecast:'读IOPS预测',
        WriteIOPSForecast:'写IOPS预测',
        QueueDepthNumber:'队列深度 (数量)',
        QueueDepth:'队列深度',
        BinaryLogDiskUsageMB:'二进制日志磁盘使用情况 (MB)',
        BinaryLogDiskUsage:'二进制日志磁盘使用情况',
        ReadAndWriteThroughputMBSec:'读写吞吐量 (MB/秒)',
        ReadThroughput:'读吞吐量',
        WriteThroughput:'写吞吐量',
        ReadThroughputForecast:'读吞吐量预测',
        WriteThroughputForecast:'写吞吐量预测',
        CPUUsagePercentage:'cpu使用率 (百分比)',
        CpuUsage:'cpu使用率',
        ConnectionUsagePercentage:'连接数使用率 (百分比)',
        ConnectionUsageRate:'连接数使用率',
        MemoryUsagePercentage:'内存使用率 (%)',
        MemoryUsage:'内存使用率',
        DiskUsagePercentage:'磁盘使用率 (%)',
        DiskUsage:'磁盘使用率',
        IOPSUsageRatePercentage:'IOPS使用率(%)',
        IOPSUsageRate:'IOPS使用率',
        StorageUtilizationPercentage:'存储利用率 (百分比)',
        StorageUtilization:'存储利用率',
        MemoryUtilizationPercentage:'内存利用率 (%)',
        MemoryUtilization:'内存利用率',
        ActiveConnectionsCount:'活动连接数 (Count)',
        ActiveConnections:'活动连接数',
        IOUtilizationPercentage:'IO利用率(%)',
        IOUtilization:'IO利用率',
        ProcessMemoryPercentagePercentage:'进程内存百分比 (%)',
        ProcessMemoryPercentage:'进程内存百分比',
        NumberOfSuccessfulConnectionsCount:'成功连接数 (Count)',
        NumberOfSuccessfulConnections:'成功连接数',
        NetworkInputBits:"MySQL网络入流量(bits/s)",
        NetworkInput:"MySQL网络入流量",
        NetworkOutBits:"MySQL网络出流量(bits/s)",
        NetworkOut:"MySQL网络出流量",
        SqlDiskReadOPSCount:"磁盘读取IO(Count)",
        SqlDiskReadOPS:"磁盘读取IO",
        SqlDiskWriteOPSCount:"磁盘写入IO(Count)",
        SqlDiskWriteOPS:"磁盘写入IO",
        SqlCpuUsageS:"CPU累计使用时间(s)",
        SqlCpuUsage:"CPU累计使用时间",
        SqlCpuUtilizationPercentage:"CPU利用率(%)",
        SqlCpuUtilization:"CPU利用率",
        DiskUtilizationPercentage:"磁盘利用率(%)",
        DiskUtilization:"磁盘利用率",
        SqlMemoryUtilizationPercentage:"内存利用率(%)",
        SqlMemoryUtilization:"内存利用率",
        SqlReceivedBytesByte:"网络字节数(byte)",
        SqlReceivedBytes:"网络字节数",
        NetworkConnectionsCount:"数据库连接数(Count)",
        NetworkConnections:"数据库连接数",
        MemoryTotalUsageInnoDB:"总内存使用量",
        MemoryTotalUsageInnoDBMb:"总内存使用量(MB)",
        InnodbPagesTotal:"InnoDB总页数",
        PgActiveConnections:"活跃连接数(个)",
        PgBlksReadDelta:"数据块读取数(个)",
        PgConnUsage:"连接使用率(%)",
        PgCpuTotal:"CPU使用率(%)",
        PgDbAge:"数据库未回卷xid数量(xids)",
        PgMemUsage:"内存使用率(%)",
        PgPlsDataSize:"数据盘大小(Mbyte)",
        PgPlsIops:"IOPS(次)",
        PgPlsIopsRead:"读IOPS(次)",
        PgPlsIopsWrite:"写IOPS(次)",
        PgPlsPgWalDirSize:"WAL日志大小(Mbyte)",
        PgPlsThroughput:"IO吞吐(Mbyte/s)",
        PgPlsThroughputRead:"读IO吞吐(Mbyte/s)",
        PgPlsThroughputWrite:"写IO吞吐(Mbyte/s)",
        PgRollbackRatio:"事务回滚率(%)",
        PgSwellTime:"膨胀点(s)",
        PgTps:"TPS(次)",
        rdsReplicaLag: 'RDS ReplicaLag告警(秒)',
        rdsReadOnly: '只读副本同步延迟'
      }
    },
    //弹性IP
    elasticResource:{
      elasticResource:"弹性IP",
      addEipAlarm: '添加弹性IP报警规则',
      editEipAlarm:"编辑弹性IP报警规则",
      elasticResourceList:"弹性IP列表",
      elasticResourceConfig:"弹性Ip配置",
      type:"账户类型",
      elasticResourceInformation:"弹性IP信息",
      elasticResourceId:"名称",
      allocationId:"分配id",
      instanceId:"关联实例id",
      privateIp:"私有ip",
      //折线图
      line:{
        NetrxPkgsRate:"流入包速率",
        NettxPkgsRate:"流出包速率",
        NetrxRate:"流入带宽(bit/s)",
        NettxRate:"流出带宽(bit/s)",
        NetInRatePercentage:"网络流入带宽利用率(%)",
        NetOutRatePercentage:"网络流出带宽利用率(%)",
        OutRateLimitDropSpeed:"限速丢包速率(Packets/Second)"
      },
    },
    // 财务
    billing: {
      rule: {
        ruleNameDuplicate: '规则名称不能重复!',
        firstThresholdGreaterThan7: '第一个阈值必需要大于7',
        account: '请选择账户名称',
        accountTypeSearchKey: '请选择云平台',
        alarmDelay: '请选择延迟告警',
        monitorPeriod: '请选择监控时段',
        backupRegion: '请选择存储区域',
        types: '请选择类型',
        ruleNameRequired: '规则名称不能为空',
        ruleNamePattern: '规则名称为2-20个字符首尾中间不能有空格',
        notificationObject: '请选择通知对象',
        noticeType: '请选择报警方式',
        monitorIndex: '请选择监控指标',
        accountGroupName: '请选择账户组',
        resourceType: '请选择资源类型',
        cycle: '请选择周期',
        continousCycle: '请选择连续周期',
        statisticsValue: '请选择统计数值',
        relationshipSign: '请选择关系符号',
        checkCycle: '请输入检测周期',
        thresholdValue: '请输入阈值',
        thresholdValues: '请选择阈值',
        contactType: '请选择联系方式',
        contactGroupIds: '请选择联系人组',
        approvalFlow: '请选择审批流',
        enterpriseWechatRobotIds: '请选择企业微信机器人URL',
      },
      modal: {
        validationRule: '验证规则',
        maxSixThresholds: '最多选择6个阈值',
        riThresholdRange: '当监控指标为自动购买预留实例时,阈值的范围是2-60',
      },
      contactGroup: "联系人组",
      contact: "联系人",
      contactWay: "联系方式",
      approval: "审批流",
      monitorIndex: '监控指标',
      pleaseSelectMonitorIndex: "请选择监控指标",
      alertRuleDesc: '报警规则描述',
      accountGroup: '账户组',
      singleAccount: '单账户',
      account: '账户',
      type: '类型',
      alertRuleName: '规则名称',
      cloudType: '云平台',
      billing: '账务',
      addBillingAlarm: '添加账务报警规则',
      editBillingAlarm: '编辑账务报警规则',
      accountGroupName: '账户组名称',
      region: '区域',
      resourceType: '资源类型',
      filterByBillingType: '请选择财务类型',
      filterByResourceType: '请输入资源类型'
    },
    // 日志
    log: {
      keyword: '关键字',
      // 应用
      application: {
        application: '应用',
        addLogAlarm: '添加日志报警规则',
        editLogAlarm: '编辑日志报警规则',
        instanceId: '实例ID',
        name: '名称',
        ip: 'IP',
        region: '区域'
      },
      // 安全
      security: {
        eventWriteType: '写类型',
        eventReadType: '读类型',
        eventAllType: '所有类型'
      },
      cloudTrail: {
        addCloudTrailAlertRule: '添加安全(CloudTrail)报警规则',
        updateCloudTrailAlertRule: '编辑安全(CloudTrail)报警规则',
        eventCheck: '事件检查'
      }
    },
    // 队列
    queue: {
      addQueue: '添加队列',
      queue: '队列',
      queueDescription: '队列描述',
      queueConfiguration: '队列配置',
      agentName: '代理名称',
      agentInstanceType: '代理实例类型',
      agentEngine: '代理引擎',
      configurationInformation: '配置信息',
      configurationName: '配置名称',
      name: '名称',
      brokerId: '代理ID',
      pleaseEnterBrokerId: "请输入代理ID",
      brokerEngine: '代理引擎',
      instanceType: '主机实例类型',
      region: '区域'
    },
    // 对象存储
    objectStorage: {
      objectStorage: '对象存储',
      objectStorageDescription: '对象存储描述',
      objectStorageConfiguration: '对象存储配置',
      configurationInformation: '配置信息',
      bucketName: '存储桶名',
      location: '地域',
      storageClass: '存储类型',
      accountName:"账户名称",
      name:"OSS名称",
      creationDateString:"创建时间",
      displayName:"创建人",
      extranetEndpoint:"外网域名",
      intranetEndpoint:"内网域名",
      displayId:"oss权限",
      access:"读写权限",
      defaultEncryption:"加密",
      region: '地区',
      objStoreName:'对象存储名称',
      pleaseEnterAccountName: "请输入账户名称",
      pleaseEnterObjStoreName: "请输入对象存储名称",
      // 折线图
      line:{
        StorageSizeBytes:'存储大小(字节)',
        StorageSize:'存储大小',
        GetAndPutRequestsNumberOfTimes:'Get、put类请求数(次数)',
        GetRequestClass:'get请求类',
        PutRequestClass:'put请求类',
        PublicNetworkOutgoingMeteredTrafficBytes:'公网流出计量流量(字节)',
        PublicNetworkOutgoingMeteredTraffic:'公网流出计量流量',
        CrossRegionReplicationOfIncomingMeteredTrafficBytes:'跨区域复制流入计量流量(字节)',
        CrossRegionReplicationOfInboundMeteringFlow:'跨区域复制流入计量流量',
        availabilityRequestValidRate:"可用性/有效请求率%",
        availability :"可用性" ,
        requestValidRate :"有效请求率",
        validRequestCountTotalRequestCount:"有效请求数/总请求数(count)",
        validRequestCount:"有效请求数",
        totalRequestCount:"总请求数",
        internetcdnsync:"流量(Byte)",
        internetSend:"公网流出流量",
        internetRecv:"公网流入流量",
        intranetSend:"内网流出流量",
        intranetRecv:"内网流入流量",
        cdnSend:"cdn流出流量",
        cdnRecv:"cdn流入流量",
        syncSend:"跨区域复制流出流量",
        syncRecv:"跨区域复制流入流量",
        // tiya
        requestCount:'请求次数',
        receivedBytesCount:'接受字节',
        sentBytesCount:'发送字节数',
        objectCount:'对象数',
        totalByteSeconds:'总字节秒数',
        totalBytes:'总字节数'
      }
    },
    // 合规检查
    complianceChecks: {
      rule: {
        ruleNameDuplicate: '规则名称不能重复!',
        account: '请选择账户名称',
        alarmDelay: '请选择延迟告警',
        monitorPeriod: '请选择监控时段',
        backupRegion: '请选择存储区域',
        configRuleNames: '请选择合规检查',
        ruleNameRequired: '规则名称不能为空',
        ruleNamePattern: '规则名称为2-20个字符首尾中间不能有空格',
        notificationObject: '请选择通知对象',
        noticeType: '请选择报警方式',
        monitorIndex: '请选择监控指标',
        cycle: '请选择周期',
        continousCycle: '请选择连续周期',
        statisticsValue: '请选择统计数值',
        relationshipSign: '请选择关系符号',
        thresholdValue: '请输入阈值',
        contactType: '请选择联系方式',
        contactGroupIds: '请选择联系人组',
        enterpriseWechatRobotIds: '请选择企业微信机器人URL',
      },
      addComplianceChecks: '添加合规检查报警规则',
      updateComplianceChecks: '编辑合规检查报警规则',
      compliance: '合规检查',
      Details:'详情',
      FilterbyResourceComplianceStatus:'请输入资源合规性状态',
      IgnoreConfirmation:'忽略确认',
      AreyouSureWantToIgnore:'你确认要忽略吗?',
      Ignore:'忽略',
      RestoreConfirmation:'恢复确认',
      AreYouSureWantToRestore:'你确认要恢复吗?',
      Restore:'恢复',
      NonCompliant:'不合规',
      Compliance:'合规',
      Account:'账号',
      Area:'区域',
      ResourceID:'资源ID',
      ResourceType:'资源类型',
      ResourceComplianceStatus:'资源合规性状态',
      RuleName:'规则名称',
      Description:'说明',
      Operating:'操作',
      AddWhitelist:'添加白名单',
      PleaseSelectAccount:'请选择账户名称',
      PleaseSelectRegion:'请选择区域',
      FilterbyComplianceRules:'请输入合规规则',
      ResourceName:'资源名称',
      SearchbyName:'请输入名称',
      AddWhitelistResources:'添加白名单资源',
      ComplianceRules:'合规规则',
      Overview:'概览',
      WhiteList:'白名单'
    },
    // 日志服务
    logService: {
      logService: '日志服务',
      logServiceDescription: '日志服务描述',
      logServiceConfiguration: '日志服务配置',
      projectName: '日志服务配置',
      logName: '日志名称',
      configurationInformation: '配置信息',
      logStoreName: '日志库名称',
      pleaseEnterLogStoreName: "请输入日志库名称",
      region: '地区',
      // 折线图
      line:{
        WriteTrafficByte:'写入流量(Byte)',
        WriteTraffic:'写入流量',
        ReadFlowByte:'读取流量(Byte)',
        ReadFlow:'读取流量',
        NumberOfOperationsCount:'操作次数(Count)',
        NumberOfOperations:'操作次数',
        OriginalDataSizeBytes:'原始数据大小(Bytes)',
        OriginalDataSize:'原始数据大小',
        ServiceStatusCount:'服务状态(Count)',
        ServiceStatus:'服务状态',
        FailedLines:"客户端解析失败行数",
        SumQps:"总体QPS",
        SuccessdByte:"客户端解析成功流量",
        InflowLine:"写入行数",
        ConsumerGroupFallBehind:"消费落后时长"
      }
    },
    // 网络
    network: {
      // CEN
      cen: {
        cen: 'CEN',
        cenDescription: 'CEN 描述',
        cenConfiguration: 'CEN 配置',
        configurationInformation: '配置信息',
        description: '描述',
        name: '名称',
        cenId: 'CEN ID',
        // 折线图
        line:{
          RegionalOutflowBandwidthPercentage:'区域流出带宽(%)',
          RegionalOutflowBandwidth:'区域流出带宽',
          GeographicalOutboundBandwidthPercentage:'地域流出带宽(%)',
          GeographicalOutflowBandwidth:'地域流出带宽',
          RegionalDelayms:'地域延时(ms)',
          RegionalDelay:'地域延时'
        }
      },
      // 负载均衡
      loadBalancing: {
        loadBalancing: '负载均衡',
        loadBalancingDescription: '负载均衡 描述',
        loadBalancingConfiguration: '配置',
        configurationInformation: '配置信息',
        instanceIp: '实例服务地址',
        region: '区域',
        name: '名称',
        loadbalancerId: '负载均衡 ID',
        ip: 'IP',
        DNSName: 'DNS名称',
        LBType: '负载均衡类型',
        status: '状态',
        vpcId: 'VPC ID',
        addLBAlarm: '添加负载均衡报警规则',
        editLBAlarm: '编辑负载均衡报警规则',
        // 折线图
        line:{
          NumberOfAbnormalBackEndECSInstancesCount:'后端异常ECS实例个数(count)',
          NumberOfAbnormalBackEndECSInstances:'后端异常ECS实例个数',
          TargetGroupHealthCheckStation:'目标群组健康状态检查(台)',
          InstancePacket:"数据包数(Count/s)",
          InstancePacketRX:'实例每秒入包数',
          InstancePacketTX:'实例每秒出包数',
          InstanceConnection:"并发连接数(Count/s)",
          InstanceActiveConnection:'实例每秒活跃连接数',
          InstanceInactiveConnection:'实例每秒非活跃连接数',
          InstanceMaxConnection:'实力每秒最大并发连接数',
          InstanceTrafficRTX:"流量(bits/s)",
          InstanceTrafficRX:"实例每秒入bit数",
          InstanceTrafficTX:"实例每秒出bit数",
          InstanceNewConnectionCount:"新建连接数(Count/s)",
          InstanceNewConnection:"实例每秒新建连接数",
          InstanceDropTrafficRTX:"丢弃流量(bits/s)",
          InstanceDropTrafficRX:"实例每秒丢失入bit数",
          InstanceDropTrafficTX:"实例每秒丢失出bit数",
          InstanceDropTrafficTXBits:"实例每秒丢失出bit数(bits/s)",
          InstanceDropTrafficRXBits:"实例每秒丢失入bit数(bits/s)",
          InstanceDropPacketRTX:"丢弃数据包数(Count/s)",
          InstanceDropPacketRX:"实例每秒丢失入包数",
          InstanceDropPacketTX:"实例每秒丢失出包数",
          InstanceDropPacketRXCount:"实例每秒丢失入包数(Count/s)",
          InstanceDropPacketTXCount:"实例每秒丢失出包数(Count/s)",
          InstanceDrops:"丢失数据数(Count/s)",
          InstanceDropConnection:"实例每秒丢失连接数",
          InstanceQpsCount:"七层实例QPS(Count/s)",
          InstanceQps:"七层实例QPS",
          InstanceQpsUtilizationPercent:"七层实例QPS使用率(%)",
          InstanceQpsUtilization:"七层实例QPS使用率",
          InstanceNewConnectionUtilizationPercent:"实例新建连接数使用率(%)",
          InstanceNewConnectionUtilization:"实例新建连接数使用率",
          InstanceMaxConnectionUtilizationPercent:"实例最大连接数使用率(%)",
          InstanceMaxConnectionUtilization:"实例最大连接数使用率",
          InstanceUpstreamRtMs:"七层协议实例UpstreamRT(ms)",
          InstanceUpstreamRt:"七层协议实例UpstreamRT",
          InstanceUpstreamCode:"七层协议实例Upstream状态码分布(Count/Second)",
          InstanceUpstreamCode4xx:"七层协议实例Upstream4XX状态码",
          InstanceUpstreamCode5xx:"七层协议实例Upstream5XX状态码",
          InstanceStatusCode:"七层协议实例状态码分布(Count/Second)",
          InstanceStatusCode2xx:"七层协议实例2XX状态码",
          InstanceStatusCode3xx:"七层协议实例3XX状态码",
          InstanceStatusCode4xx:"七层协议实例4XX状态码",
          InstanceStatusCode5xx:"七层协议实例5XX状态码",
          InstanceRtms:"七层协议实例RT(ms)",
          InstanceRt:"七层协议实例RT",
          BackendLatencies:"后端延迟",
          BackendRequestBytesCount:"后端请求字节",
          BackendRequestCount:"后端请求计数",
          BackendResponseBytesCount:"后端响应字节",
          InternalBackendLatencies:"内部负载均衡器后端延迟",
          InternalRequestCount:"内部负载均衡器请求计数",
          InternalRequestBytesCount:"请求字节",
          InternalResponseBytesCount:"内部负载均衡器响应字节",
          InternalTotalLatencies:"总延迟",
          RequestCount:"请求计数",
          ResponseBytesCount:"响应字节",
          TcpEgressBytesCount:"出口字节数",
          TcpEgressPacketsCount:"出口数据包计数",
          TcpIngressBytesCount:"入口字节数",
          TcpIngressPacketsCount:"入口数据包计数",
          TcpInternalEgressBytesCount:"内部负载均衡器出口字节数",
          TcpInternalEgressPacketsCount:"内部负载均衡器出口数据包数",
          TcpInternalIngressBytesCount:"内部负载均衡器出口字节数",
          TcpInternalIngressPacketsCount:"内部负载均衡器入口数据包数",
          TcpClosedConnections:"封闭链接",
          TcpNewConnections:"新链接已打开",
          UdpEgressBytesCount:"出口字节数",
          UdpEgressPacketsCount:"出口数据包计数",
          UdpIngressBytesCount:"入口字节数",
          UdpIngressPacketsCount:"入口数据包计数",
          UdpInternalEgressBytesCount:"内部负载均衡器出口字节数",
          UdpInternalEgressPacketsCount:"内部负载均衡器出口数据包数",
          UdpInternalIngressBytesCount:"内部负载均衡器出口字节数",
          UdpInternalIngressPacketsCount:"内部负载均衡器入口数据包数",
          UdpClosedConnections:"封闭链接",
          UdpNewConnections:"新链接已打开",
        }
      },

      AppGateway: {
        //应用程序网关
        title: "应用程序网关",
        addAppGatewayAlarm: "添加应用程序网关报警规则",
        editAppGatewayAlarm: '编辑应用程序网关报警规则',
        resourceGroup: "资源组",
        // 折线图
        line:{
          ThroughputByte:'吞吐量（Byte）',
          Throughput:'吞吐量',
          NumberOfConnectionsCount:'连接数（个）',
          NumberOfConnections:'连接数'
        }
      },
      AppService: {
        addAppServiceAlertRule: '添加应用程序服务报警规则',
        updateAppServiceAlertRule: '编辑应用程序服务报警规则',
        //应用程序服务
        title: "应用程序服务",
        add: "添加应用程序服务报警规则",
        name: "名称",
        status: "状态",
        appType: "应用类型",
        appPlan: "应用服务计划",
        resourceGroup: "资源组",
        location: "位置",
        subscription: "订阅",
        description: "应用程序服务描述",
        appConfig: "应用程序服务配置",
        subscriptionID: "订阅ID",
        subscriptionName: "订阅名称",
        appServiceInfo: "应用程序服务信息",
        time:"时间",
        // 折线图
        line:{
          CPUTimeseconds:'CPU Time（秒）',
          MemorySetbytes:'内存集（字节）',
          MemorySet:'内存集',
          ResponseTimeseconds:'响应时间（秒）',
          ResponseTime:'响应时间'
        }
      },
      //nat网关
      nat:{
        nat:"NAT网关",
        natList:"NAT网关列表",
        region:"区域",
        name:"网关名称",
        natGatewayId:"nat网关ID",
        state:"状态",
        publicIp:"公有IP",
        privateIp:"私有IP",
        vpcId:"VPC",
        createTime:"创建时间",
        natConfig:"nat网关配置",
        natInformation:"nat网关信息",
        line:{
          SessionActiveLimitDropConnectionCount:"并发连接数/并发丢弃连接速率(CountS)",
          SessionActiveConnectionCount:"并发连接数",
          SessionLimitDropConnectionCount:"并发丢弃连接速率",
          SessionNewLimitDropConnectionCount:"新建连接速率/新建丢弃连接速率(CountS)",
          SessionNewConnectionCountS:"新建连接速率",
          SessionNewLimitDropConnectionCountS:"新建丢弃连接速率",
          SessionActiveNewConnectionWaterLever:"并发连接水位/新建连接水位（%）",
          SessionActiveConnectionWaterLever:"并发连接水位",
          SessionNewConnectionWaterLever:"新建连接水位",
          BWRateInFromOutToInsideBps:"入方向流量速率(Bps)",
          BWRateInFromOutsideBps:"从公网来流量速率",
          BWRateOutToInsideBps:"入VPC流量速率",
          BytesInFromOutOutToInsideByte:"入方向流量(Byte)",
          BytesInFromOutsideByte:"从公网来流量",
          BytesOutToInsideByte:"入VPC流量",
          PPSRateInFromOutOutToInsideCount:"入方向包速率(CountS)",
          PPSRateInFromOutsideCount:"从公网来包速率",
          PPSRateOutToInsideCount:"入VPC包速率",
          PacketsInFromOutOutToInsideCount:"入方向包量(Count)",
          PacketsInFromOutsideCount:"从公网来包量",
          PacketsOutToInsideCount:"入VPC包量",
          BWRateInFromInOutToOutsideBps:"出方向流量速率(Bps)",
          BWRateInFromInsideBps:"从VPC来流量速率",
          BWRateOutToOutsideBps:"入公网流量速率",
          BytesInFromInOutToOutsideByte:"出方向流量(Byte)",
          BytesInFromInsideByte:"从VPC来流量",
          BytesOutToOutsideByte:"入公网流量",
          PPSRateInFromInOutToOutsideCountS:"出方向包速率(CountS)",
          PPSRateInFromInsideCountS:"从VPC来包速率",
          PPSRateOutToOutsideCountS:"入公网包速率",
          PacketsInFromInOutToOutsideCount:"出方向包量(Count)",
          PacketsInFromInsideCount:"从VPC来包量",
          PacketsOutToOutsideCount:"入公网包量"

        }
      }
    },
    //SLS
    sls:{
      sls:"SLS",
      slsList:"SLS列表",
    },
    //autoscaling
    autoscaling:{
      autoscaling:"弹性伸缩",
      autoscalingList:"弹性伸缩列表",
      accountIdString:"账号ID",
      accountName:"账号Name",
      scalingGroupId:"弹性伸缩组id",
      scalingGroupName:"弹性伸缩组name",
      groupType:"实例类型",
      vpcId:"VPC ID",
      totalInstanceCount:"ECS实例的数量",
      lifecycleState:"状态信息",
      minSize:"ECS实例台数的最小值",
      maxSize:"ECS实例台数的最大值",
      scalingPolicy:"指定伸缩组的回收模式",
      healthCheckType:"伸缩组的健康检查方式",
      autoscalingConfig:"弹性伸缩网关配置",
      autoscalingInformation:"弹性伸缩网关信息",
      line:{
        MaxInstanceCount:"最大实例数",
        MinInstanceCount:"最小实例数",
        PendingInstanceCount:"正在加入实例数",
        RemovingInstanceCount:"正在移除实例数",
        RunningInstanceCount:"运行实例数",
        TotalInstanceCount:"总实例数"
      }
    },
    WebApplicationFirewall:{
      WebApplicationFirewall:"Web应用防火墙",
      WebApplicationFirewallList:"Web应用防火墙列表",
      accountName:"账户名称",
      accountIdString:"账户ID",
      region:"区域",
      instanceId:"实例id",
      statusName:"是否过期",
      versionName:"版本",
      WebApplicationFirewallConfig:"Web应用防火墙配置",
      configurationInformation: '配置信息',
      InstanceId:"实例ID:",
      createdTime: '创建时间',
      line:{
        Qps:"QPS",
        QpsRatio:"QPS环比增长率",
        QpsRatioDown:"QPS环比下降率",
      }
    },
    // Redshift
    redshift: {
      addRedshiftAlarm: '添加数据仓库报警规则',
      editRedshiftAlarm: '编辑数据仓库报警规则',
      cluster: '集群',
      accountName: "账户名称",
      nodeType: '类型',
      nodeSize: '节点数',
      redshiftList: '数据仓库列表',
      redshiftName: "数仓名称",
    },
    // elasticSearch
    elasticSearch: {
      addEsAlarm: '添加ElasticSearch报警规则',
      editEsAlarm: '编辑ElasticSearch报警规则',
      esDomain: "ES域名",
      elasticSearchList: 'ElasticSearch列表',
      filterByEsDomainName: '请输入ES域名',
      clusterStatus:'集群状态',
      blockWriteRequest:'阻止写入请求',
      numberOfNodes:'节点数量',
      automaticSnapshotFailed:'自动快照失败',
      kMSKeyError:'KMS密钥错误',
      kMSKeyCannotBeAccessed:'KMS密钥无法访问',
      dataNodeCPUUsage:'数据节点CPU使用率',
      dataNodeJVMMemoryPressure:'数据节点JVM内存压力',
      cPUUsageOfTheMasterNode:'主节点CPU使用率',
      JVMMemoryPressureOnTheMasterNode:'主节点JVM内存压力',
      dataNodeRemainingStorageSpace:'数据节点剩余存储空间%',
      green:'绿色',
      yellow:'黄色',
      red:'红色'
    },
    // redis
    redis: {
      clusterName: '集群名称',
      cacheEngine: '缓存引擎',
      nodeType: '节点类型',
      addRedisAlarm: '添加Redis报警规则',
      editRedisAlarm: '编辑Redis报警规则',
      redisList: 'Redis列表',
      filterByCacheClusterId: '请输入节点名称',
      redisDescription:'Redis描述',
      redisConfig:'Redis配置',
      redisInfo:'Redis信息',
      cacheClusterId:'节点名称',
      currConnectionAmount:'当前连接数(数量)',
      currConnection:'当前连接数',
      bytesUsedForCacheByte:'缓存字节数(字节)',
      bytesUsedForCache:'缓存字节数'
    },
    // 云用户
    cloudUser: {
      detail: {
        cloudUserDesc: '云用户描述',
        cloudUserConfig: '云用户配置',
        cloudUserInfo: '云用户信息',
        name: '名称',
      },
      rule: {
        ruleNameDuplicate: '规则名称不能重复!',
        account: '请选择账户名称',
        alarmDelay: '请选择延迟告警',
        backupRegion: '请选择存储区域',
        ruleNameRequired: '规则名称不能为空',
        ruleNamePattern: '规则名称为2-20个字符首尾中间不能有空格',
        notificationObject: '请选择通知对象',
        noticeType: '请选择报警方式',
        monitorIndex: '请选择监控指标',
        cycle: '请选择周期',
        continousCycle: '请选择连续周期',
        statisticsValue: '请选择统计数值',
        relationshipSign: '请选择关系符号',
        thresholdValue: '请输入阈值',
        contactType: '请选择联系方式',
        contactGroupIds: '请选择联系人组',
        enterpriseWechatRobotIds: '请选择企业微信机器人URL',
      },
      title:"云用户",
      cloudUserList:"云用户列表",
      addCloudUserAlarm: '添加云用户报警规则',
      editCloudUserAlarm: '编辑云用户报警规则',
      cloudUserName: '云用户'
    },
    // 邮箱
    mailbox: {
      selectMailbox: '请选择邮箱',
      title:"邮箱",
      addMailBoxAlarm: '添加邮箱报警规则',
      editMailBoxAlarm: '编辑邮箱报警规则',
      monitoringMailBox: '监控邮箱'
    },
    // 网站健康状态
    websiteHealthStatus: {
      pleaseEnterHost: '请输入网站地址',
      pleaseEnterPort: '请输入端口',
      tcpConnectFail: '该网址TCP无法连接!',
      second: '秒',
      title:"网站健康状态",
      addWebsiteHealthStatusAlarm: '添加网站健康状态报警规则',
      editWebsiteHealthStatusAlarm: '编辑网站健康状态报警规则',
      host: '网站地址',
      port: '端口',
      timeout: '连接超时时间'
    },
    // 报警规则公用项
    common: {
      dynamicHeader:'动态表头',
      alertContact: '联系人',
      alertContactGroup: '联系人组',
      weChatTemplate: '微信模板',
      phoneTemplate: '电话模板',
      emailTemplate: '邮箱模板',
      monitoringTime: '监控时段',
      delayAlarm: '延迟告警',
      alarmType: '报警方式',
      pleaseSelect: '请选择',
      unit: '单位',
      threshold: '阈值',
      continuous: '连续周期',
      volatility: '波动率',
      checkCycle: '检测周期',
      tips: '由于利用率和覆盖率有延迟性，故检测时间是从当前时间向前推2天开始。举例：当前如果为：2023-11-20日，检测周期如为30天，则周期内的时间范围为：2023.10.18-2023.11.18',
      tooltips: '检测周期为近30天',
      cycle: '周期',
      sign: '符号',
      statisticsValue: '统计数值',
      ok: '确认',
      addAlarm: '添加告警',
      addWhitelist: '添加白名单',
      search: '查询',
      nextStep: '下一步',
      lastStep: '上一步',
      cancel: '取消',
      edit: '编辑',
      add: '添加',
      delete: '删除',
      details: '详情',
      deleteConfirmation: '删除确认',
      sureDelete: '你确认要删除',
      sureDeletes: '你确认要删除吗',
      sureRunImmediately:"你确定要立即运行",
      allWarningRules: '下所有相关的告警规则吗',
      createdTime: '创建时间',
      monitorMessage: '监控信息',
      monitorItems: '监控项',
      viewMonitoringOverview: '查看监控概览',
      viewForecastMonitoringOverview: '查看预测监控概况',
      alertRule: '报警规则',
      untreated: '未处理案例',
      viewAlarmRules: '查看报警规则 ',
      tags: '标签',
      count: '项',
      what: '吗',
      seriousProblems: '项严重问题',
      hostDescription: '主机描述',
      allRegion: '全部区域',
      monitoringSummary: '监控概览',
      refresh: '刷新',
      alertRuleName: '规则名称',
      status: '状态',
      monitorIndex: '监控指标',
      contact: '通知对象',
      scanType: '类型',
      delayType: '延迟类型',
      delayCountdown: '延迟倒计时(小时)',
      accountName: '账户名称',
      account: '账户',
      accountType: '账户类型',
      region: '存储区域',
      accountGroupName: '账户组名称',
      billingType: '财务类型',
      alertRuleDesc: '报警规则描述',
      resourceType: '资源类型',
      allResourceType: '所有资源类型',
      back: '返回',
      pleaseSelectCompany: '请选择公司',
      pleaseSelectRegions: '请选择区域',
      all: '全部',
      allSelected: '全选',
      filterByAlertRuleName: '请输入规则名称',
      filterByAccountType: '请选择账户类型',
      filterByAccountName: '请输入账户名称',
      filterByNatGatewayId:"请输入Nat网关ID",
      filterNatGatewayId: '请输入NAT网关ID',
      filterOssName:"请输入oss名称",
      filterByVpcName:"请输入vpc名称",
      filterByInstanceId: '请输入实例ID',
      filterByInstanceName: '请输入实例名称',
      filterByScalingGroupName:"请输入弹性伸缩名称",
      filterByLoggingstoredName:"请输入日志存储名称",
      filterByLoggingRouteName:"请输入日志路由名称",
      filterByProjectName:"请输入项目名称",
      filterByIpAddress: '请输入IP地址',
      filterByTagKey: '请输入标签KEY',
      filterByTableName: '请输入表名称',
      pleaseSelectAccount: '请选择账户名称',
      pleaseSelectStatus: '请选择状态',
      pleaseSelectCategory: '请选择类型',
      pleaseSelectDelayType: '请选择延迟类型',
      operationLog: '操作日志',
      pleaseInputValue: '请输入值',
      ruleName: '规则名称',
      monitoringMethod: '监控方法',
      ruleDescription: '规则描述',
      continuousCycle: '连续周期',
      statisticsCount: '统计次数',
      symbol: '符号',
      minimum: '最小值',
      max: '最大值',
      logGroupName: '日志组名称',
      contactType: '联系方式',
      notificationObject: '通知对象',
      contactPerson: '联系人',
      contactGroup: '联系人组',
      noticeType: '报警方式',
      alarmDelay: '延迟告警',
      monitorPeriod: '监控时段',
      emailModal: '邮箱模板',
      wechatModal: '微信模板',
      phoneModal: '微信模板',
      approvalFlow: '审批流',
      cloudPlatform: '云平台',
      standardValue: '标准值',
      routineMonitoring: '常规监控',
      intervalMonitoring: '区间监控',
      warning:'警告提示',
      wechatTip:'目前没有微信联系人，请取消微信通知渠道并继续！',
      phoneTip:'目前没有电话联系人，请取消电话通知渠道并继续！',
      enable: '启用',
      disable: '禁用',
      manual: '手动',
      automatic: '自动',
      aiIntervention: 'AI是否接管',
      aiInterventionYes: '是',
      aiInterventionNo: '否',
      sopType: 'SOP类型',
      sopTypeDefault: '默认',
      sopTypeCustom: '自定义',
      setSop: '设置SOP',
      configSopTitle: '配置告警规则SOP',
      enableEmailNotice: '启用邮件通知',
      switchToDefaultConfirm: '切换后将删除自定义SOP，恢复使用默认SOP，是否继续？',
      sopStepList: 'SOP步骤',
      addSopStep: '添加步骤',
      stepPlaceholder: '请输入步骤内容',
      sopEmailTemplate: '邮件模板',
      pleaseSelectAi: '请选择AI是否接管',
      pleaseSelectSopType: '请选择SOP类型',
      fiveMinutes:'5分钟',
      fifteenMinutes:'15分钟',
      oneHour:'1小时',
      sixHour:'6小时',
      oneDay:'一天',
      Empty:'清空',
      SelectionPeriod:'选择时间',
      close:'关闭',
      enterpriseWeChatRobotURL:'企业微信机器人URL',
      publicIp:"弹性IP",
      resourceSyncLog: "资源同步记录"
    },
    // 存储网关
    storagegateway: {
      storagegateway:'存储网关',
      storagegatewayList:'存储网关列表',
      addAlertRule:'添加存储网关告警规则',
      filterByStorageGatewayName:'请输入存储网关名称',
      storageGatewayName:'存储网关名称',
      addStorageGatewayAlarm:'添加存储网关告警',
      storageGatewayDetail:'存储网关详情' ,
      storageGatewayConfig:'存储网关配置',
      storageGatewayInfo:'存储网关信息',
      editStorageGatewayAlarm: '编辑存储网关告警规则'
    },
    //备份计划
    backPlan:{
      detail: {
        nameLabel: '名称：',
      },
      backPlan:"备份计划",
      addBackPlanAlarm:"添加备份计划报警规则",
      backPlanList:"备份计划列表",
      accountTypeName:"账户类型",
      accountName:"账户名称",
      backupPlanId:"备份计划id",
      backupPlanName:"备份计划名称",
      creationDate:"创建日期",
      region:"区域",
      addBackupPlanAlarm:"添加备份计划报警规则",
      editBackupPlanAlarm:"添加备份计划报警规则",
    },






    export: {
      instanceUsageStatistics: '实例使用统计情况.xls',
      databaseUsage: '数据库使用情况.xls',
      databaseUsageStatistics: '数据库使用统计情况.xls'
    },
  },
  // 实例列表
  instance_list: {
    swireInstanceList: '太古实例列表',
    environment: '环境',
    instanceName: '实例名称',
    usageDetail: '使用细节',
    availableZone: '可用区',
    privateIP: '私有IP',
    CPUNumber: 'CPU数量',
    mem: '内存(GB)',
    disk: '磁盘(GB)',
    project: '项目',
    business: '业务',
    owner1: '拥有者1',
    owner2: '拥有者2',
    os: '操作系统',
    env: 'Env',
    billingType: 'Billing Type',
    selectByEnvironment: '请输入环境',
    selectByDate: '请选择日期'
  },
  // 规则引擎
  rule_engine: {
    title: '规则引擎',
    alertRule: '报警规则',
    instance: '实例',
    database: '数据库',
    storage: '存储',
    name: '名称',
    instanceId: '实例ID',
    deviceName: '设备名',
    volumeId: '卷ID',
    capacity: '容量',
    readSpeed: '读取速度',
    area: '地区',
    region: '区域',
    privateIP: '私有IP',
    databaseId: '数据库ID',
    dbEngine: 'DB引擎',
    instanceType: '实例类型'
  },
  // 报警联系人
  alarm_contact: {
    allType: '全部类型',
    contact: '联系人',
    contactGroup: '联系人组',
    selectByCompany: '请选择公司',
    selectByName: '请输入用户姓名',
    alarmContact: '报警联系人',
    alarmContactSearchKeyPlaceholder: '请输入姓名',
    addAlarmContact: '添加联系人',
    companyName: '公司名称',
    name: '用户',
    dept: '部门',
    position: '职务',
    monitorModule: '监控模块',
    phone:'电话',
    email: '邮箱',
    wechat: '企业微信',
    defaultContact: '默认联系人',
    alarmContactReplacement: '报警联系人替换',
    del: "删除",
    addContact: "添加联系人组",
    contactGroupName: "联系人组名称",
    selectByContactGroupName: "请输入联系人组名称",
    default: "是否默认",
    description: "描述",
    contactGroupConfig: "配置",
    operationLog: "操作日志",
    replace: "替换",
    replaceTip: "将当前联系人的报警规则，替换到新的联系人下!",
    bindingStatus: "绑定状态",
    personalWeChat: "个人微信",
    yes: "是",
    no: "否",
    unBind: "解除绑定",
    isBinding:'已绑定',
    editContact: "编辑报警联系人",
    contactConfiguration: "联系人配置",
    enterpriseWechatRobot: "企业微信机器人",
    searchByRobotName: "请输入机器人名称",
    add: "添加",
    edit: "编辑",
    robotName: "机器人名称",
    phonePlaceholder: "请输入电话",
    nameRequired: "请输入姓名",
    selectMonitorModule: "请选择监控模块",
    selectDefaultContact: "请选择默认联系人",
    selectUser: "请选择用户",
    unbindSuccess: "解绑成功",
    contactGroupNameRequired: "请输入联系人组名称",
    selectDefaultContactGroup: "请选择默认联系人组",
    robotNameRequired: "请输入机器人名称",
    robotUrlRequired: "请输入企业微信机器人URL"
  },
  // easy_cron 表达式配置组件
  easy_cron: {
    config: "配置",
    validator: {
      empty: "cron表达式不能为空",
      tooManyItems: "cron表达式最多7项",
      yearError: "cron表达式参数[年]错误:{year}",
      parseError: "cron表达式错误:{error}"
    },
    configCronExpression: "配置Cron表达式",
    executionTime: "执行时间",
    selectExecutionStartTime: "选择执行开始时间",
    executionPreviewTooltip: "执行预览解析不含年参数",
    executionPreview: "执行预览",
    previewIgnoreYear: "执行预览，会忽略年份参数",
    noExecutionTime: "无执行时间",
    expression: "表达式",
    expressionNoYear: "表达式(不含年)",
    unit: {
      second: "秒",
      minute: "分",
      hour: "时",
      day: "日",
      month: "月",
      week: "周",
      year: "年",
      dayLoop: "天"
    },
    type: {
      everySecond: "每秒",
      everyMinute: "每分",
      everyHour: "每时",
      everyDay: "每日",
      everyMonth: "每月",
      everyYear: "每年",
      range: "区间",
      loop: "循环",
      specify: "指定",
      notSet: "不设置",
      workDay: "工作日",
      lastDay: "最后一日"
    },
    from: "从",
    to: "至",
    loopStart: "开始，间隔",
    dayWeekTip: "日和周只能设置其中之一",
    thisMonth: "本月",
    recentWorkDay: "日，最近的工作日",
    week: {
      sun: "周日",
      mon: "周一",
      tue: "周二",
      wed: "周三",
      thu: "周四",
      fri: "周五",
      sat: "周六"
    }
  },
  // 定时开关机
  schedule_instance_config: {
    start:'启动',
    pause:'暂停',
    close:'关闭',
    exception:'例外',
    ip: 'IP',
    instanceName: '实例名称',
    AWSType: "AWS资源类型",
    instanceUsage: '实例用途',
    instanceStatus: '实例状态',
    isWorkDay: '是否工作日',
    scheduleOpenInstanceTime: '开机时间',
    scheduleCloseInstanceTime: '关机时间',
    isException: '是否例外',
    exceptionStartDate: '例外开始日期',
    exceptionEndDate: '例外结束日期',
    exceptionStartTime: '例外开机时间',
    exceptionEndTime: '例外关机时间',
    hasScheduledTask: '有定时任务',
    timeSwitch: '定时开关机',
    search: '查询',
    timeSwitchTask: '定时开关机任务',
    selectByCompany: '请选择公司',
    selectByIp: '请输入IP',
    add: '添加',
    addSystemTask: '添加定时任务',
    editSystemTask: '编辑定时任务',
    status: '状态',
    approvalFlow: '审批流',
    instance: '实例',
    reason: '申请原因',
    yes: '是',
    no: '否',
    workDay: '工作日',
    everyDay: '每天',
    virtualHost: '虚拟主机',
    virtualDesktop: '虚拟桌面',
    del: '删除',
    performType:'执行类型',
    existingTaskReminder: '已存在定时开关机任务提醒',
    existingTaskConfirm: '已存在定时开关机任务,继续创建新的定时开关机任务吗?',
    continue: '继续',
    viewLog: '查看日志',
    log: '日志',
    time: '时间',
    openRequired: '开机必填!',
    closeRequired: '关机必填!',
    exceptionOpenRequired: '例外开机必填!',
    exceptionCloseRequired: '例外关机必填!',
    selectStatus: '请选择状态',
    selectPerformType: '请选择执行类型',
    selectOpenTime: '请选择开机时间',
    selectCloseTime: '请选择关机时间',
    selectExceptionOpenTime: '请选择例外开机时间',
    selectExceptionCloseTime: '请选择例外关机时间',
    selectExceptionStartDate: '请选择例外开始日期',
    selectApprovalFlow: '请选择审批流',
    selectExceptionEndDate: '请选择例外结束日期',
    selectIsException: '请选择是否例外',
    selectIsWorkDay: '请选择是否工作日',
    inputReason: '请输入申请原因',
    maxChars100: '最多输入100个字符',
    thisScheduledTask: '该定时任务'
  },
  audit_task: {
    auditTask: '审核任务',
    ip: 'IP',
    operator: '操作员',
    auditor: '审核员',
    auditStatus: '审核状态',
    operationType: '操作类型',
    createdTime: '创建时间',
    denialReason: '驳回原因',
  },
  configuration_management: {
    securityLog: {
      title: "安全日志配置",
      retentionTime: "安全日志保留时间",
      readAndAgree: "阅读并同意",
      disclaimerClause: "《免责条款》",
      disclaimerTitle: "免责条款",
      cloudtrailAdvantage: "1.Cloudtrail优势",
      advantageDesc: "AWS CloudTrail 是一项服务，支持对贵公司 AWS 账户进行监管、合规性检查、操作审核和风险审核。借助 CloudTrail，贵公司可以记录日志、持续监控并保留与整个 AWS 基础设施中的 API 调用相关的事件。CloudTrail 可提供贵公司账户的 AWS API 调用历史记录，包括通过 AWS 管理控制台、AWS 开发工具包、命令行工具和其他 AWS 服务执行的 API 调用。此历史记录可简化安全性分析、资源更改跟踪和故障排除。",
      advantageIntro: "作为一项AWS重要的安全管理工具。Cloudtrail具有很多自身的优势：",
      simplifiedCompliance: "简化的合规性",
      visibility: "用户与资源活动的可见性",
      securityAnalysis: "安全性分析和故障排除",
      securityAutomation: "安全自动化",
      slPolicy: "2.Silver Lining 的Cloudtrail政策",
      slPolicyDesc: "对于进入Silver Lining运维流程的客户，我们的工程师会在第一时间联系客户，对客户账户和资源进行初始化审查和安全配置操作，包括御云者账户的绑定、安全审查，TAG规范等。作为初始化的重要部分，Cloudtrail是我们要求客户要打开的功能。对于不愿意开启Cloudtrail功能的客户，我们会提供相关的免责条款，详细请参考第三部分《免责条款》",
      disclaimerSection: "3.免责条款",
      disclaimerIntro: "为更好的管理贵公司的AWS账户及其资源，保障安全性，Silver Lining建议贵公司开启AWS Cloudtrail功能。如果贵公司自主放弃使用此功能，表示贵公司明白且同意签署以下免责条款协议（以下简称“本协议”），请贵公司务必仔细阅读并遵守。",
      scopeTitle: "一、【本协议的范围】",
      scope11: "1.1【本协议适用主体范围】",
      scope11Desc: "本协议是贵公司与Silver Lining之间，关于贵公司拒绝开启CloudTrail功能所订立的协议。",
      aboutTitle: "二、【关于本协议】",
      about21: "2.1【本协议目的】",
      about21Desc: "本协议目的是明确由于贵公司拒绝开启CloudTrail功能服务，因此Silver Lining运维服务内容将不包括Cloudtrail及其相关功能，贵公司也不会因此向Silver Lining 究责。",
      about22: "2.2【本协议内容】",
      about22Desc: "签署本协议，表示贵公司完全了解拒绝开启CloudTrail服务可能对贵公司AWS账户管理及其安全审计所造成的影响（包括但不限于）：",
      impact1: "1.无法对整个AWS账户已执行操作的活动日志进行记录和存储；",
      impact2: "2.无法记录 AWS API 调用信息，包括 AWS 的用户和账户、发起调用的源 IP 地址以及执行调用的时间；",
      impact3: "3.捕捉特定时段内贵公司的 AWS 账户中所发生更改的全面历史记录，发现并解决安全性和操作性问题；",
      impact4: "4.无法跟踪并自动应对威胁 AWS 资源安全性的 API 活动。",
      about23: "2.3 【本协议范围】",
      about23Desc: "与Cloudtrail相关问题或者需要借助Cloudtrail服务来解决的问题。",
      effectTitle: "三、【本协议效力】",
      effect31: "3.1签署本协议，表示贵公司自主放弃使用AWS Cloudtrail服务；",
      effect32: "3.2若贵公司在后期使用AWS过程中，遇到Cloudtrail相关问题或者需要借助Cloudtrail服务来解决的问题，则不在Silver Lining支持的范围内。",
      effect33: "3.3由于拒绝开启Cloudtrail所造成的相关安全以及审计问题，将由贵公司自行承担，Silver Lining将不承担任何责任。",
      otherTitle: "四、【其他】",
      other41: "4.1本协议签订地为中华人民共和国上海市。",
      other42: "4.2本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。",
      other43: "4.3若贵公司和Silver Lining之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。",
      other44: "4.4本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。",
      other45: "4.5若本协议有中文、英文等多个语言版本，相应内容不一致的，均以中文版的内容为准。",
      configure: "配置",
      oneMonth: "一个月",
      twoMonths: "二个月",
      threeMonths: "三个月",
      pleaseSelectRetentionTime: "请选择安全日志保留时间",
      configureSuccess: "配置成功",
    },
    exceptionResource: {
      addLoadBalancing: "添加负载均衡",
    },
    // 邮箱配置管理
    mailbox_management: {
      emailNameRequired: "邮箱名称不能为空",
      portRequired: "端口不能为空",
      hostRequired: "主机地址不能为空",
      userNameRequired: "用户名不能为空",
      passwordRequired: "密码不能为空",
      pleaseEnterDescribe: "请输入描述",
      subjectKeywordRequired: "邮件主题关键词不能为空",
      keywordRequired: "关键词不能为空",
      email: "邮件",
      monitorMailboxConfiguration: "监控邮箱配置",
      processEmails: "待处理邮件主题",
      emailSubject: '邮件主题',
      addEmail: '添加邮箱',
      editEmail: '编辑邮箱',
      addEmailSubjectKeyword: '添加邮件主题关键词',
      editEmailSubjectKeyword: '编辑邮件主题关键词',
      emailSubjectKeyword: '邮件主题关键词',
      company: '公司',
      emailName: '邮箱名称',
      host: '主机地址',
      port: '端口',
      userName: '用户名',
      password: '密码',
      describe: '描述',
      queryByKeyWord: '请输入关键词',
    },
    // 预留实例购买
    reserved_instance_purchase : {
      title: '预留实例购买配置',
      riFamily: "实例家族",
      size: "实例大小",
    },
    // schedules
    schedules: {
      nameRequired: "名称不能为空",
      namePattern: "名称为8-20个字符",
      frequencyNumRequired: "请选择重复频率数值",
      frequencyUnitRequired: "请选择重复频率单位",
      atLeastOne: "至少选择一项",
      atMostSeven: "至多选择七项",
      pleaseEnterDescribe: "请输入描述",
      title: "调度管理",
      addSchedule: "添加日程",
      editSchedule: "编辑日程",
      name: "名称",
      repetition: "重复",
      start: "开始时间",
      frequency: "调度",
      enableWeekdays: "周天",
      end: "结束时间",
      startFor: "启用于",
      describe: "描述",
      minute: "分钟",
      hour: "小时",
      day: "天",
      week: "周",
      month: "月",
      Monday: "星期一",
      Tuesday: "星期二",
      Wednesday: "星期三",
      Thursday: "星期四",
      Friday: "星期五",
      Saturday: "星期六",
      Sunday: "星期天",
      queryByName: "请输入名称",
    },
    // System Task
    system_task: {
      editSystemTask: "编辑定时任务",
      status: "状态",
      pleaseEnterBeanName: "请输入bean名称",
      beanNamePattern: "bean名称为1-20个字符、不包含特殊字符",
      pleaseEnterMethodName: "请输入方法名称",
      methodNamePattern: "方法名称为1-20个字符、不包含特殊字符",
      pleaseEnterMethodParameter: "请输入方法参数",
      pleaseSelectStatus: "请选择状态",
      pleaseEnterNote: "请输入备注",
      searchByBeanName: "按bean名称查询",
      addSystemTask: '添加定时任务',
      configureSystemTask: '定时任务配置',
      taskID: '任务ID',
      beanName: 'bean名称',
      methodName: '方法名称',
      methodParameter: '方法参数',
      cronExpressioin: 'cron表达式',
      note: '备注',
      ok: '正常',
      paused: '暂停',
    },
    // Customized Alarm Config
    customized_alarm_config: {
      exporting: "正在导出，请稍等...",
      exportSuccess: "导出成功",
      customizedAlarmConfig: '客户自定义报警配置',
      listOfAlarmRules: '报警规则一览表',
      version: '版本号',
      isAutoDelayEnroll: '注册自动延迟',
      addVolume: "添加磁盘",
      checkAll: "全选",
      checkTheListOfAlarmRules: "查看报警规则一览表",
      setUpAUniversalAIAlarmHandlingProcess: '设置通用AI报警处理流程',
      defaultApprovalFlow: '默认审批流',
      alarmValidityPeriod: '报警有效期(分钟)',
      alarmValidityPeriodSecond: '报警有效期(秒)',
      noticeType: '通知方式',
      exceptionResources: "例外资源",
      AIMonitoringAlarm: 'AI监控报警',
      AIMonitorsTheAlarmStatus: 'AI监控报警状态',
      editAIAlarmProcess: '编辑AI报警流程',
      whetherToEnableEmailNotifications: '是否启用邮件通知',
      editGeneralAIAlarmProcess: '编辑通用AI报警流程',
      pleaseEnterTheProcessContent: '请输入流程内容',
      identification: '识别',
      pleaseConfigureTheNotificationTemplate: '请配置通知模板',
      configureSeparateAIAlarmProcess: '配置单独AI报警流程',
      recipient: '收件人',
      subjectSuffix: '邮件主题后缀',
      subjectMode: '主题模式',
      subjectModeSuffix: '追加后缀',
      subjectModeReplace: '整体替换',
      subject: '邮件主题',
      usingResources:'使用资源',
      alertRuleDesc:'具体内容',
      delayName:'延迟类型',
      alarmDelayCountdown:'延迟倒计时',
      processSteps:'流程步骤',
      addStep:'添加步骤',
      atLeastOneStep:'至少保留一个步骤',
      selectCloudPlatform:'请选择云平台',
      selectCloudPlatformAndMonitorModule:'请先选择云平台和监控模块',
      query:'查询',
      setUniversalSOP:'设置通用SOP',
      steps:'个步骤',
      emailNotification:'邮件通知',
      universalAIAlarmProcess:'通用智能告警处理流程',
      editAIAlarmProcessBtn:'编辑AI报警流程',
      noStepsTip:'暂无步骤，请点击"编辑AI报警流程"添加',
      selectPriorityTip:'请从左侧选择一个优先级',
      processStepList:'流程步骤列表',
      maxSteps:'最多 15 条',
      pleaseEnterStepContent:'请输入步骤内容',
      modifySuccess:'修改成功',
      confirmSuccess:'确认成功',
      stepsCannotBeEmpty:'步骤信息不能为空',
      pleaseFillAllSteps:'请填写所有步骤的内容',
      submitSuccess:'提交成功',
      validationRule:'验证规则',
      thresholdRangeForAutoRI:'当监控指标为自动购买预留实例时,阈值的范围是2-60',
      maxSixThresholds:'最多选择6个阈值',
      editSuccess:'编辑成功',
      subjectSuffix:'邮件主题后缀'
    },
    // Default Alarm Config
    default_alarm_config: {
      firstThresholdGreaterThan7: "第一个阈值必需要大于7",
      singleAccount: "单账户",
      accountGroup: "账户组",
      pleaseSelectEnroll: "请选择是否需要Enroll",
      pleaseSelectApprovalFlow: "请选择审批流",
      pleaseSelectAlarmWay: "请选择报警方式",
      pleaseSelectEventCheck: "请选择事件检查",
      pleaseSelectMonitorIndex: "请选择监控指标",
      pleaseSelectCycle: "请选择周期",
      pleaseSelectContinousCycle: "请选择连续周期",
      pleaseSelectStatisticsValue: "请选择统计数值",
      pleaseSelectStatisticsCount: "请选择统计次数",
      pleaseSelectRelationshipSign: "请选择关系符号",
      pleaseSelectCloudPlatform: "请选择云平台",
      pleaseSelectMonitorPeriod: "请选择监控时间段",
      pleaseSelectAutoDelayEnroll: "请选择是否注册自动延迟",
      pleaseSelectType: "请选择类型",
      defaultAlarmConfig: '默认报警配置',
      addDefaultAlarmConfig: '添加默认报警配置',
      editDefaultAlarmConfig: '添加默认报警配置',
      addAlarm: '添加报警',
      cloudPlatform: '云平台',
    },
    //配置管理通用
    common: {
      max100Characters: "最多输入100个字符",
      pleaseEnterThreshold: "请输入阈值",
      pleaseSelectPriority: "请选择优先级",
      pleaseSelectResourceType: "请选择资源类型",
      pleaseSelectThreshold: "请选择阈值",
      all: '全部',
      cloudType: '全部类型',
      sequenceId: '序号',
      accountType: '账户类型',
      cycle: '周期',
      continuous: '连续周期',
      statisticsValue: '统计数值',
      statisticsCount: '统计次数',
      resourceType: '资源类型',
      sign: '符号',
      threshold: '阈值',
      unit: '单位',
      priority: '优先级',
      standardValues: '标准值',
      type: "类别",
      ruleDescription: "规则描述",
      monitorModule: '监控模块',
      logGroupName: '日志组名称',
      monitorPeriod: '监控时间段',
      alarmWayList: '报警方式',
      isAutoDelayEnrollTypeList: '是否注册自动延迟',
      pleaseSelectCompany: '请选择公司',
      operationLog: '操作日志',
      deleteButton: '删除',
      pleaseSelectStartTime: '请选择开始时间',
      pleaseSelectEndTime: '请选择结束时间',
      selectButton: '查询',
      changeField: '变更字段',
      originalValue: '原值',
      newValue: '新值',
      operator: '操作人',
      operatingTime: '操作时间',
      pleaseSelect: '请选择',
      save: "保存",
    }
  },
  // Task Scheduler
  task_scheduler: {
    title: '任务调度中心',
    allTasks: '全部任务',
    pending: '待执行',
    executing: '执行中',
    completed: '已完成',
    failed: '执行失败',
    canceled: '已取消',
    searchPlaceholder: '任务编号 / 工单编号',
    customer: '客户',
    account: '账号',
    taskStatus: '任务状态',
    plannedTime: '计划执行时间',
    search: '查询',
    viewDetail: '查看详情',
    cancel: '取消',
    taskNumber: '任务编号',
    taskName: '任务名称',
    accountGroup: '账号组：',
    accountPrefix: '账号：',
    relatedTicket: '关联工单',
    operation: '操作',
    cancelTask: '取消任务',
    cancelConfirm: '确定要取消该任务吗？取消后任务将不再继续执行。',
    cancelFailed: '取消失败',
    back: '返回',
    basicInfo: '基础信息',
    createdTime: '创建时间',
    remark: '备注',
  },
  // AI 可用性面板
  ai_availability: {
    title: 'AI 可用性面板',
    lastRefreshTime: '最近刷新时间',
    refreshNow: '刷新',
    loadFailed: '数据加载失败',
    // 健康状态
    healthTitle: 'AgentVerse 健康状态',
    healthSubtitle: '页面每 15 秒自动刷新',
    online: '在线',
    slow: '响应慢',
    offline: '离线',
    unknown: '未知',
    responseDelay: '响应延迟',
    consecutiveFailures: '连续失败',
    timesUnit: ' 次',
    recentProbes: '近 10 次探活',
    probeTime: '探活时间',
    probeStatus: '状态',
    probeDelay: '响应耗时',
    probeSuccess: '成功',
    probeSlow: '响应慢',
    probeFail: '失败',
    // 今日核心指标
    todayAlertTotal: '今日告警总数',
    todayAlertTotalDesc: '进入 AI 处理链路',
    aiProcessedCount: 'AI 已处理数',
    aiProcessedCountDesc: '已完成 / SOP 已完成',
    todayTimeoutNotifyCount: '今日超时通知工单',
    todayTimeoutNotifyCountDesc: '按工单统计，不按拨打次数',
    currentFaultCount: '当前故障工单',
    currentFaultCountDesc: '不含人工介入状态',
    // 搜索区
    companyPlaceholder: '请输入公司',
    ticketPlaceholder: '请输入案例 ID',
    priorityPlaceholder: '请选择优先级',
    alarmTimePlaceholder: '请选择告警时间',
    searchBtn: '查询',
    resetBtn: '重置',
    // 当前故障工单列表
    faultListTitle: '当前故障工单',
    ticketNumber: '工单号',
    customerName: '客户名称',
    priority: '优先级',
    faultType: '故障类型',
    stuckDuration: '卡住时长',
    currentStatus: '当前状态',
    faultNotify: '故障通知',
    notified: '已触发',
    alarmTime: '告警时间',
    operation: '操作',
    ticketDetail: '工单详情',
    responseTimeout: '响应超时',
    processTimeout: '处理超时',
    // 工单状态文案
    statusManualNotify: '人工通知',
    statusManualIntervene: '人工介入',
    // 时长单位
    dayUnit: '天',
    hourUnit: '小时',
    minuteUnit: '分钟',
  },
  permission_configuration_management: {
    resourcePermission: {
      resource: "资源",
      nodeName: "节点名称",
      clusterName: "集群名称",
      cacheEngine: "缓存引擎",
      nodeType: "节点类型",
      pleaseSelectResource: "请选择资源",
      pleaseSelectAccountName: "请选择账户名称",
      pleaseSelectStorageRegion: "请选择存储区域",
      pleaseSelectCloudPlatform: "请选择云平台",
      pleaseSelectDatabaseEngine: "请选择数据库引擎",
      pleaseSelectRegion: "请选择区域",
      accountRequired: "账户为必填项",
      regionRequired: "区域为必填项",
      searchByStorageGatewayId: "按存储网关ID查询",
      searchByCacheClusterId: "按缓存集群ID查询",
      addRedis: "添加Redis",
      searchByDatabaseIdentifier: "按数据标识符查询",
      searchByBucketName: "按存储桶名称查询",
      addBucket: "添加存储桶",
      searchByLogstoreName: "按日志库名称查询",
      addSls: "添加sls",
      searchByLoadBalancerId: "按负载均衡ID查询",
      addElasticLoadBalancer: "添加弹性负载均衡",
      searchByNatGatewayId: "按NAT网关ID查询",
      addNatGateway: "添加Nat网关",
      gatewayName: "网关名称",
      natGatewayId: "NAT网关ID",
      elasticIpAddress: "弹性IP地址",
      privateIpAddress: "私有IP地址",
      networkInterfaceId: "网络接口ID",
      subnet: "子网",
      createTime: "创建时间",
      searchByClusterName: "按集群名称查询",
      addRedshift: "添加Redshift",
      searchByDomainName: "按域名称查询",
      addElasticsearch: "添加Elasticsearch",
      searchByBackupPlanId: "按备份计划ID查询",
      addBackup: "添加BackUp",
      addBackupPlan: "添加备份计划",
      addFirewall: "添加Firewall",
      addCen: "添加CEN",
      searchByElasticIp: "按弹性IP查询",
      addElasticIp: "添加ElasticIp",
      searchByAutoscalingGroupId: "按弹性伸缩组ID查询",
      addAutoscaling: "添加Autoscaling",
    },
    //权限模块通用
    common:{
      all: '全部',
      pleaseInput:'请输入',
      pleaseSelect:'请选择',
      edit:'编辑',
      enable: '启用',
      disable: '禁用',
      cancel:'取消',
      confirm:'确定',
      delete:'删除',
      operationLog: '操作日志',
      pleaseSelectCompany:'请选择公司',
    },
    // 策略一览
    permission:{
      owned: "拥有",
      notOwned: "没有",
      missingPolicy: "缺失策略",
      permissionOverviewFileName: "策略一览.xls",
      permissionOverview:'策略一览',
      permissions:'策略',
      authorized:'是否授权',
      templateName:'策略类型'
    },
    // 账号管理
    account: {
      confirmDeleteAssociatedData: "下关联的所有数据吗?",
      accessKeyIdSecretInvalid: "输入accessKeyId和secretAccessKey有误或权限不够!",
      accountNameRequired: "账户名不能为空",
      accountNameLength: "账户名为2-20个字符",
      pleaseSelectAuthType: "请选择认证方式",
      pleaseSelectAccountType: "请选择账户类型",
      pleaseSelectRegion: "请选择区域",
      pleaseInputProjectId: "请输入Project ID",
      accessKeyIdRequired: "访问密钥ID不能为空",
      secretAccessKeyRequired: "访问密钥KEY不能为空",
      roleSessionNameRequired: "访问角色会话名称不能为空",
      max100NonChinese: "最多输入100个字符并且非中文",
      roleArnRequired: "访问角色ARN不能为空",
      externalIdRequired: "访问外部ID不能为空",
      subscriptionIdRequired: "订阅ID不能为空",
      pleaseInputAccountId: "请输入账户ID",
      accountIdLength: "账户ID为4-70个字符",
      atLeastOne: "至少选择一项",
      pleaseSelectScanResource: "请选择扫描资源",
      pleaseUploadAttachment: "请上传附件",
      onlyOneAttachment: "有且仅有一个附件",
      pleaseInputLabelScanInterval: "请输入标签扫描间隔",
      pleaseSelectMonitorModule: "请选择监控模块",
      pleaseSelectContactType: "请选择联系方式",
      pleaseSelectContactGroup: "请选择联系人组",
      scanSuccess: "扫描成功",
      cancel:'取消',
      confirm:'确定',
      delete:'删除',
      elk:'ELK',
      protogenesis:'原生',
      overseas:'海外',
      china:'中国',
      all:'全部',
      pleaseSelectCompany:'请选择公司',
      checkByAccountName:'请输入账户名',
      subscriptionId: '订阅ID',
      subscriptionName: '订阅名称',
      accessKeyID: '访问密钥ID',
      secretAccessKey: '访问密钥Key',
      roleSessionName: '角色会话名称',
      roleArn: '角色ARN',
      externalId: '外部ID',
      scanResources: '扫描资源',
      account: '账户',
      company: '公司',
      addAccount: '添加账户',
      editAccount: '编辑账户',
      searchNewResource: '新资源发现',
      accountName: '账户名',
      scanResource: '扫描资源',
      accountType: '账户类型',
      accountId: '账户ID',
      area: '地区',
      region: '区域',
      authType: '认证方式',
      dataSource: '数据源',
      accountRegister: '账号注册',
      labelScanInterval: '标签扫描间隔',
      contactType: '联系方式',
      contact: '联系人',
      contactGroup: '联系人组',
      isCoverDefault: '扫描已存在自定义告警的资源',
      immediatelyScan: '立即扫描',
      update: '更新',
      operationLog: '操作日志',
      enable: '启用',
      disable: '禁用',
      accountNameDuplicate: '账户名称不能重复!',
      accountIdDuplicate: '账户ID不能重复!',
    },
    // 注册
    register:{
      UserName:'用户名',
      FullName:'全名',
      Company:'公司',
      Department:'部门',
      Position:'职务',
      Mailbox:'邮箱',
      Password:'密码',
      ConfirmPassword:'确认密码',
      Register:'注册',
      ExistingAccountLogin:'已有账号登录',
      SendTheVerificationCode:'发送验证码',
      VerificationCode:'验证码',
      NextStep:'下一步',
      ResetPassword:'重置密码',
      Warning:'警告提示',
      ResetTip:'密码输入错误已达5次,更改密码功能已被锁定,请1个小时之后再访问该功能!',
      Cancel:'取消',
      Reset:'重置'
    },
    smsLogin:{
      telPhone:'手机号码',
      SMSAuthenticationLogin:'短信验证登录',
      plaTelPhone:'请输入手机号码',
      rightTelPhone:'请输入正确的手机号码',
      plaVerificationCode:'请输入验证码',
      getVerificationCode:'获取验证码',
      surplusTime:'后重发',
      Reacquire:'重新获取',
      verificationCode:'验证码',
      product:'产品',
      subscribe:'订阅',
      doc:'使用手册',
      TrialVersion:'试用版',
      trialVersionDesc:'为团队协作量身打造，提升协作效能',
      function:'产品功能',
      Dashboard:'仪表盘',
      ResourceAlarmManagement:'资源告警管理（部分资源）',
      CaseWorkOrderSystem:'案例工单系统',
      AlarmContact:'报警联系人',

      BillManagement:'账单服务（AWS）',
      CMDBFunctionSomeResources:'CMDB功能（部分资源）',

      ReservedInstances:'预留实例',

      PermissionConfigurationManagement:'权限配置管理',

      OfficialEdition:'企业版',
      trialVersionDescOfficial:'产品研发全生命周期覆盖',
      OfficialFunction:'试用版全部功能，以及',
      InstrumentClusterEnhanced:'仪表盘[加强版]',

      ResourceAlarmManagementEnhancedVersion:'资源告警管理[加强版]',


      TimingSwitch:'定时开关机',

      ApprovalProcess:'审批流',

      BillManagementEnhancedVersion:'账单服务[加强版]',

      PachEasy:'PachEasy',

      ConfigurationManagementEnhanced:'配置管理[加强版]',

      IntelligentMonitoring:'智能监控',
      FreeTrial:'免费试用',
      applyTrial:'申请试用',
      UserManual:'使用手册',
      QuickStartGuide:'快速上手指南',
      ComingSoon:'敬请期待...',
      adminGuide:'管理员手册',
      ResourceLabelManagement:'资源标签管理',
    },
    // User
    user: {
      pleaseInputUserName: "请输入用户名",
      pleaseInputPassword: "请输入密码",
      userNameLength100: "用户名为1-100个字符",
      userNameRule420: "用户名为4-20个字符、不包含特殊字符",
      pleaseInputEmail: "请输入邮箱",
      emailFormatError: "邮箱格式错误",
      pleaseInputFullName: "请输入全名",
      fullNameLength100: "全名为1-100个字符",
      fullNameRule250: "全名为2-50个字符、不包含除空格以外特殊字符",
      pleaseSelectDepartment: "请选择部门",
      pleaseSelectPosition: "请选择职位",
      pleaseSelectRole: "请选择角色",
      pleaseInputCurrentPassword: "请输入当前密码",
      passwordRequired: "密码不能为空",
      confirmPasswordRequired: "确认密码不能为空",
      passwordMismatch: "新密码和确认密码应相同",
      passwordRule: "密码为8-20个字符、必须包含大小写字母和数字",
      currentPasswordIncorrectRemaining: "当前密码不正确,您还有剩余{count}次机会！",
      changeSuccess: "修改成功",
      changeFail: "修改失败",
      changeSuccessExclaim: "修改成功!",
      changeFailExclaim: "修改失败!",
      registerSuccess: "注册成功!",
      registerFail: "注册失败!",
      loginSuccess: "登录成功!",
      loginFail: "登录失败!",
      serverError: "服务器异常,请稍后重试!",
      switchToChinese: "切换为中文!",
      inputUserNameBeforeForgetPassword: "请先输入用户名后再点击忘记密码!",
      noMenuContactAdmin: "暂无菜单，请联系管理员",
      sendSuccessValid5Min: "发送成功，5分钟内有效!",
      emailNotExist: "邮箱不存在!",
      verifySuccess: "验证成功!",
      newPassword:'新密码',
      currentPassword:'当前密码',
      resetPassword:'重置密码',
      enable: '启用',
      disable: '禁用',
      offLine:'离线',
      onLine:'在线',
      checkByUserName:'请输入用户名',
      pleaseSelectCompany:'请选择公司',
      all:'全部',
      confirmPassword: '确认密码',
      password: '密码',
      addUser: '添加用户',
      editUser: '编辑用户',
      userManagement: '用户管理',
      userName: '用户名称',
      companyName: '公司名称',
      email: '邮箱',
      fullName: '全名',
      department: '部门',
      position: '职务',
      role: '角色',
      loginStatus: '登陆状态',
      accountStatus: '账号状态',
      SMSVerification:'开启短信验证',
      SMSVerificationStatus:'开启短信验证状态',
    },
    // Role
    role: {
      roleNameDuplicate: "角色名称不能重复!",
      roleNameRequired: "角色名称不能为空",
      roleNameLength: "角色名称为2-20个字符",
      pleaseSelectStatus: "请选择状态",
      pleaseInputRemark: "请输入备注",
      maxChars100: "最多输入100个字符",
      editRole:'编辑角色',
      companyName: '公司名称',
      roleManagement: '角色管理',
      addRole: '添加角色',
      roleName: '角色名称',
      menuData: '菜单权限',
      remark: '备注',
      checkByRoleName:'请输入角色名称',
    },
    // Group
    group: {
      editGroup: "编辑组",
      groupNameRequired: "组名称不能为空",
      groupNameLength: "组名称为4-20个字符",
      companyName:'公司名称',
      checkByVirtualDesktopID:'请输入虚拟桌面ID',
      addVirtualDesktop:'添加虚拟桌面',
      virtualDesktopID:'虚拟桌面ID',
      databaseEngine:'数据库引擎',
      cloudPlatform:'云平台',
      addDatabase:'添加数据库',
      status:'状态',
      encryption:'加密',
      readingSpeed:'读取速度',
      type:'类型',
      deviceName:'设备名',
      name:'名称',
      volumeID:'磁盘ID',
      addVolume:'添加磁盘',
      checkByVolumeId:'请输入磁盘ID',
      tags:'标签',
      privateIP:'私有IP',
      region: "区域",
      instanceName: "实例名称",
      instanceID: "实例ID",
      instanceType: "实例类型",
      diskStorage: "储存大小（GB）",
      addInstance:'添加实例',
      checkByPrivateIP:'请输入私有IP',
      checkByInstanceId:'请输入实例ID',
      checkByAccountType:'请输入账户类型',
      checkByAccountName:'请输入账户名',
      checkByStorageGatewayId:'请输入存储网关',
      addStorageGateway:'添加存储网关',
      accountType: '账户类型',
      accountId: '账户ID',
      accountName:'账户名称',
      addAccount:'添加账户',
      backGroup:'返回组',
      addUser:'添加用户',
      virtualDesktop:'虚拟桌面',
      database:'数据库',
      disks:"磁盘",
      instance:'实例',
      account:'账户',
      user:'用户',
      accessConfiguration:'权限配置',
      groupManagement: '组管理',
      addGroup: '添加组',
      configPermission: '权限配置',
      groupName: '组名称',
      checkByGroupName:'请输入组名称',
      storageGateway:'存储网关',
      storageGatewayID:'存储网关ID',
      storageGatewayName:'存储网关名称',
    },
  },
  // 监控（EC2 / EBS / RDS）
  monitor: {
    ec2: {
      detail: {
        totalDisks: '共{n}块磁盘',
        cpuCoreCount: 'CPU核数',
        coresValue: '{n}核',
        totalMemorySize: '内存总大小',
        totalDiskSize: '磁盘总大小'
      },
      dashboard: {
        selectTimeRange: '选择时间区间',
        pleaseSelectDateRange: '请选择日期区间'
      },
      warning: {
        rule: {
          ruleNameRepeated: '规则名称不能重复!',
          accountRequired: '请选择账户名称',
          alarmDelayRequired: '请选择延迟告警',
          monitorPeriodRequired: '请选择监控时段',
          regionRequired: '请选择存储区域',
          ruleNameRequired: '规则名称不能为空',
          ruleNamePattern: '规则名称为2-20个字符首尾中间不能有空格',
          notificationObjectRequired: '请选择通知对象',
          noticeTypeRequired: '请选择报警方式',
          monitorIndexRequired: '请选择监控指标',
          cycleRequired: '请选择周期',
          continousCycleRequired: '请选择连续周期',
          statisticsValueRequired: '请选择统计数值',
          statisticsCountRequired: '请选择统计次数',
          relationshipSignRequired: '请选择关系符号',
          thresholdRequired: '请输入阈值',
          contactTypeRequired: '请选择联系方式',
          enterpriseWechatRobotRequired: '请选择企业微信机器人URL',
          monitorModeRequired: '请选择监控方式',
          contactGroupRequired: '请选择联系人组'
        }
      }
    },
    ebs: {
      monitorIndex: {
        diskReadIOPS: '磁盘读取IOPS',
        diskWriteIOPS: '磁盘写入IOPS'
      },
      dashboard: {
        selectTimeRange: '选择时间区间',
        selectDateRange: '请选择日期区间'
      },
      warning: {
        rule: {
          ruleNameDuplicate: '规则名称不能重复!',
          account: '请选择账户名称',
          alarmDelay: '请选择延迟告警',
          monitorPeriod: '请选择监控时段',
          backupRegion: '请选择存储区域',
          ruleNameRequired: '规则名称不能为空',
          ruleNamePattern: '规则名称为2-20个字符首尾中间不能有空格',
          notificationObject: '请选择通知对象',
          noticeType: '请选择报警方式',
          monitorIndex: '请选择监控指标',
          cycle: '请选择周期',
          continousCycle: '请选择连续周期',
          statisticsValue: '请选择统计数值',
          relationshipSign: '请选择关系符号',
          thresholdValue: '请输入阈值',
          contactType: '请选择联系方式',
          contactGroupIds: '请选择联系人组',
          approvalFlow: '请选择审批流',
          enterpriseWechatRobotIds: '请选择企业微信机器人URL'
        }
      }
    },
    rds: {
      search: {
        aliyunSuffix: '(阿里云)'
      },
      dashboard: {
        selectTimeRange: '选择时间区间',
        selectDateRange: '请选择日期区间'
      },
      warning: {
        rule: {
          ruleNameDuplicate: '规则名称不能重复!',
          selectAccount: '请选择账户名称',
          selectAlarmDelay: '请选择延迟告警',
          selectMonitorPeriod: '请选择监控时段',
          selectCloudPlatform: '请选择云平台',
          selectRegion: '请选择存储区域',
          selectDatabaseEngine: '请选择数据库引擎',
          ruleNameRequired: '规则名称不能为空',
          ruleNamePattern: '规则名称为2-20个字符首尾中间不能有空格',
          selectNotificationObject: '请选择通知对象',
          selectNoticeType: '请选择报警方式',
          selectMonitorIndex: '请选择监控指标',
          selectCycle: '请选择周期',
          selectContinousCycle: '请选择连续周期',
          selectStatisticsValue: '请选择统计数值',
          selectRelationshipSign: '请选择关系符号',
          thresholdRequired: '请输入阈值',
          selectContactType: '请选择联系方式',
          selectContactGroup: '请选择联系人组',
          selectEnterpriseWechatRobot: '请选择企业微信机器人URL'
        }
      }
    },
    alarmRule: {
      ruleNameRepeated: '规则名称不能重复!',
      accountRequired: '请选择账户名称',
      alarmDelayRequired: '请选择延迟告警',
      monitorPeriodRequired: '请选择监控时段',
      regionRequired: '请选择存储区域',
      ruleNameRequired: '规则名称不能为空',
      ruleNamePattern: '规则名称为2-20个字符首尾中间不能有空格',
      notificationObjectRequired: '请选择通知对象',
      noticeTypeRequired: '请选择报警方式',
      monitorIndexRequired: '请选择监控指标',
      cycleRequired: '请选择周期',
      continousCycleRequired: '请选择连续周期',
      statisticsValueRequired: '请选择统计数值',
      relationshipSignRequired: '请选择关系符号',
      thresholdRequired: '请输入阈值',
      contactTypeRequired: '请选择联系方式',
      contactGroupRequired: '请选择联系人组',
      enterpriseWechatRobotRequired: '请选择企业微信机器人URL',
      approvalFlowRequired: '请选择审批流',
      eventCheckRequired: '请选择事件检查',
      alarmKeywordRequired: '请输入报警关键字'
    },
    search: {
      selectTimeRequired: '请选择时间',
      selectEventNameRequired: '请选择事件名称',
      selectEventTypeRequired: '请选择事件类型',
      selectRegionRequired: '请选择地区',
      timeIntervalExceedMonth: '时间间隔不能超过一个月，请重新选择'
    },
    agw: {
      detail: {
        description: '应用程序网关描述',
        configuration: '应用程序网关配置',
        information: '应用程序网关信息',
        nameLabel: '名称：'
      }
    },
    web: {
      detail: {
        nameLabel: '名称：'
      },
      exportFileName: '应用程序服务使用情况.xls'
    },
    cloudTrail: {
      exportFileName: 'cloudtrail安全事件日志.xls'
    }
  },
  // 公共
  common: {
    // 操作
    operation: '操作',
    operationLog: '操作日志',
    addAlarm: '添加报警',
    editAlarm: '编辑报警',
    export: '导出',
    exportInstanceAlarmRule: '导出实例报警规则',
    exportRDSAlarmRule: '导出数据库报警规则',
    exportMetricsStatistics: '导出指标统计',
    exportStatistics: '导出统计',
    del: '删除',
    edit: '编辑',
    login: '登录',
    register: '注册新账号',
    activate: '激活',
    inActivate: '禁用',
    note: '备注',
    ok: '确认',
    configure: '配置',
    forgetPassword: '忘记密码',
    changePassword: '修改密码',
    userName:'用户名',
    password:'密码',
    submit:'提交',
    determine:'确定',
    singleAccount: '单账户',
    accountGroup: '账户组',
    noData:'暂无数据',
    notice:'通知',
    noticeContent:'你有一条新的待办事项',
    yes:'是',
    no:'否',
    cancel:'取消',
    prompt:'提示',
    exporting:'正在导出，请稍等...',
    exportSuccess:'导出成功',
    exportFail:'导出失败',
    deleteSuccess:'删除成功',
    editSuccess:'编辑成功',
    addSuccess:'添加成功',
    editFail:'编辑失败',
    addFail:'添加失败',
    saveSuccess:'保存成功',
    runSuccess:'运行成功',
    descriptionRequired:'请输入描述',
    uploadSuccess:'上传成功',
    uploadFail:'上传失败',
    operationSuccess:'操作成功',
    update:'更新',
    updateSuccess:'更新成功',
    updateFail:'更新失败',
    detail:'详情',
    systemPrompt:'系统提示',
    downloadSuccess:'下载成功'
  },
  // 操作日志
  operation_log: {
    operationLog: "操作日志",
    changeField: "变更字段",
    operationMonitorModuleName: "操作模块",
    operationFieldName: "操作字段",
    operationOriginValue: "原值",
    operationNewValue: "新值",
    createdBy: "操作人",
    search: "查询",
    pleaseSelectStartTime: "请选择开始时间",
    pleaseSelectEndTime: "请选择结束时间",
    createdTime: "更新时间"
  },
  patch_management: {
    // 补丁监视器
    patch_monitor: {
      patchMonitor: '补丁监视器',
      awsSSMOverview: '概述',
      instanceType: '实例类型',
      patchedInstancesByOS: '已打补丁的实例（操作系统）',
      patchedInstance: '补丁实例',
      id: '实例ID',
      name: '名称',
      missingCount: '丢失数',
      installedCount: '安装数量',
      installedOtherCount: '安装其他数量',
      notApplicableCount: '未打补丁数量',
      notPatchedInstances: '未打补丁实例',
      quantity: '数量'
    },
    //补丁策略
    patch_policy: {
      deletePolicy:"删除策略",
      runImmediately:"立即运行",
      start:"开启",
      close:"关闭",
      active:"启用",
      inactive:"禁用",
      addPolicy:"添加策略",
      editPolicy:"编辑策略",
      name:"名称",
      policyName: "策略名称",
      account:"账户",
      region:"区域",
      queryByRegion:"请输入区域",
      state:"状态",
      remindTime:"提醒时间",
      contactType:"联系方式",
      contactPerson:"通知对象",
      contactGroup:"联系人组",
      approvalFlow:"审批流",
      schedule:"日程",
      description:"描述",
      cancel:"取消",
      confirm:"确定",
      submit:"提交",
      queryByName:"请输入名称",
      queryByPolicyName: "请输入策略名称",
      patchDetail:"补丁详情",
      releaseDate:"发行日期",
      title:"名称",
      vendor:"供应商",
      productFamily:"产品系列",
      product:"产品",
      classification:"分类",
      severity:"严重级别",
      number:"编号",
      language:"语言",
      patchBaselineDetail:"补丁基准详情",
      baselineId:"基准ID",
      baselineName:"基准名称",
      os:"操作系统",
      defaultBaseline:"默认基准",
      patchGroup:"补丁组",
      createdDate:"创建日期",
      modifiedDate:"修改日期",
      queryByAccount:"请输入账号",
      queryBySeverity:"请输入严重级别",
      search:"搜索",
      queryByOS:"请输入操作系统",
      patchBaseline:"补丁基准",
      patch:"补丁",
      selectAll:"全选",
      priority: "优先级",
      addPatchBaseline:"添加补丁基准",
      editPatchBaseline:"编辑补丁基准",
      add:"添加",
      edit:"编辑",
      yes:"是",
      no:"否",
      CommandParameters:"命令参数",
      Operating:"操作",
      SnapshotId:"快照Id",
      InstallationCoverageList:"安装覆盖列表",
      WhetherToBackup:"是否备份",
      InAdvance:"提前",
      MinuteBackup:"分钟备份",
      WhetherTheBackupFailsToContinue:"备份失败是否继续",
      BackupRetention:"备份保留",
      Day:"天",
      Aims:"目标",
      SpecifyTargetMethod:"指定目标方式",
      SpecifyLabel:"指定标签",
      ManuallySelectInstance:"手动选择实例",
      KeyUpToCharacters:"键 （最多128个字符）",
      ValueUpToCharacters:"值 （最多256个字符）",
      Delete:"删除",
      AddTag:"添加标签",
      OtherParameters:"其他参数",
      Comment:"注释",
      TimeoutSeconds:"超时(秒)",
      OutputOptions:"输出选项",
      Tip:"将命令输出写入Amazon S3 存储桶",
      EnableBucketWriting:"启用S​​3 存储桶写入",
      WriteCommandOutputToAmazonCloudWatchLog:"将命令输出写入Amazon CloudWatch 日志",
      CloudWatchOutput:"CloudWatch 输出",
      TargetInstance:"目标实例",
      QuerybyInstanceID:"请输入实例ID",
      InstanceID:"实例 ID",
      ProxyVersion:"代理版本",
      status:"状态",
      AvailableArea:"可用区域",
      platform:"平台",
      S3BucketName:"S3 存储桶名称",
      S3KeyPrefixOptional:"S3密钥前缀 - 可选",
      LogGroupNameRequired:"日志组名称 - 必选",
      save:"保存",
      //Input Validation
      inputValidation: {
        requiredAccount: "请选择账号",
        requiredRegion: "请选择区域",
      },
      nameRequired: "名称不能为空",
      nameLength: "名称为4-20个字符",
      selectApprovalFlow: "请选择审批流",
      selectNotificationObject: "请选择通知对象",
      selectAccountName: "请选择账户名称",
      selectRemindTime: "请选择提醒时间",
      selectState: "请选择状态",
      selectSchedule: "请选择日程",
      maxChars100: "最多输入100个字符",
      selectContactType: "请选择联系方式",
      selectContactGroup: "请选择联系人组",
      selectOS: "请选择操作系统",
      selectProduct: "请选择产品",
      selectPriority: "请选择优先级",
      selectSeverity: "请选择严重性",
      maxChars1000: "最多输入1000个字符",
      selectIsDefaultBaseline: "请选择是否默认补丁基准",
      keyRequired: "键不能为空",
      valueRequired: "值不能为空",
      atLeastOneSubDimension: "至少需要一个子维度",
      atLeastOneTargetInstance: "至少需要一个目标实例"
    },
    // 补丁命令参数
    patch_command: {
      commandDetail: "命令详情",
      cancelCommand: "取消命令",
      cancelCommandTitle: "取消命令  39902398-ce1d-45b9-b711-634d4c8b8045",
      cancelCommandContent: "您可以尝试取消此命令。但是，我们无法保证该命令将终止并且基础流程将停止。是否确实要取消此命令？",
      rerunCommand: "重新运行命令",
      rerunCommandContent: "您是否要使用完全相同的输入重新运行命令？",
      rerunCommandId: "39902398-ce1d-45b9-b711-634d4c8b8045.",
      cancelCommandSuccess: "取消命令成功",
      rerunCommandSuccess: "重新运行命令成功"
    }
  },

  satisfaction: {
    // 满意度
    title: "满意度",
    search: "查询",
    ticketID: "案例ID",
    summary: "概要",
    initiator: "发起人",
    ticketCategory: "问题类型",
    functionCategory: "功能类型",
    priority: "优先级",
    status: "状态",
    finishTime: "结束时间",
    satisfaction: "满意度",
    operation: "操作",
    detail: "详情",
    comment: "评论",
    searchBySubject: "请输入主题",
    searchByPriority: "请选择优先级",
    pleaseSelectStartTime: "请选择开始时间",
    pleaseSelectEndTime: "请选择结束时间"
  },
  //KPI
  KPI: {
    viewProcessingDetails: "查看处理详情",
    viewSlaDetails: "查看SLA详情",
    pleaseSelectCompany: "请选择公司",
    pleaseSelectOperation: "请选择运维",
    pleaseSelectDate: "请选择日期",
    pleaseSelectType: '请选择值班类型',
    id: "序号",
    ticketEntityId: "案例ID",
    subject: "主题",
    priorityName: "优先级",
    statusName: "状态",
    problemType: "问题类型",
    slaStandard: "标准SLA",
    waitTime: "响应时间(min)",
    name: "姓名",
    total: "总计",
    p1event: "p1事件",
    p2event: "p2事件",
    p3event: "p3事件",
    p4event: "p4事件",
    closed: "已关闭",
    pending: "待处理",
    responseTime: "响应时间",
    processing: "正在处理",
    totalEvent: "事件总数",
    fundamentalStructureAlert: "基础架构告警事件",
    securityAlert: "安全告警事件",
    billingAlert: "账单告警事件",
    companyContribution: "公司贡献",
    changingRequest: "变更请求",
    serviceRequest: "服务申请",
    eventCategory: "问题类型",
    whetherManual: "是否自动",
    eventChangingTrendingStatistic: "事件变化趋势统计图",
    casesSLAStatistic: "各级别案例SLA分析统计图",
    casesStatistic: "案例统计",
    nightFactor: "夜班系数",
    documentationContribution: "文档贡献",
    internalContribution: "内部贡献",
    unsatisfiedSLACasesStatistic: "不满足SLA案例统计",
    ticketCategoryName: "种类",
    caseSLAAtEachLevel: "各级别案例SLA",
    dayShift: "白班",
    nightShift: "夜班",
    fileNameCaseStatistic: "案例统计.xls",
    fileNameCompanyContribution: "公司贡献.xls",
    fileNameUnsatisfiedSLA: "不满足SLA案例统计.xls"
  },
  RedshiftMonitor: {
    //数据仓库
    redshift: "数据仓库",
    addRedshift: "添加数据仓库报警规则",
    cluster: "集群",
    accountName: "账户名称",
    accountType: "账户类别",
    status: "状态",
    region: "区域",
    operation: "操作",
    redshiftList: "数据仓库列表",
    redshiftInfo: "数据仓库信息",
    redshiftDescription: "数据仓库描述",
    redshiftConfig: "数据仓库配置",
    name: "名称",
    // 折线图
    line:{
      PercentageOfUsedDiskSpacePercentage:'已使用磁盘空间的百分比（%）',
      PercentageOfUsedDiskSpace:'已使用磁盘空间的百分比',
      HealthStatus:'健康状态',
      MaintenanceMode:'维护模式',
      ClusterCPUUsagePercentage:'集群CPU使用率(%)',
      ClusterCPUUsage:'集群CPU使用率',
      NumberOfClusterConnectionstimessecond:'集群连接数(次数/秒)',
      NumberOfClusterConnections:'集群连接数',
      ClusterReadAndWriteIOPStimessecond:'集群读写IOPS (次数/秒)',
      ClusterReadIOPS:'集群读IOPS',
      ClusterWriteIOPS:'集群写IOPS'
    }
  },
  DocDBMonitor: {
    //数据仓库
    redshift: "DocDB",
    addRedshift: "添加DocDB报警规则",
    editRedshift:'编辑DocDB报警规则',
    cluster: "集群",
    accountName: "账户名称",
    accountType: "账户类别",
    status: "状态",
    region: "区域",
    operation: "操作",
    redshiftList: "DocDB列表",
    redshiftInfo: "DocDB信息",
    redshiftDescription: "DocDB描述",
    redshiftConfig: "DocDB配置",
    name: "名称",
    ClusterIdentifier:'集群标识符',
    instanceIdentifier:'实例标识符',
    Identifier:'标识符',
    role:'角色',
    EngineVersion:'引擎版本',
    AreasAndZones:'区域和可用区',
    status:'状态',
    size:'大小',
    accountTypes:'账号类型',
    accountName:'账号名称',
    dbClusterMembers:'实例个数',
    roleName:'角色名称',

    clusterCreateTime:'创建时间',
    engineVersion:'引擎版本',
    // 折线图
    line:{
      PercentageOfUsedDiskSpacePercentage:'已使用磁盘空间的百分比（%）',
      PercentageOfUsedDiskSpace:'已使用磁盘空间的百分比',
      HealthStatus:'健康状态',
      MaintenanceMode:'维护模式',
      ClusterCPUUsagePercentage:'集群CPU使用率(%)',
      ClusterCPUUsage:'集群CPU使用率',
      NumberOfClusterConnectionstimessecond:'集群连接数(次数/秒)',
      NumberOfClusterConnections:'集群连接数',
      ClusterReadAndWriteIOPStimessecond:'集群读写IOPS (次数/秒)',
      ClusterReadIOPS:'集群读IOPS',
      ClusterWriteIOPS:'集群写IOPS'
    }
  },
  ElasticSearch: {
    //ElasticSearch
    esDomain: "ES域名",
    accountName: "账户名称",
    accountType: "账户类型",
    region: "区域",
    operation: "操作",
    esList: "ElasticSearch列表",
    addEs: "添加ElasticSearch报警规则",
    EsDescription: "ElasticSearch描述",
    EsConfig: "ElasticSearch 配置",
    EsInfo: "ElasticSearch 信息",
    name: "名称",
    // 折线图
    line:{
      ClusterAverageCPUUtilizationPercentage:'集群平均CPU利用率（百分比）',
      ClusterAverageCPUUtilization:'集群平均CPU利用率',
      ClusterStatus:'集群状态',
      ClusterStatusRed:'集群状态(红色)',
      ClusterStatusYellow:'集群状态(黄色)',
      ESClusterStatusRed:'红色集群状态',
      ESClusterStatusYellow:'黄色集群状态',
      ESFreeStorageSpace:'集群可用存储空间',
      ESClusterIndexWritesBlocked:'集群正在阻止写入请求',
      ESNodes:'集群节点',
      ESAutomatedSnapshotFailure:'自动快照失败',
      ESCPUUtilization:'CPU使用率',
      ESJVMMemoryPressure:'集群中所有数据节点的 Java 堆的最大百分比',
      ESMasterCPUUtilization:'主节点CPU使用率',
      ESMasterJVMMemoryPressure:'集群中主数据节点的 Java 堆的最大百分比',
      ESKMSKeyError:'域中加密静态数据的 KMS 加密密钥已禁用',
      ESKMSKeyInaccessible:'域中加密静态数据的 KMS 加密密钥已被删除或已撤销其对 Amazon ES 的授权',
    }
  },
  StorageGateway: {
    //StorageGateway
    accountName: "账户名称",
    accountType: "账户类型",
    region: "区域",
    name: "名称",
    // 折线图
    line:{
      cachePercentUsed:'缓存总使用率 (百分比)',
      cacheHitPercent:'缓存命中率（百分比）',
      ioWaitPercent:'高 IO 等待（百分比）',
      availabilityNotifications:'可用性通知',
      healthNotifications:'运行状况通知',
      cachePercentDirty:'缓存脏数据（百分比）'
    }
  },
  application: {
    //应用
    alertRule: "报警规则",
    ruleName: "规则名称",
    status: "状态",
    monitorIndex: "监控指标",
    indexDescription: "指标描述",
    contact: "通知对象",
    category: "类型",
    instanceList: "实例列表",
    name: "名称",
    accountName: "账户名称",
    accountType: "账户类型",
    instanceID: "实例ID"
  },
  ActionTrailSecurity: {
    //安全ActionTrail
    title: "安全（ActionTrail）",
    chinaRegion: "中国区",
    account: "账户",
    time: "时间",
    region: "区域",
    eventName: "事件名称",
    eventType: "事件类型",
    userName: "用户名",
    resourceType: "资源类型",
    resourceName: "资源名称",
    errorCode: "错误码",
    accountName: "账号名称",
    eventTime: "事件时间",
    search: "搜索",
    area:'地区',
    AccessKey:"访问秘钥",
    EventSource:"事件源",
    district:"地域",
    ErrorCode:"错误代码",
    RequestID:"请求ID",
    EventID:"事件ID",
    SourceIPAddress:"源IP地址",
    EventName:"事件名称",
    RelatedResources:"相关资源",
    pleaseSelectEventName: "请选择事件名称",
    pleaseSelectArea: '请选择地区',
  },
  CloudTrailSecurity: {
    //安全CloudTrail
    title: "安全（CloudTrail）",
    alertRule: "报警规则",
    ruleName: "规则名称",
    status: "状态",
    monitorIndex: "监控指标",
    contact: "通知对象",
    category: "类型",
    operation: "操作",
    cloudTrailLogList: "CloudTrail日志列表",
    account: "账户",
    region: "区域",
    time: "时间",
    caseName: "事件名称",
    caseTime: "事件时间",
    resourceType: "资源类型",
    resourceName: "资源名称",
    addCloudTrailSecurityAlertRule: "添加安全CloudTrail报警规则",
    operationLog: "操作日志",
    search: "搜索",
    userName: "用户名",
    accessKeyId:"AWS访问秘钥",
    awsRegion:"AWS地域",
    readOnly:"只读",
    errorCode:"错误代码",
    requestId:"请求ID",
    eventId:"事件ID",
    invokedBy:"源IP地址",
    eventSource:"事件源"
  },
  TrustAdvisor: {
    account: '账号',
    total: '总量',
    consultant: '顾问列表',
    alertRule: "报警规则",
    ruleName: "规则名称",
    status: "状态",
    monitorIndex: "监控指标",
    contact: "通知对象",
    category: "类型",
    operation: "操作",
    highAvailability: "高可用性",
    suggestion: "建议",
    greatestInfluence: "影响最大",
    mediumInfluence: "中等程度的影响",
    lowestInfluence: "最小影响",
    influencedResources: "受影响的资源",
    security: "安全性",
    performance: "性能",
    cost: "成本",
    alertDelay: "延迟告警",
    overview: "概览",
    addTrustAdvisorAlert: "添加Advisor报警规则",
    updateTrustAdvisorAlert: "编辑Advisor报警规则",
    detail: "详情",
    generalSuggestion: "总体建议",
    influence: "影响",
    explanation: "说明",
    updateTime: "更新时间",
    sortedSuggestion: "按影响排列的建议"
  },
  ARD: {
    //AffectResourceDetail
    region: "区域",
    IPAddress: "IP地址",
    regionAZ: "区域AZ",
    volumeID: "卷ID",
    volumeName: "卷名",
    volumeAttachment: "卷附加",
    instanceID: "实例ID",
    instanceType: "实例类型",
    instanceName: "实例名称",
    ebsOptimize: "ebs优化",
    status: "状态",
    snapshotID: "快照ID",
    snapshotName: "快照名称",
    snapshotAge: "快照年龄",
    reason: "原因",
    AZ: "AZ",
    dbInstance: "数据库实例",
    backupRetentionPeriod: "备份保留期",
    bucketName: "存储桶名称",
    tgtName: "目标名称",
    tgtExist: "目标存在",
    sameOwner: "所有者相同",
    writeEnable: "写权限已启用",
    regionName: "区域名称",
    regionAPIParameter: "区域 API 参数",
    ACLAllowList: "ACL 允许列表",
    ACLAllowUploadDelete: "ACL 允许上传/删除",
    policyAllowAccess: "策略允许访问",
    ignoredBucketName: "已忽略的存储桶名称",
    ASGroupName: "AutoScaling 组名称",
    loadBalancerAssociated: "关联的负载均衡器",
    healthCheck: "运行状况检查",
    launchConfigName: "启动配置名称",
    launchName: "启动名称",
    launchType: "启动类型",
    resourceName: "资源名",
    resourceType: "资源类型",
    securityGroupName: "安全组名称",
    securityGroupID: "Security Group ID",
    groupID: "组ID",
    description: "描述",
    instanceAmount: "实例数量",
    totalInboudRules: "全部入站规则",
    totalOutboudRules: "全部出站规则",
    loadBalancerName: "负载均衡器名称",
    loadBalancerPort: "负载均衡器端口",
    passwordPolicy: "密码策略",
    upperCase: "大写",
    lowerCase: "小写",
    number: "数字",
    nonAlphanumeric: "非字母数字",
    protocol: "协议",
    port: "端口",
    ipRange: "IP 范围",
    zoneAmount: "区域数量",
    ZoneAInstance: "A 区实例",
    ZoneBInstance: "B 区实例",
    ZoneCInstance: "C 区实例",
    ZoneDInstance: "D 区实例",
    ZoneEInstance: "E 区实例",
    ZoneFInstance: "F 区实例",
    day1: "Day 1",
    day2: "Day 2",
    day3: "Day 3",
    day4: "Day 4",
    day5: "Day 5",
    day6: "Day 6",
    day7: "Day 7",
    day8: "Day 8",
    day9: "Day 9",
    day10: "Day 10",
    day11: "Day 11",
    day12: "Day 12",
    day13: "Day 13",
    day14: "Day 14",
    day14avgCPUUtlz: "14天CPU平均使用率",
    amtDaysCPUUtlzOver90: "CPU使用率超过90%的天数",
    amountOfDaysOver: "超过的天数",
    maxDailyMedian: "最大每日中值",
    estimateMonthlySaving: "预计每月节省"
  },
  //账单
  Bill: {
    //RI页面
    RI: {
      title: "RI页面",
      currentRIList: "当前预留实例列表",
      reservedInstanceReccmd: "预留实例推荐",
      otherReservedList: "当前预留RDS,预留ElastiCache,预留Redshift,预留ElastiSearch等列表",
      DHHostReservedInstance: "DH Host预留实例",
      proEnvInstanceStatus: "生产环境实例情况 (以上取数为前日01:00pm至昨日01:00pm)",
      devEnvInstanceStatus: "开发环境实例情况 (以上取数为前日01:00pm至昨日01:00pm)",
      system: "系统",
      quantity: "数量/单元",
      startTime: "开始时间",
      endTime: "截止时间 ",
      rent: "租赁",
      RIRecAmount: "RI推荐数量",
      account: "账号",
      subScriptionId: "订阅ID",
      due: "到期(天)",
      series: "系列",
      instanceAmount: "实例数量/单元",
      RIAmount: "RI数量",
      detail: "具体数据",
      beijing: "北京",
      Singapore: "新加坡",
      detailFileName: "{name}(详情)",
      devEnvInstanceFile: "开发环境实例情况",
      prodEnvInstanceFile: "生产环境实例情况"
    },
    // 账单页面
    Billing: {
      title: "账单页面",
      recent10DaysAnalysis: "近10日各服务每日花费分析",
      monthlyCost: "月度花费",
      dailyCostCurve: "花费日增长曲线",
      eachDimentionCost: "花费日增长曲线",
      unit: "(单位:",
      S3: "对象存储 (单位:GB)",
      serviceName: "服务",
      linkedaccountid: "账号",
      selectAll: '全选',
      billingday: "日期",
      region: "区域",
      servicename: "服务",
      unblendedcosUnit: "花费",
      export: "导出",
      beforeDiscount: "折扣前",
      afterDiscount: "折扣后",
      month: "月度",
      theProportionOfEachDimension: "各维度花费比例",
      dimenkey: "键",
      keyvalue: "键值",
      detail: "具体数据",
      resourceId: "资源ID",
      usageDate: "使用时间",
      usageQuantity: "使用量",
      totalCost: "总和花费",
      detailFileName: "{name}(详情)",
      dailyCostGrowth: "花费日增长",
      eachDimensionCostFile: "各维度花费"
    },
    // AWS账单页面
    SLBilling: {
      resourceCategories:'Top 15 资源类别',
      title: "AWS账单页面",
      monthPrediction: "预测",
      monthBilling: "账单",
      monthlyBillingAmount: "每月账单金额",
      billingOverview: "账单概览",
      billAmount: "账单金额",
      Histogram:"矩形图",
      total:"总量"
    },
    CostAllocation: {
      title: "成本分摊",
      tableName: "表名",
      applicationName: "应用名",
      costCenter: "成本中心",
      name: "名称",
      proportionOfContribution: "分摊比例(%)",
      timer: "开始时间-结束时间",
      batchExport: "批量导出",
      confirmBatchExport: "你确定要批量导出以下数据吗?",
      nameRequired: "名称不能为空",
      pleaseInputProportion: "请输入分摊比例(%)",
      proportionSumMustBe100: "分摊比例相加之和需为100%",
      tableAppNameDuplicate: "表名+应用名不能重复!",
      atLeastOneSubDimension: "至少需要一个子维度",
      pleaseInputTableName: "请输入表名",
      pleaseInputApplicationName: "请输入应用名"
    },
    ResourceOptimization: {
      title: "资源优化",
      pleaseSelectProjectValue: "请选择project值",
      RIDataSource: "RI数据源",
      prompt: "提示",
      singleAvailabilityStandardizedUnit: "单可用区标准化单位",
      multiAvailabilityStandardizedUnit: "多可用区标准化单位",
      pleaseSelectLabelValue: "请选择标签值",
      pleaseSelectAccount: "请选择账号",
      customer: "客户",
      engineType: "引擎类型",
      instanceType: "实例类型",
      elasticsearchCount: "Elasticsearch量(实时数量)",
      RIRecommendedQuantity: "RI 推荐数量",
      RIAvailableQuantity: "现有RI数量",
      purchaseRate: "购买率",
      exactlyMatchTheSavings: "完全匹配节省费用",
      currentlyReservedToSaveCosts: "当前预留节省费用",
      toolTips: "所有预留实例相关费用均以 All Upfront 计费方式计算",
      os: '操作系统',
      EC2Count: "EC2量(实时数量)",
      clientCompany: "客户公司",
      specialDiscountOrNot: "是否特殊折扣",
      CUDRecommendationPage: "CUD推荐页面",
      recommendedPurchaseCUDNumber: "建议购买CUD数",
      purchasedCUDNumber: "已经购买CUD数",
      noMatchCUD: "本月未匹配CUD平均数量",
      nextMonthCUD: "下月推荐购买CUD后节省费用",
      CUDUsage: "CUD使用情况",
      utilizationRate: "利用率",
      queryInterval: "请输入查询区间",
      coverageRate: "覆盖率",
      payAccount: "请选择付款账号",
      redshiftCount: "Redshift量(实时数量)",
      multiAZ: "是否多可用区",
      databaseEngine: "数据库引擎",
      databaseType: "数据库类型",
      RDSCount: "RDS量(实时数量)",
      queryMaybeSlow: "查询可能较慢，请耐心等待",
      basicDiscountOff: "基本折扣(% off)",
      pleaseSelectClientCompany: "请选择客户公司",
      pleaseInputBasicDiscount: "请输入基本折扣",
      pleaseSelectSpecialDiscount: "请选择是否特殊折扣"
    },
    CostCalculation: {
      title: "成本计算",
      reset: "重置",
      EC2: "EC2 (服务器实例)",
      storage: "存储",
      RDS: "RDS (关系型数据库)",
      subtotal: "小计",
      AWSTotal: "AWS总计",
      purpose: "用途",
      region: "地区",
      cache: "内存",
      OS: "操作系统",
      paymentMethod: "付费类型",
      amount: "数量",
      unitPrice: "单价",
      month: "月",
      price: "价格",
      operation: "操作",
      storageType: "存储类型",
      serviceType: "服务类型",
      storageCapacity: "存储容量",
      preConfigIOPS: "预配置的IOPS数量",
      databaseType: "数据库类型",
      deploymentMethod: "部署方式",
      year: "年",
      area: "区域",
      areaColon: "区域 :",
      core: "核",
      add: "添加",
      addStorage: "添加存储",
      addEC2: "添加EC2 (服务器实例)",
      addRDS: "添加RDS(关系型数据库)",
      generalSSD: "通用型(SSD)卷",
      provisionedIOPSSSD: "预配置IOPS(SSD)卷",
      throughputOptimizedHDD: "吞吐量优化型(HDD)卷",
      coldHDD: "Cold HDD卷",
      ebsSnapshot: "EBS快照",
      onDemandInstance: "按需实例",
      noUpfrontStandard1Year: "无前期费用(标准1年)",
      singleZone: "单区域",
      multiZone: "多区域",
      pleaseSelectStorageType: "请选择存储类型",
      pleaseSelectServiceType: "请选择服务类型",
      pleaseInputNumber: "请输入数字",
      pleaseSelectUnit: "请选择单位",
      pleaseSelectOS: "请选择操作系统",
      pleaseSelectPaymentMethod: "请选择付费类型",
      pleaseSelectDatabaseType: "请选择数据库类型",
      pleaseSelectDeploymentMethod: "请选择部署方式",
      pleaseSelectRegion: "请选择地区",
      savePlan: "保存方案",
      saveAs: "另存为",
      exportReport: "导出报表",
      name: "名称",
      description: "描述",
      beijing: "北京",
      singapore: "新加坡",
      nameExists: "当前名称已存在!",
      nameRequired: "名称不能为空",
      descriptionRequired: "请输入描述",
      max100Chars: "最多输入100个字符",
      exportFailedUsageEmpty: "导出失败,用途不能为空",
      exportFailedMonthEmpty: "导出失败,月不能为空",
      exportSuccess: "导出成功",
      saveFailedUsageEmpty: "保存失败,用途不能为空",
      saveFailedMonthEmpty: "保存失败,月不能为空",
      addSuccess: "添加成功",
      addFailed: "添加失败",
      saveAsFailedUsageEmpty: "另存为失败,用途不能为空",
      saveAsFailedMonthEmpty: "另存为失败,月不能为空"
    },
    ebilling:{
      dashboard:"仪表盘",
      account:"账户",
      tag:"标签",
      service:"服务",
      LicenseRI:"License RI",
      NolicenceRI:"Nolicence RI",
      region:"区域",
      custom:"客户自定义",
      bill:"账单",
      awsBill:"AWS账单"
    },
    cudRecommend:{
      expireList:"CUD到期信息列表",
      cudUsage:"CUD使用量",
      cudMatched:"CUD匹配量",
      cudRemaining:"CUD剩余使用量",
      onDemandQuantity:"按需数量",
      purchaseCudQuantity:"购买CUD数量"
    },

  },
  companyManagement: {
    editCompany: "编辑公司",
    pleaseSelectDate: "请选择日期",
    monitorAwsHealthDashboard: "监控AWS健康仪表盘",
    pleaseInputCompanyName: "请输入公司名称",
    companyNameLength: "公司名称为1-100个字符",
    pleaseInputCompanyAddress: "请输入公司地址",
    companyAddressLength: "公司地址为1-100个字符",
    pleaseInputParentCompanyAddress: "请输入母公司地址",
    parentCompanyAddressLength: "母公司地址为1-100个字符",
    pleaseInputBillingAddress: "请输入账单邮寄地址",
    billingAddressLength: "账单邮寄地址为1-100个字符",
    pleaseSelectReplySwitch: "请选择回复开关",
    pleaseSelectMonitorAwsHealthDashboard: "请选择监控AWS健康仪表盘",
    pleaseSelectCustomerType: "请选择客户类型",
    searchByCompanyName: "按公司名称查询",
    searchByCustomerType: "按客户类型查询",
    //公司管理
    title: "公司管理",
    companyName: "公司名称",
    companyAddress: "公司地址",
    parentCompanyName: "母公司名称",
    emailNotificationReply: "邮件通知回复案例",
    AWSHealthMonitorDashboard: "AWS健康监控仪表盘",
    billingAddress: "账单邮寄地址",
    customerType: "客户类型",
    operation: "操作",
    addCompany: "添加公司",
    yes: "是",
    no: "否",
  },
  RIAccountGroupManagement: {
    accountGroupNameDuplicate: "财务账户组名称不能重复!",
    //财务账户组管理
    title: "财务账户组管理",
    RIAccountGroupName: "财务账户组名称",
    addRIAccountGroup: "添加财务账户组",
    editRIAccountGroup: "编辑财务账户组",
    configuration: "配置",
    region: "地区",
    area: "地区",
    AvailabilityZone: "区域",
    AZ: "区域",
    comment: "备注",
    operation: "操作",
    RIAccountGroupConfig: "财务账户组配置",
    accountName: "账户名",
    accountID: "账户ID",
    addAccount: "添加账户",
    companyName: "公司名称",
    cancel: "取消",
    China:"中国",
    Overseas:"海外",
    Native:"原生",
    queryByAccountGroupName: '请输入财务账户组名称',
    accountGroupNameNotEmpty: '账户组名称不能为空',
    accountGroupNameValidateMsg: '账户组名称为4-20个字符',
    pleaseSelectArea: '请选择地区',
    pleaseSelectRegion: '请选择区域'
  },


  MenuManagement: {
    menuRole: "菜单角色",
    normalMenu: "普通菜单",
    paidMenu: "付费菜单",
    general: "通用",
    //菜单管理
    menuManagement: "菜单管理",
    addMenu: "添加菜单",
    menuName: "菜单名称",
    category: "类型",
    sort: "排序",
    menuIcon: "菜单图标",
    permissionIcon: "权限标识",
    addressPath: "地址栏路径",
    componentPath: "组件路径",
    operation: "操作",
    edit: "编辑",
    delete: "删除",
    editMenu: '编辑菜单',
    upperMenu: '上级菜单',
    buttonName: '按钮名称',
    menuTitle: '菜单标题',
    englishTitle: '英文标题',
    directory: '目录',
    menu: '菜单',
    button: '按钮',
    pleaseSelectType: '请选择类型',
    pleaseInputMenuTitle: '请输入菜单标题',
    pleaseInputEnglishTitle: '请输入英文标题',
    pleaseInputSort: '请输入排序',
    pleaseInputAddressPath: '请输入地址栏路径',
    pleaseInputComponentPath: '请输入组件路径',
    pleaseInputMenuIcon: '请输入菜单图标',
    pleaseInputButtonName: '请输入按钮名称',
    pleaseInputPermissionIcon:'请输入权限标识'
  },
  AWSBilling: {
    //AWS账单页面
    prediction: "预测",
    billings: "账单",
    monthlyBillingCost: "每月账单金额",
    billingPreview: "账单预览",
    top15ResourceType: "Top15资源类型"
  },
  cudrecommendation:{
    //CUD推荐页面
    commitmentId:"CUD ID",
    name:"名称",
    start:"起始时间",
    end:"截止时间",
    autoRenew:"自动续订",
    typeName:"类型",
    statusName:"状态",
    planName:"时长",
    search:"搜索",

   },
   cudRecommendForm:{
      accountId:"请选择账号",
      cudType:"请选择机型",
      availableArea:"请选择可用区",
      resourceType:"请选择资源类型",
    },
    //预留实例
    reservedInstance:{
      //覆盖率报告
      coverage:{
        pleaseSelect:"请选择查询区间",
        customer: "客户",
        accountName:"账户名称",
        accountId:"账户ID",
        EC2:"EC2",
        RDS:"RDS",
        Redshift:"Redshift",
        ElastiCache:"ElastiCache",
        Opensearch:"Opensearch"
      },
      report:{
        pleaseSelectCompany:"请选择公司",
        pleaseSelectAccount:"请选择账号",
        pleaseSelectDate:"请选择日期",
        pleaseInputInterval:"请填写区间",
        pleaseInputValidInterval:"请填写合适的区间"
      },
    },
  // PatchEasy
  PatchEasy: {
    // 补丁策略
    PatchPolicy: {
      title: "补丁策略",
      addStrategy: "添加策略",
      name: "名称",
      policyName: "策略名称",
      account: "账户",
      dispatchDuty: "调度任务",
      config: "配置",
      patchstdConfig: "补丁标准配置",
      patchcmdPara: "补丁命令参数",
      deleteStrategy: "删除策略",
      instantRun: "立即运行",
      addStdConfig: "添加标准配置",
      stdID: "基准ID",
      stdName: "基准名称",
      description: "描述",
      OS: "操作系统",
      defaultStd: "默认基准",
      productSeries: "产品系列",
      product: "产品",
      category: "分类",
      severityLevel: "严重级别"
    },
    //命令列表
    PatchCmd: {
      title: "命令列表",
      cmdID: "命令 ID",
      requestDate: "请求日期",
      fileName: "文档名称",
      comment: "注释",
      tgt: "# 目标",
      error: "# 错误",
      submitDelay: "# 提交超时",
      complete: "# 完成",
      search: "搜索",
      command: "命令",
      commandHistory: "命令历史记录",
      account: "账号",
      region: "区域",
      selectByAccount: "请输入账号",
      selectByRegion: "请输入区域",
      selectByCmdID: "请输入命令ID",
      commandDetails: "命令详情",
      commandStatus: "命令状态",
      overallStatus: "总体状态",
      detailedStatus: "详细状态",
      goalsAndOutputs: "目标与输出",
      selectByInstanceID: "请输入实例ID",
      instanceID: "实例 ID",
      instanceName: "实例名称",
      backupID: "备份ID",
      startTime: "开始时间",
      completeTime: "完成时间",
      viewOutput: "查看输出",
      output: "输出",
      descriptionAndStatus: "步骤 1 - 命令描述和状态",
      responseCode: "响应代码",
      stepName: "步骤名称",
      stepOneOutput: "步骤 1 - 输出",
      tip: "命令输出最多显示 2500 个字符。如果您在运行命令时指定了 S3 存储桶或 CloudWatch 日志组，则可以在 Amazon S3 或 CloudWatch 日志中查看完整的命令输出。",
      nameAndDescription: "名称和描述",
      commandDocument: "命令文档",
      documentVersion: "文档版本",
      requestTime: "请求时间",
      commandParameters: "命令参数",
      parameter: "参数",
      deliveryTimeout: "交付超时 (秒)",
      executionTimeout: "执行超时 (秒)"
    }
  },
  //资源配置管理
  RAM: {
    AWS: {
      computeInstance: {
        //计算实例
        title: "计算实例",
        accountID: "账户ID",
        accountName: "账户名称",
        region: "区域",
        instanceName: "实例名称",
        instanceID: "实例ID",
        instanceType: "实例类型",
        CPU:"CPU",
        AMIID:"AMI ID",
        VPCID:"VPC ID",
        EBSDevices:"EBS Devices",
        cache: "内存（GB）",
        diskStorage: "储存大小（GB）",
        T2T3Unlimited:"T2/T3无限",
        OperatingSystem:"操作系统",
        stateName:"状态名称",
        InstanceStatus:"实例状态",
        Project:"项目",
        Owner:"拥有者",
        SystemHealthStatus:"系统健康状态",
        InstanceHealthStatus:"实例健康状态",
        PublicIP:"公有IP",
        PrivateIP:"私有IP",
        SubnetID:"子网ID",
        CreationTime:"创建时间",
        SecurityGroupID:"安全组ID",
        SecurityGroupName:"安全组名称"
      },
      eks:{
        title:"EKS",
        name:"集群名称",
        version:"集群版本号",
        status:"集群状态",
        platformVersion:"平台版本号",
        createdAt:"集群的创建时间",
        endpoint:"终端节点",
        pointName:"节点组名称",
        releaseVersion:"AMI 发行版本",
        minSize:"最大大小",
        maxSize:"最小大小",
        amiType:"AMI 类型",
        diskSize:"磁盘大小"
      },
      emr:{
        title:"EMR",
        clusterId:"集群ID",
        name:"集群名称",
        status:"集群状态",
        logUrl:"日志URI",
        releaseLabel:"发行版标签",
        normalizedInstanceHours:"标准实例小时数",
        masterPublicDnsName:"主节点公有DNS",
        clusterArn:"集群ARN",
        creationDate:"集群创建时间",
      },
      tgw:{
        //tgw
        title:"TGW",
        name:"中转网关名称",
        transitGatewayId:"中转网关ID",
        description:"描述",
        ownerId:"拥有者ID",
        state:"状态",
        associationDefaultRouteTableId:"关联路由表ID",
        propagationDefaultRouteTableId:"传播路由表ID",
        creationTime:"创建时间",
        amazonSideAsn:"Amazon ASN",
        dnsSupport:"DNS 支持",
        vpnEcmpSupport:"VPN ECMP 支持",
        autoAcceptSharedAttachments:"自动接受共享挂载",
        defaultRouteTableAssociation:"原定设置关联路由表",
        multicastSupport:"多播支持",
        defaultRouteTablePropagation:"原定设置传播路由表",
        transitGatewayAttachmentId:"中转网关挂载ID",
        resourceType:"资源类型",
        resourceId:"资源ID",
        transitGatewaystate:"挂载状态",
        transitGatewayRouteTableId:"挂载关联路由表ID",
        associationState:"关联状态"
      },
      DedicatedHosting:{
      //专用主机
      title: "专用主机",
      accountID: "账户ID",
      accountName: "账户名称",
      region: "区域",
      name:"主机名称",
      hostId:"主机ID",
      availabilityZone:"可用区",
      state:"状态",
      instanceFamily:"实例系列",
      instanceType:"实例类型",
      },
      database: {
        //数据库
        title: "数据库",
        accountName: "账户名称",
        accountID: "账户ID",
        instanceName: "实例名称",
        terminalNode: "终端节点",
        engine: "引擎",
        instanceType: "实例类型",
        storageSize: "储存大小(G)",
        multipleAZ: "多可用区",
        maintenance: "维护",
        subnetGroup: "子网组",
        runningStatus: "运行状态",
        launchTime: "创建时间",
        backupPolicy: "备份策略",
        subnetID: "子网ID",
        region: "区域",
        iops: "IOPS",
      },
      VirtualNetwork: {
        //虚拟网络
        title: "虚拟网络",
        accountName: "账户名称",
        accountID: "账户ID",
        VPCName: "VPC名称",
        DHCPSettingSet: "DHCP选项集",
        routeTableId:"主路由表",
        defaultVPC: "默认VPC",
        runningStatus: "运行状态"
      },
      Elasticsearch: {
        //Elasticsearch
        region: "地区",
        title: "Elasticsearch",
        accountName: "账户名称",
        accountID: "账户ID",
        domainName: "域",
        elasticsearchVersion: "Elasticsearch 版本",
        volumeType: "卷类型",
        volumeSize: "卷大小",
        instanceType: "实例类型（数据）",
        instanceCount: "节点数",
        dedicatedMasterType: "实例类型（主实例）",
        dedicatedMasterCount: "主实例数"
      },
      ElasticBlockStorage: {
        //弹性快存储
        title: "弹性快存储",
        accountName: "账户名称",
        accountID: "账户ID",
        volumeName: "卷名称",
        volumeID: "卷id",
        volumeCapacity: "卷大小",
        volumeCategory: "卷类型",
        attachedStatus: "关联状态",
        attachedInstanceID: "关联实例ID"
      },
      ElasticLoadBalancer: {
        //弹性负载均衡
        title: "弹性负载均衡",
        accountName: "账户名称",
        accountID: "账户ID",
        ELBName: "ELB名称",
        DNSName: "DNS名称",
        availabilityZone: "可用区",
        instanceID: "实例ID",
        targetCluster: "目标群组",
        securityGroup: "安全组",
        pleaseEnterELBName: "请输入负载均衡名称"
      },
      StorageBin: {
        //储存桶
        title: "储存桶",
        accountName: "账户名称",
        accountID: "账户ID",
        binName: "桶名称",
        bucketStorage:"桶容量(GB)",
        launchTime: "创建时间",
        establishPerson: "创建人",
        bucketLogging: "是否开启访问日志",
        bucketLoggingUrl: "访问日志路径",
        binAuthorization: "桶权限",
        encryption: "加密",
        public: "公开",
        lifeCycle: "生命周期"
      },
      Redshift: {
        accountName: "账户名称",
        accountID: "账户ID",
        clusterName: "集群名称",
        clusterStatus: "集群状态",
        databaseStatus: "数据库状态",
        releaseStatus: "发行状态",
        maintain: "是否维护",
        nodeType: "节点类型",
        region: "区域",
        clusterSubnetGroup: "集群子网组",
        recentEventsAmount: "最近事件数",
        nodesAmount: "节点数",
        clusterParametersGroup: "集群参数组",
        subnet: "子网"
      },
      ElasticCache: {
        //弹性缓存
        memcachedTitle: "Memcached",
        redisTitle: "Redis",
        accountName: "账户名称",
        accountID: "账户ID",
        region: "区域",
        clusterName: "集群名称",
        statusName: "状态",
        createdTime: "创建时间",
        primaryEndpoint: "主终端节点",
        configurationEndpoint: "配置终端节点",
        engine: "引擎",
        nodeType: "节点类型",
        slice: "分片",
        multiAz: "多可用区",
        securityGroups: "安全组",
        NodeID:"节点ID",
        TerminalNode:"终端节点",
        Port:"端口",
        AvailabilityZone:"可用区",
        CurrentRole:"当前角色"
      },
      RI: {
        //预留实例
        EC2: {
          accountName: "账户名称",
          accountID: "账户ID",
          region: "区域",
          instanceType: "实例类型",
          start: "启动",
          overdue: "过期",
          due: "期限",
          paymentMethod: "付款方式",
          providedType: "提供的类型",
          platform: "平台",
          status: "状态",
          rentTime: "租期",
          instanceAmount: "实例数量",
          standardizeFactor: "标准化因子"
        },
        RDS: {
          accountName: "账户名称",
          accountID: "账户ID",
          region: "区域",
          reservedInstanceID: "预留实例ID",
          engine: "引擎",
          instanceType: "实例类型",
          paymentMethod: "付款方式",
          status: "状态",
          start: "启动",
          overdue: "过期",
          due: "期限",
          multipleAvailabilityZone: "多可用区",
          amount: "数量",
          standardizeFactor: "标准化因子"
        },
        ElasticCache: {
          accountName: "账户名称",
          accountID: "账户ID",
          region: "区域",
          reservedCacheNodeID: "预留缓存节点ID",
          productDescription: "产品描述",
          CacheNodeType: "缓存节点类型",
          productType: "产品类型",
          status: "状态",
          start: "启动",
          overdue: "过期",
          nodeAmount: "节点数量",
          due: "期限"
        },
        RedShift: {
          accountName: "账户名称",
          accountID: "账户ID",
          region: "区域",
          reservedNodeID: "预留节点ID",
          NodeType: "节点类型",
          productType: "产品类型",
          status: "状态",
          start: "启动",
          overdue: "过期",
          due: "期限",
          amount: "数量"
        },
        ElasticSearch: {
          name: "名称",
          id: "预留实例ID",
          accountName: "账户名称",
          accountID: "账户ID",
          region: "区域",
          reservedCacheNodeID: "预留缓存节点ID",
          productDescription: "产品描述",
          CacheNodeType: "实例类型",
          productType: "产品类型",
          status: "状态",
          start: "启动",
          overdue: "过期",
          nodeNumber: "节点数量",
          due: "期限"
        }
      },
      ElasticIP: {
        //弹性IP
        title: "弹性IP",
        accountName: "账户名称",
        accountID: "账户ID",
        ElasticIP: "弹性IP",
        allocatedID: "分配ID",
        privateIP: "私有IP",
        AttachedInstance: "关联实例"
      },
      routingTable: {
        //路由表
        title: "路由表",
        accountName: "账户名称",
        accountID: "账户ID",
        routingTableName: "路由表名称",
        routingTableID: "路由表ID",
        isMainRoutingTable: "是否是主路由表",
        ipAddress:"ip地址",
        instanceId:"指定实例id",
        gatewayId:"指定网关id",
        routeState:"路由状态"

      },
      Gateway: {
        //网关
        title: "网关",
        accountName: "账户名称",
        accountID: "账户ID",
        gatewayName: "网关名称",
        gatewayID: "网关ID",
        accountTypes: '账户类型',
      },
      Subnet: {
        //子网
        title: "子网",
        accountName: "账户名称",
        accountID: "账户ID",
        subnetName: "子网名称",
        subnetID: "子网ID",
        availabilityZone: "可用区",
        availableIP: "可用IP数"
      },
      SecurityGroup: {
        //安全组
        title: "安全组",
        accountName: "账户名称",
        accountID: "账户ID",
        securityGroupName: "安全组名称",
        securityGroupID: "安全组ID",
        protocolType: "协议类型",
        protocol: "协议",
        port: "端口",
        resource: "资源",
        accessRules: "类型"
      },
      Event: {
        // 事件
        title: "事件变更记录",
        accountName: "账号名称",
        accountID: "账号ID",
        region: "区域",
        resource: "资源",
        resourceId: "资源ID",
        instanceType: "实例类型",
        eventType: "事件类型",
        beforeChangeStatus: "变更前状态",
        afterChangeStatus: "变更后状态",
        eventTime: "事件时间"
      },
      IdentityAndAccessManagement: {
        //身份和访问管理
        title: "用户",
        accountName: "账户名称",
        accountID: "账户ID",
        userName: "用户名",
        group: "组",
        accessKeyAge: "访问密钥使用期限",
        passwordAge: "密码使用期限",
        lastActivity: "上一次活动",
        mfa: "MFA",
        policyName: "策略名称",
        policyTypeName: "策略类型",
        policyFrom: "策略附加"
      },
      IAM:{
        Group:{
          // 组
          title:"组",
          AccountName:"账户名称",
          AccountId:"账户Id",
          GroupName:"组名",
          NumberOfPeople:"人数",
          PolicyType:"策略类型",
          PolicyName:"策略名称",
          pleaseEnterGroupName: "请输入组名",
          pleaseEnterPolicyName: "请输入策略名称"
        },
        Policy:{
          // 策略
          title:"策略",
          AccountName:"账户名称",
          AccountId:"账户Id",
          PolicyName:"策略名称",
          PolicyType:"策略类型"
        },
        AKSK: {
          pleaseEnterIamUserName: "请输入AKSK用户名称",
          accountName: "账户名称",
          accountId: "账户Id",
          userName: "用户名",
          createDate: "创建时间",
          lastUsedDate: "最后使用时间",
          status: "状态"
        }
      },
      Backup:{
        Repository:{
          title:"备份保管库",
          backupVaultName:"备份保管库名称",
          numberOfRecoveryPoints:"恢复点",
          encryptionKeyArn:"KMS 加密密钥 ID",
          creationDate:"创建日期",
          recoveryPointArn:"恢复点ID",
          status:"状态",
          resourceArn:"资源ID",
          resourceType:"资源类型",
          deleteAfterDaysDesc:"保留期",
          moveToColdStorageAfterDaysDesc:"转为冷存储",
        },
        Plan:{
          title:"备份计划",
          backupPlanId:"备份计划ID",
          backupPlanName:"备份计划名称",
          lastExecutionDate:"上次运行时",
          creationDate:"上次修改时间",
          ruleName:"名称",
          targetBackupVaultName:"备份保管库",
          destinationBackupVaultArn:"目标备份保管库",
          selectionName:"名称",
          iamRoleArn:"IAM角色ARN",
          creationDate:"创建时间",
          backupPlanRule:"备份规则",
          resourceAllocation:"资源分配"
        }
      },
      DynamoDB: {
        partitionKey: '分区键',
        sortKey: '排序键',
        index: '索引',
        deleteProtection: '删除保护',
        readCapacity: '读取容量',
        readCapacityMode: '读取容量模式',
        writeCapacity: '写入容量',
        writeCapacityMode: '写入容量模式',
        totalSize: '总大小',
        listClass: '表类',
        projectionAttribute: '投影属性',
        numberOfEntries: '项目数'
      },
      ECR: {
        title: '弹性容器注册表',
        repositoryName: '存储库名称',
        enterRepositoryName: '请输入存储库名称',
        labelInvariance: '标签不变性',
        pushScan: '推送扫描',
        encryptionType: '加密类型',
        imageTag: '映像标签',
        componentType: '构件类型',
        pushPosition: '推送位置',
        size: '大小',
        imageURI: '映像URI',
        digest: '摘要',
        scanningState: '扫描状态',
        bug: '漏洞'
      },
      ECS: {
        title: '弹性容器服务',
        clusterName: '集群名称',
        enterClusterName: '请输入集群名称',
        service: '服务',
        task: '任务',
        running: '正在运行',
        containerInstance: '容器实例',
        monitoring: 'CloudWatch 监控',
        capacityProviderStrategy: '容量提供商策略',
        clusterDescription: '集群描述',
        serviceName: '服务名称',
        status: '状态',
        serviceType: '服务类型',
        rolloutState: '上次部署',
        taskDefinition: '任务定义',
        launchType: '启动类型',
        lastStatus: '最后状态',
        desiredStatus: '预期状态',
        runningState: '运行状态',
        startTime: '启动时间',
        memory: '内存(GB)',
        updateSuccess: '更新成功',
        pleaseWait: '正在导出，请稍等...',
        exportSuccess: '导出成功'
      },
      KMS: {
        aliases: '别名',
        enterAliases: '请输入密钥别名',
        keyId: '密钥ID',
        status: '状态',
        creationDate: '创建日期',
        dueDate: '到期日期',
        source: '来源',
        keyType: '密钥类型',
        keySpecification: '密钥规格',
        keyUsage: '密钥使用情况'
      },
      DMS: {
        serverlessReplications: '无服务器复制',
        replicationInstances: '复制实例',
        name: '名称',
        type: '类型',
        sourceEndpoint: '源端点',
        targetEndpoint: '目标端点',
        created: '创建时间',
        enterName: '请输入名称',
        class: '类',
        engineVersion: '引擎版本',
        availabilityZone: '可用区',
        publicIPAddress: '公有IP地址',
        privateIPAddress: '私有IP地址',
        multiAZ: '多可用区'
      },
      natGateway: {
        title: 'NAT网关',
        region: '区域',
        name: '网关名称',
        natGatewayId: 'NAT网关ID',
        status: '状态',
        elasticIpAddress: '弹性IP地址',
        privateIpAddress: '私有IP地址',
        networkInterfaceId: '网络接口ID',
        subnet: '子网',
        creationTime: '创建时间'
      },
      EBSSnapshot: {
        title: 'ebs快照',
        snapshotName: '快照名称',
        snapshotId: '快照ID',
        size: '大小',
        status: '状态',
        encryption: '加密',
        associatedVolumeId: '关联卷ID',
        startTime: '启动时间'
      },
      ec2Search: {
        conditionName: '条件名称',
        conditionValue: '条件值',
        conditionSelected: '你已选择该条件名称'
      },
      reservedInstanceTag: {
        configTag: '配置标签',
        tagKey: '标签键',
        tagValue: '标签值',
        addTag: '添加标签',
        selectTagKey: '请选择标签键',
        enterTagValue: '请输入标签值',
        tagValuePattern: '标签值前后不能有特殊字符和空格',
        submitSuccess: '提交成功',
        submitFail: '提交失败',
        oneYear: '一年',
        threeYears: '三年'
      },
      export: {
        virtualNetwork: '虚拟网络.xls',
        subnet: '子网.xls',
        securityGroup: '安全组.xls',
        storageBucket: '存储桶.xls',
        routeTable: '路由表.xls',
        database: '数据库.xls',
        natGateway: 'NAT网关列表.xls',
        gateway: '网关.xls',
        eventRecord: '资源变更记录.xls',
        elasticLoadBalancer: '弹性负载均衡.xls',
        elastiCacheRedis: '弹性缓存-Redis.xls',
        elastiCacheMemcached: '弹性缓存-Memcached.xls',
        elasticIP: '弹性IP.xls',
        computeInstance: '计算实例.xls',
        ebsSnapshot: 'ebs快照.xls',
        elasticBlockStorage: '弹性块存储.xls',
        dedicatedHosting: 'AWS专用主机.xls',
        backupRepository: '备份保管库.xls',
        backupPlan: '备份计划.xls',
        riRedshift: 'Redshift预留实例.xls',
        riRds: 'RDS预留实例.xls',
        riElasticsearch: 'Elasticsearch预留实例.xls',
        riElastiCache: 'ElastiCache预留实例.xls',
        riEc2: 'EC2预留实例.xls'
      }
    },
    Azure: {
      VirtualMachine: {
        //虚拟机
        title: "虚拟机",
        accountName: "账户名",
        subscriptionName: "订阅名称",
        subscriptionID: "订阅ID",
        resourceGroup: "资源组",
        instanceName: "实例名称",
        instanceType: "实例类型",
        cache: "内存(GB)",
        diskStorage: "磁盘容量(GB)",
        operatingSystem: "操作系统",
        instanceStatus: "实例状态",
        project: "项目",
        owner: "拥有者",
        publicIP: "公有IP",
        privateIP: "私有IP",
        virtualNetworkAndSubnet: "虚拟网络/子网",
        NetworkSecurityGroup: "网络安全组"
      },
      database: {
        //数据库
        title: "数据库",
        accountName: "账户名称",
        subscriptionName: "订阅名称",
        subscriptionID: "订阅ID",
        resourceGroup: "资源组",
        databaseName: "数据库名称",
        serverName: "服务器名称",
        location: "位置",
        status: "状态",
        connectionString: "连接字符串",
        pricingLevel: "定价层"
      },
      VirtualNetwork: {
        //虚拟网络
        title: "虚拟网络",
        accountName: "账户名称",
        subscriptionName: "订阅名称",
        subscriptionID: "订阅ID",
        resourceGroup: "资源组",
        VPCName: "VPC名称",
        location: "位置",
        addressSpace: "地址空间"
      },
      trusteeDisk: {
        //托管磁盘
        title: "托管磁盘",
        accountName: "账户名称",
        subscriptionName: "订阅名称",
        subscriptionID: "订阅ID",
        resourceGroup: "资源组",
        diskConfig: "磁盘设置",
        status: "状态",
        owner: "所有者",
        operatingSystem: "操作系统",
        launchTime: "创建时间"
      },
      storageAccount: {
        //存储账户
        title: "存储账户",
        storageAccountName: "存储账户名",
        accountName: "账户名称",
        subscriptionName: "订阅名称",
        subscriptionID: "订阅ID",
        resourceGroup: "资源组",
        performance: "性能",
        status: "状态",
        duplicationAndRedundant: "复制/冗余",
        accountType: "账户类型"
      },
      appService:{
        title:"应用程序服务",
        AccountName:"账户名",
        AccountID:"账户ID",
        SubscriptionName:"订阅名称",
        SubscriptionID:"订阅ID",
        ResourceGroup:"资源组",
        Name:"名称",
        Area:"地区",
        Status:"状态",
        Type:"类型",
        ServerFarm:"服务器群"
      },
      loadBalance:{
        title:"负载均衡",
        AccountName:"账户名",
        AccountID:"账户ID",
        SubscriptionID:"订阅ID",
        Name:"名称",
        ResourceGroup:"资源组",
        Area:"地区",
        BackendPool:"后端池",
        HealthDetection:"运行状况探测",
        LoadBalancingRules:"负载均衡规则",
        DedicatedIPAddress:"专用IP地址",
        SKU:"SKU"
      }
    },
    ALI:{
      computeInstance: {
        //计算实例
        title: "计算实例",
        accountID: "账户ID",
        accountName: "账户名称",
        region: "区域",
        instanceName: "实例名称",
        instanceID: "实例ID",
        instanceType: "实例类型",
        cache: "内存（GB）",
        diskStorage: "储存大小（GB）",
        ImageId:"ImageID(镜像ID)",
        amazonVpcId:"VPC ID",
        OperatingSystem:"操作系统",
        InstanceStatus:"实例状态",
        Project:"项目",
        Owner:"拥有者",
        PublicIP:"公有IP",
        PrivateIP:"私有IP",
        InstanceCreatedTime:"创建时间",
      },
      database: {
        //数据库
        title: "数据库",
        accountName: "账户名称",
        accountID: "账户ID",
        engine: "引擎",
        name:"实例名称",
        instanceType: "实例类型",
        storageSize: "储存大小(G)",
        stateName: "运行状态",
        databaseCreatedTime: "创建时间",
        version:"数据库版本",
        nodeNumber:"节点数量",
        endpoint:"终端节点",
        maintenance: "维护",
        region: "区域",
        iops: "IOPS",
      },
      ElasticBlockStorage: {
        //弹性块存储
        title: "弹性块存储",
        accountName: "账户名称",
        accountID: "账户ID",
        cloudStorageName: "云盘名称",
        searchByCloudStorageName: "请输入云盘名称",
        cloudStorageID: "云盘id",
        cloudStorageCapacity: "盘大小",
        cloudStorageCategory: "盘类型",
        attachedStatus: "关联状态",
        attachedInstanceID: "关联实例ID"
      },
      ElasticIP: {
        //弹性公网IP
        title: "弹性公网IP",
        accountName: "账户名称",
        accountID: "账户ID",
        ElasticIP: "弹性IP",
        allocatedID: "分配ID",
        privateIP: "私有IP",
        AttachedInstance: "关联实例",
        searchByElasticIP: "请输入弹性公网IP"
      },
      ElasticLoadBalancer: {
        //弹性负载均衡
        title: "弹性负载均衡",
        accountName: "账户名称",
        accountID: "账户ID",
        ELBName: "负载均衡名称",
        DNSName: "DNS名称",
        loadbalancerType:"负载均衡类型",
        instanceID: "实例ID",
        region: "地区",
        stateName: "运行状态"
      },
      Redis:{
        //Redis
        title:"Redis",
        instanceId:"实例ID",
        instanceName:"实例名称",
        connectionDomain:"内网连接地址",
        instanceStatus:"实例状态",
        instanceClass:"实例类型",
        engineVersion:"引擎版本",
        architectureType:"架构类型"
      },
      Vpc:{
        title:"虚拟网络",
        name:"VPC名称",
        id:"VPC ID",
        Cidr:"VPC CIDR",
        region:"区域",
        defaultVpc:"默认VPC",
        stateName:"运行状态",
      },
      Oss:{
        title:"存储桶",
        name:"OSS名称",
        creationDateString:"创建时间",
        displayName:"创建人",
        extranetEndpoint:"外网域名",
        intranetEndpoint:"内网域名",
        displayId:"OSS权限",
        access:"读写权限",
        defaultEncryption:"加密",
      },
      NatGateway:{
        title:"NAT网关",
        natGatewayId:"NAT网关ID",
        state:"状态",
        publicIp:"公有IP",
        privateIp:"私有IP",
        vpcId:"VPC",
        createTime:"创建时间",
        name:"网关名称"
      },
      Ack: {
        ackTitle: "Ack",
        accountID: "账户ID",
        accountName: "账户名称",
        region: "区域",
        accountType:"账号类型",
        clusterId:"集群ID",
        clusterName:"集群名称",
        clusterType:"集群类型",
        profile:"集群标识",
        clusterSpec:"托管版集群类型",
        vpcId:"集群专有网络ID",
        size:"集群当前节点数量",
        state:"集群运行状态",
        created:"集群创建时间",
        updated:"集群更新时间"
      },
      AutoScaling:{
        title:"弹性伸缩",
        accountType:"账号类型",
        scalingGroupId:"弹性伸缩组id",
        scalingGroupName:"弹性伸缩组name",
        groupType:"实例类型",
        totalInstanceCount:"所有ECS实例的数量",
        lifecycleState:"状态信息",
        minSize:"ECS实例台数的最小值",
        maxSize:"ECS实例台数的最大值",
        groupModificationTime:"修改时间",
        isActive:"当前数据行是否有效",
      },
      Sls:{
        title:"sls",
        accountTypeName:"账户类型",
        logstoreName:"日志库名称",
        projectName:"项目名称",
      },
      ClickHouse:{
        title:"ClickHouse",
        accountID: "账户ID",
        accountName: "账户名称",
        region: "区域",
        accountType:"账号类型",
        filterByClusterId: "请输入集群ID",
        clusterId:"集群ID",
        nodeCount:"节点数量",
        storageType:"存储类型",
        nodeStorage:"存储空间(GB)",
        nodeClass:"集群规格",
        clusterStatus:"集群状态",
        controlVersion:"版本号",
        createTime:"创建时间"
      },
      Waf:{
        title:"Web应用防火墙",
        accountID: "账户ID",
        accountName: "账户名称",
        region: "区域",
        accountType:"账号类型",
        instanceId:"实例ID",
        statusName:"是否过期",
        versionName:"版本"
      },
      Cen:{
        //Cen
        title:"Cen",
        cenId:"实例ID",
        name:"实例名称",
        description:"描述",
        status:"实例状态",
        ipv6Level:"开启IPv6",
        protectionLevel:"网段重叠级别",
        resourceGroupId:"资源组ID",
        creationTime:"创建时间",
      },
      Kafka:{
        title:"消息队列Kafka",
        accountIdString:"账号ID",
        accountName:"账号Name",
        region: "区域",
        instanceId:"实例ID",
        name:"实例name",
        serviceStatusStr:"实例状态",
        vpcId:"VPC ID",
        specType:"实例规格",
        deployTypeStr:"部署类型",
        diskTypeStr:"磁盘类型",
        diskSize:"磁盘容量",
        createTimeStr:"创建时间"
      },
      ReservedInstances:{
        title:"ECS预留实例券",
        reservedInstanceId: "预留实例劵ID",
        name : "名称",
        platform : "操作系统",
        instanceType : "实例规格",
        status : "状态",
        creationTime : "创建时间",
        expiredTime : "到期时间",
        instanceAmount : "实例数量"
      }
    },
    GCP:{
      computeInstance: {
        //计算实例
        Project:"项目",
        Owner:"拥有者",
        project: '项目',
        owner: '所有者',
      },
      ElasticBlockStorage: {
        //弹性快存储
        awsZone:"可用区",
        region:"区域",
        encrypted:"是否加密",
        accountName:"账户名称",
        accountIdString:"账户id",
        name:"磁盘名称",
        volumeAwsId:"磁盘id",
        capacity:"存储",
        type:"磁盘类型",
        stateName:"状态",
      },
      RelationalDataBaseResource:{
        //数据库
        name:"数据库名称",
        endpoint:"连接名称",
        type:"类型",
        project:"项目",
        backupPolice:"备份策略",
        filterByInstanceName:"请输入数据库名称",
        type:"类型"
      },
      ElasticLoadBalancer:{
       //负载均衡
       region:"区域",
       accountTypeName:"账户类型",
       stateName:"状态"
      },
      CloudStorageGcp:{
        //CloudStorage
        title:"CloudStorage",
        accountType:"账户类型",
        location:"资源地址",
        projectId:"资源所属项目",
        name:"资源名称",
        metaGeneration:"bucket元数据",
        storageClass:"存储类型",
        timeCreated:"创建时间",
        isActive:"是否有效"
      },
      Redis:{
        projectId:"projectId",
        instanceName:"实例名称",
        cacheClusterId:"节点名称",
        version: '版本号',
        cache:'内存大小',
        timeCreated:'创建时间',
        state:"状态",
      },
      BigQuery:{
        title:"BigQuery",
        datasetName:"数据集名称",
        datasetId:"数据集ID",
        projectId:"项目id",
        datasetCreatedTime:"创建时间",
        filterByDatasetId:"请输入数据集ID",
      },
      Kubernetes:{
        title: "GKE",
        name: "集群名称",
        initialClusterVersion: "集群初始版本",
        currentMasterVersion: "当前集群主节点版本",
        currentNodeVersion: "当前节点版本",
        currentNodeCount: "当前节点数量",
        network: "网络名称",
        subnetWork: "子网名称",
        status: "集群状态",
        nodeName:"节点名称",
        nodeLocations:"节点可用区",
        nodeMachineType:"节点的机器类型",
        nodeDiskSize:"磁盘大小",
        nodeImageType:"镜像类型",
        nodeDiskType:"磁盘类型",
        nodeInitialNodeCount:"初始节点数量",
        nodeVersion:"版本",
        nodeStatus:"节点状态",
      },
      FileStore:{
        title: "文件存储",
        filterByGFilestoreName: "请输入文件存储名称",
        accountName:"账户名称",
        accountIdString:"账户ID",
        region:"区域",
        name:"文件存储名称",
        description:"描述",
        state:"运行状态",
        capacity:"容量",
        tier:"实例服务层",
        projectId:"项目ID",
        filestoreCreatetime:"创建时间"
      },
      loggingstored:{
        title:"日志存储",
        accountName:"账户名称",
        accountID:"账户ID",
        location:"区域",
        projectId:"项目ID",
        name:"名称",
        description:"说明",
        retentionDays:"保留期限",
        locked:"状态",
        createTime:"创建时间",
      },
      loggingroute:{
        title:"日志路由",
        accountName:"账户名称",
        accountID:"账户ID",
        location:"区域",
        projectId:"项目ID",
        name:"名称",
        description:"说明",
        type:"类型",
        destination:"目标位置",
        createTime:"创建时间",
      },
      common:{
        location: "区域",
        projectId: "项目ID"
      }
    },
    // 华为云
    HWC: {
      ECS: {
        title: "云服务器",
        accountID: "账户ID",
        accountName: "账户名称",
        region: "区域",
        instanceName: "实例名称",
        instanceID: "实例ID",
        instanceType: "实例类型",
        state: "运行状态",
        diskStorage: "储存大小（GB）"
      },
      RDS: {
        title: "云数据库",
        accountID: "账户ID",
        accountName: "账户名称",
        region: "区域",
        instanceName: "实例名称",
        instanceID: "实例ID",
        engineVersion: "引擎版本",
        state: "运行状态",
        instanceType: "实例类型"
      },
      EVS: {
        title: "云磁盘",
        diskName: "磁盘名称",
        diskID: "磁盘ID",
        diskType: "磁盘类型",
        state: "状态",
        diskStorage: "磁盘大小（GB）",
        encryption: "加密"
      },
      OBS: {
        title: "对象存储",
        bucketName: "桶名称",
        storageType: "存储类别",
        bucketStorage: "桶容量",
        objectCount: "对象数量",
        createTime: "创建时间"
      }
    },
    // 腾讯云
    TENCENT: {
      CVM: {
        title: "云服务器",
        accountName: "账户名称",
        instanceId: "实例ID",
        name: "实例名称",
        region: "区域",
        instanceType: "规格",
        cpu: "CPU核数",
        ram: "内存(GB)",
        os: "操作系统",
        stateName: "状态",
        publicIp: "公网IP",
        privateIp: "私有IP",
        instanceCreatedTime: "创建时间"
      },
      CDB: {
        title: "云数据库MySQL",
        accountName: "账户名称",
        instanceId: "实例ID",
        name: "实例名称",
        region: "区域",
        engine: "引擎",
        engineVersion: "版本",
        cpu: "CPU核数",
        memory: "内存(MB)",
        volume: "磁盘(GB)",
        statusName: "状态",
        vip: "内网IP",
        vport: "端口",
        instanceCreatedTime: "创建时间"
      },
      POSTGRES: {
        title: "云数据库PostgreSQL",
        accountName: "账户名称",
        instanceId: "实例ID",
        name: "实例名称",
        region: "区域",
        engine: "引擎",
        engineVersion: "版本",
        cpu: "CPU核数",
        memory: "内存(MB)",
        volume: "磁盘(GB)",
        statusName: "状态",
        vip: "内网IP",
        vport: "端口",
        instanceCreatedTime: "创建时间"
      },
      REDIS: {
        title: "云数据库Redis",
        accountName: "账户名称",
        instanceId: "实例ID",
        instanceName: "实例名称",
        region: "区域",
        zone: "可用区",
        statusName: "状态",
        vip: "内网IP",
        port: "端口",
        size: "容量(MB)",
        productType: "产品类型",
        engineVersion: "版本",
        createTime: "创建时间"
      },
      CBS: {
        title: "云硬盘",
        accountName: "账户名称",
        diskId: "云硬盘ID",
        diskName: "名称",
        region: "区域",
        diskType: "类型",
        diskSize: "大小(GB)",
        stateName: "状态",
        instanceId: "挂载实例ID",
        createdTime: "创建时间"
      },
      CLB: {
        title: "负载均衡",
        accountName: "账户名称",
        loadBalancerId: "CLB ID",
        name: "名称",
        region: "区域",
        vip: "VIP地址",
        statusName: "状态",
        type: "类型",
        createdTime: "创建时间"
      },
      COS: {
        title: "对象存储",
        accountName: "账户名称",
        bucketName: "存储桶名称",
        region: "区域"
      },
      VPC: {
        title: "私有网络",
        accountName: "账户名称",
        vpcId: "VPC ID",
        vpcName: "名称",
        cidrBlock: "CIDR",
        region: "区域"
      },
      SUBNET: {
        title: "子网",
        accountName: "账户名称",
        subnetId: "子网ID",
        subnetName: "名称",
        vpcId: "VPC ID",
        cidrBlock: "CIDR",
        availableIpCount: "可用IP数",
        region: "区域"
      },
      SG: {
        title: "安全组",
        accountName: "账户名称",
        securityGroupId: "安全组ID",
        securityGroupName: "名称",
        description: "描述",
        region: "区域"
      },
      EIP: {
        title: "弹性IP",
        accountName: "账户名称",
        addressId: "EIP ID",
        addressIp: "IP地址",
        statusName: "状态",
        instanceId: "绑定实例ID",
        region: "区域"
      }
    },
    // 资源配置导出文件名（多云厂商）
    export: {
      computeInstance: '计算实例.xls',
      database: '数据库.xls',
      virtualNetwork: '虚拟网络.xls',
      elasticBlockStorage: '弹性块存储.xls',
      elasticLoadBalancer: '弹性负载均衡.xls',
      aliElasticIP: '弹性公网IP.xls',
      aliAutoScaling: '弹性伸缩.xls',
      azureVirtualMachine: '虚拟机.xls',
      azureStorageAccount: '存储账户.xls',
      azureLoadBalance: '负载均衡.xls',
      azureTrusteeDisk: '托管磁盘.xls',
      azureAppService: '应用程序服务.xls',
      gcpLogRoute: '日志路由.xls',
      gcpLogStored: '日志存储.xls',
      hwcCloudServer: '云服务器.xls',
      hwcCloudDatabase: '云数据库.xls',
      hwcCloudDisk: '云磁盘.xls',
      hwcObjectStorage: '对象存储.xls',
      tencentCvm: '腾讯云服务器.xls',
      tencentCdb: '腾讯云数据库MySQL.xls',
      tencentPostgres: '腾讯云数据库PostgreSQL.xls',
      tencentRedis: '腾讯云数据库Redis.xls',
      tencentCbs: '腾讯云硬盘.xls',
      tencentClb: '腾讯负载均衡.xls',
      tencentCos: '腾讯对象存储.xls',
      tencentVpc: '腾讯私有网络.xls',
      tencentSubnet: '腾讯子网.xls',
      tencentSg: '腾讯安全组.xls',
      tencentEip: '腾讯弹性IP.xls',
      subnet: '子网.xls',
      securityGroup: '安全组.xls',
      gateway: '网关.xls',
      natGateway: 'NAT网关列表.xls',
      eventRecord: '资源变更记录.xls',
      storageBucket: '存储桶.xls',
      routeTable: '路由表.xls',
      elastiCacheRedis: '弹性缓存-Redis.xls',
      elastiCacheMemcached: '弹性缓存-Memcached.xls',
      elasticIP: '弹性IP.xls',
      ebsSnapshot: 'ebs快照.xls',
      dedicatedHosting: 'AWS专用主机.xls',
      backupRepository: '备份保管库.xls',
      backupPlan: '备份计划.xls',
      riRedshift: 'Redshift预留实例.xls',
      riRds: 'RDS预留实例.xls',
      riElasticsearch: 'Elasticsearch预留实例.xls',
      riElastiCache: 'ElastiCache预留实例.xls',
      riEc2: 'EC2预留实例.xls',
    },
    // 资源配置管理通用项
    common:{
      update:'更新',
      multiLineExport:'多行导出',
      filterByAccountName:'请输入账户名称',
      filterByLoadName:'请输入负载均衡名称',
      filterByResourceName: '请输入资源名称',
      QuerybyInstanceID:'请输入实例ID',
      QuerybyInstanceName:'请输入实例名称',
      QuerybyPublicIP:'请输入公有IP',
      QueryByTgwId:"请输入中转网关ID",
      QueryByBackupVaultName:"请输入备份保管库名称",
      QueryByBackupPlanName:"请输入备份计划名称",
      PleaseSelectCompany:'请选择公司',
      SearchbyEngine:'请输入引擎',
      QuerybyInstanceType:'请输入实例类型',
      FilterbyOperatingStatus:'请输入运行状态',
      QuerybyBucketName:'请输入桶名称',
      QuerybyClusterName:'请输入集群名称',
      PleaseSelectAccount:'请选择账号',
      PleaseSelectRegion:'请选择区域',
      PleaseEnterAccountID:'请输入账户ID',
      PleaseEnterAccount:'请选择账户',
      PleaseChoosePaymentMethod:'请选择付款方式',
      PleaseSelectStatus:'请选择状态',
      PleaseSelectExpirationTime:'请选择到期时间',
      PleaseEnterEngine:'请输入引擎',
      PleaseSelectEngine:'请选择引擎',
      PleaseSelectProductType:'请选择产品类型',
      QuerybySubnetID:'请输入子网ID',
      QuerybySecurityGroupID:'请输入安全组ID',
      PleaseSelectResourceType:'请选择资源类型',
      PleaseSelectEventType:'请选择事件类型',
      PleaseSelectTimeRange:'请选择时间范围',
      DomainName:'域名称',
      QuerybyStorageAccountName:'请输入存储账户名',
      QuerybyResourceGroup:'请输入资源组',
      PleaseSelectTagValue:'请输入标签值',
      company:'公司',
      pleaseEnterAccount:'请输入账户',
      QueryByNatGatewayId:'按NAT网关ID查询',
      QueryBySnapshotId:'按快照ID查询',
      exportConfirm:'导出确认',
      exportTagsQuestion:'是否需要导出资源的标签?'
    }
  },
  //审批任务
  ApprovalTask: {
    title: "审批任务",
    approvalFlowName: "审批流名称",
    submitter: "提交人",
    category: "类型",
    status: "状态",
    launchTime: "创建时间",
    processing: '处理中',
    passed: '已通过',
    rejected: '已驳回',
    expired: '已失效',
    selectByCompany: '请选择公司',
    selectByType: '请输入类型',
    selectAll: '全部',
    processInformation: '流程信息',
    approvalStatus: '审批状态',
    startTime: '开始时间',
    endTime: '结束时间',
    view: '查看',
    dealwith: '处理',
    reservedInstancePurchase: '预留实例购买',
    associatedCaseID: '关联案例ID',
    contentOfTheParentNode: '上级节点内容',
    matchType: '匹配类型',
    purchaseList: '购买清单',
    reservedInstancePurchaseList: '预留实例购买清单',
    tip: '您目前自定义购买的RI数量是少于系统建议的到期RI购买数量的，在您保存并审批该自定义购买后，系统在实际购买前将自动不会对该批RI中未购买的部分进行告警，除非在实际购买前您需要购买的RI数量发生了变化。如果在实际购买前您需要购买的RI数量发生了变化的情况，系统将自动产生一个新的审批任务，并同时删除当前已经被审批完成的任务。',
    rawData: '原始数据',
    standardizedQuantity: '标准化数量',
    accountName: '账户名称',
    accountId: '账号ID',
    region: '区域',
    instanceCount: '数量',
    normalizationFactor: '标准化数量',
    actualPurchasedQuantity: '建议购买数量',
    instanceType: '预留实例类型',
    price: 'RI价格',
    productDescription: '产品描述',
    instanceTenancy: '租赁类型',
    offeringType: '付费方式',
    offeringClass: '提供的类别',
    endDate: '到期时间',
    duration: '时间期限',
    stepDescription: '这里是该步骤的描述信息',
    shouldBeLessThanCurrentQuantity: '应≤当前数量',
    shouldBeLessThanCurrentStandardizedQuantity: '应≤当前标准化数量',
    verificationFailed: '验证失败',
    pleaseEnterNumber: '请输入数字',
    shouldBeGreaterThan1: '应大于1',
    riPriceModifiedSuccess: 'RI价格修改成功',
    dealwithDetail: {
      loadBalancerNotAttachedDetail: '负载均衡器未关联实例详情',
      deleteELBNotAttached: '删除ELB未关联实例',
      instanceNotAttachedDiskDetail: '实例未关联磁盘详情',
      deleteInstanceNotAttachedDisk: '删除实例未关联磁盘',
      whetherMustBackup: '是否必须备份',
      whetherMustBackupColon: '是否必须备份:',
      elasticIPNotAttachedDetail: '弹性IP未关联实例详情',
      deleteElasticIPNotAttached: '删除弹性IP未关联实例',
      nextStep: '下一步',
      whetherToBuy: '是否购买',
      reasonForNotBuying: '不购买原因',
      approval: '审批',
      approvalResult: '审批结果',
      pass: '通过',
      reject: '驳回',
      returnToParentNode: '返回上级节点',
      reason: '原因',
      previousStep: '上一步',
      submit: '提交',
      selectApprovalResult: '请选择审批结果',
      enterReason: '请输入原因',
      maxChars100: '最多输入100个字符',
      approvalSuccess: '审批成功',
      approvalFail: '审批失败'
    }
  },
  AlertConfigManagement: {
    //报警配置管理
    CostomizedAlarm: {
      //自定义报警配置
      isAccountGroup: "是否为账户组",
      AccountGroupName: "账户组名称",
      status: "状态"
    }
  },
  BSH: {
    resourceGroup: "资源组",
    resourceGroupName: "资源组名称",
    account: "账户",
    region: "区域",
    tagKey: "标签关键字",
    tagValue: "标签值",
    searchTagKey: "请输入标签关键字",
    searchTagValue: "请输入标签值",
    searchResourceGroupName: "请输入资源组名称",
    add: "新增",
    basicInfo: "基本信息",
    companyName: "公司名",
    resourceAllocation: "资源分配",
    uniqueIdentifierOfResource: "资源唯一标识符",
    searchUniqueIdentifierOfResource: "请输入资源唯一标识符",
    alarmConfiguration: "告警配置",
    pleaseSelectNotificationObject: "请选择通知对象",
    pleaseSelectAlarmType: "请选择报警方式",
    pleaseSelectAlarmDelay: "请选择延迟告警",
    monitoringState: "监控状态",
    monitorIndexName: "指标名称"
  },
  MCM: {
    //MaintenanceConfigManagement
    //运维配置管理
    dutyManagement: {
      //值班管理
      title: "值班管理",
      editDuty: "编辑值班",
      name: "姓名",
      pleaseSelectName: "请选择姓名",
      dutyType: "值班类型",
      pleaseSelectDutyType: "请选择值班类型",
      dutyTime: "值班时间",
      pleaseSelectDutyTime: "请选择值班时间",
      comment: "备注",
      operation: "操作",
      addDuty: "添加值班",
      priority: "排班优先级",
      pleaseSelectPriority: "请选择排班优先级",
      dayShift: "白班",
      nightShift: "夜班"

    },
    extraContributionManagement: {
      //额外贡献管理
      title: "额外贡献管理",
      editExtraContribution: "编辑额外贡献",
      name: "姓名",
      attachment: "附件",
      attachmentList: "附件列表",
      PleaseSelectName: "请选择姓名",
      extraContributionTime: "额外贡献时间",
      additionalContributionStatistics: "额外贡献统计",
      pleaseEnterExtraContributionTime: "请输入额外贡献时间",
      extraContributionDate: "额外贡献年月",
      pleaseSelectExtraContributionDate: "请选择额外贡献年月",
      description: "描述",
      pleaseEnterDescription: "请输入描述",
      EnterMaximumOfCharacters: "最多输入10000个字符",
      operation: "操作",
      addExtraContribution: "添加额外贡献",
      addExtraContributionAttachment: "添加额外贡献附件",
      filename: "文件名",
      fileType: "文件类型",
      saveAddress: "保存地址",
      PleaseSelectTheFileToUpload: "请选择要上传的文件"

    },
    automaticalMaintenanceReport: {
      //自动化运维报告
      title: "自动化运维报告",
      companyName: "公司名称",
      pleaseSelectCompany: "请选择公司",
      account: "账户",
      pleaseSelectAccount: "请选择账号",
      filterByAccount: "请输入账号",
      month: "月份",
      pleaseSelectMonth: "请选择月份",
      region: "区域",
      pleaseSelectRegion: "请选择区域",
      config: "配置",
      operation: "操作",
      add: "添加",
      edit: "编辑",
      preview: "预览",
      reportConfig: "报告配置"

    },
    msg: {
      //提示信息
      updateSuccessExclam: "更新成功!",
      dutyRepeat: "姓名、值班类型、值班时间、排班优先级不能重复不能重复!",
      contributionRepeat: "姓名、额外贡献年月不能重复!"
    },
    exportFile: {
      //导出文件名
      operationDuty: "运维值班.xls",
      operationContribution: "运维额外贡献.xls"
    },
    reportConfiguration: {
      //报告配置
      title: "自动化运维报告",
      financialOptimization: "财务优化",
      resourceOptimization: "资源优化",
      operationMaintenance: "运维工作",
      majorEvent: "重大事件",
      add: "添加",
      customize: "自定义",
      cancel: "取消",
      update: "更新",
      //财务优化
      monthlyAccountAnalysis: "月度账务分析",
      billCompareText: "从上图可以看到总体费用（这里的金额单位都是人民币）相对{month}月份账单{result}{ratio}%",
      fillReason: "填写原因",
      riRecommendCostComparison: "预留实例推荐花费对比",
      reservedInstanceMatchText: "贵公司账户购买了{count}台预留实例,经过后台检测,目前全部匹配,详情如下",
      annualMonthlyExpenses: "年度每月花费",
      monthlyExpenses: "月度花费",
      fallingUp0: "上升",
      fallingUp1: "下降",
      //列名
      accountId: "账号ID",
      accountName: "账号名称",
      accountGroupName: "账户组名称",
      instanceTenancy: "租赁类型",
      productDescription: "实例系统",
      instanceType: "实例类型",
      recommendBuyRI: "推荐购买RI(单位:台)",
      onDemandCost: "按需年度花费",
      noUpfrontCost: "无前期RI年度花费",
      partUpfrontCost: "部分前期RI年度花费",
      allUpfrontCost: "全部前期年度花费",
      totalBuyRI: "总共购买RI(单位:台)",
      unmatchRI: "未匹配RI(单位:台)",
      //资源优化
      ec2OptimizeSuggestion: "EC2优化建议",
      rdsOptimizeSuggestion: "RDS优化建议",
      costComparison: "降级前后花费对比",
      optimizeSuggestion: "优化建议",
      instanceName: "实例名称",
      cpuUtilization: "CPU使用率",
      memoryUtilization: "内存使用率",
      databaseName: "数据库名称",
      databaseInstanceType: "数据库实例类型",
      freememory: "剩余内存(MB)",
      freeDisk: "剩余磁盘(GB)",
      optimizeType: "优化类型",
      resourceBefore: "实例调整前",
      resourceAfter: "实例调整后",
      unitPriceBefore: "调整前单价",
      unitPriceAfter: "调整后单价",
      saveCost: "可节省花费",
      //运维工作
      operationEvents: "本月运维事件",
      eventsPending: "上月待处理事件",
      eventsPendingText: "根据上月度运维报告,贵公司还有部分优化事件待处理,如下",
      time: "时间",
      level: "级别",
      eventDescribe: "事件描述",
      eventProgress: "事件进度",
      pendingEvent: "待优化事件",
      belongType: "所属类型",
      problemReason: "问题原因",
      responseTime: "响应时间",
      solutionTime: "解决时间",
      second: "秒",
      problemType: "问题类型",
      pleaseSelectTime: "请选择时间",
      pleaseSelectLevel: "请选择级别",
      pleaseSelectProblemType: "请选择问题类型",
      pleaseSelectEventProgress: "请选择事件进度",
      pleaseEnterEventDescribe: "请输入事件描述",
      maxCharacters: "最多输入10000个字符",
      pleaseEnterResponseTime: "请输入响应时间",
      pleaseEnterSolutionTime: "请输入解决时间",
      //重大事件
      majorEventTitle: "重大事件",
      subject: "主题",
      problemDescribe: "问题描述",
      eventProgressDetail: "事件进展",
      eventResult: "事件结果",
      pleaseEnterSubject: "请输入主题",
      pleaseEnterProblemDescribe: "请输入问题描述",
      pleaseEnterEventProgress: "请输入事件进展",
      pleaseEnterEventResult: "请输入事件结果",
      //展示用枚举(预览页只读展示)
      upgrade: "升级",
      downgrade: "降级",
      ticketCat0: "基础架构告警事件",
      ticketCat1: "安全告警事件",
      ticketCat2: "账单告警事件",
      ticketCat4: "公司贡献",
      ticketCat5: "变更请求",
      ticketCat6: "定时任务管理",
      ticketCat7: "服务申请"
    },
    preview: {
      //报告预览
      close: "关闭",
      print: "打印",
      reportTitleSuffix: "{year}年{month}月AWS运维报告",
      ver: "ver 3.0",
      //目录
      contentsWorkSummary: "工作总结",
      contents11: "1.1事件分析",
      contents111: "1.1.1事件处理",
      contents112: "1.1.2月度告警分析",
      contents113: "1.1.3事件SLA分析",
      contents12: "1.2月度账务分析",
      contentsInstanceOptimize: "实例优化建议",
      contents21: "2.1 EC2优化建议",
      contents22: "2.2 RDS优化建议",
      contents23: "2.3 实例花费节省预览",
      contents231: "2.3.1 降级前后花费对比",
      contents232: "2.3.2 预留实例推荐花费对比",
      contentsOtherOptimize: "其他优化建议",
      contentsRIMatching: "RI匹配情况",
      contentsOperation: "运维工作",
      contents51: "5.1本月运维事件",
      contents52: "5.2上月待处理事件",
      contentsMajorEvent: "重大事件",
      //工作总结
      workSummaryTitle: "1. 工作总结",
      eventAnalysis: "1.1 事件分析",
      eventHandling: "1.1.1 事件处理",
      summaryFirst: "{month}月份在Case数量为{amount}个，相比{compareMonth}月份{increasedReduction}{cmAmount}个。在收到case请求以后，值班工程师均在不同的事件响应级别内进行了响应。",
      summarySecond: "{month}月份事件处理的详细信息请查看运维工作列表。",
      monthlyAlarmAnalysis: "1.1.2 月度告警分析",
      warningText: "从下图可以看到{month}月份总共收到{reviews}条告警信息，主要来自于EC2实例流量输出的告警，相关工程师已经通知并协助处理了告警。",
      eventSlaAnalysis: "1.1.3 事件SLA分析",
      responseTimeText: "通过对上月所有事件的分析，上月份事件的平均响应时间为{time}分钟，此数据基于御云者的e-ITILining系统。",
      avgResponseTime: "平均响应时间",
      solutionTimeText: "通过对上月所有事件的分析，上月份事件的平均解决时间为{time}分钟，此数据基于御云者的e-ITILining系统。",
      avgSolutionTime: "平均解决时间",
      //月度账务分析
      monthlyAccountAnalysis: "1.2 月度账务分析",
      accountingFirst: "从下图可以看到总体费用（这里的金额单位都是人民币）相对{compareMonth}月份账单{fallingUp}{percentage}，原因{accountReason}。此图来自御云者e-Billing。",
      accountingSecond: "继续对{month}月份用量进行细化，分摊到不同的服务上去，可以看到用量仍然主要集中在{mainFocus}这几个服务上，每个服务所占的比例如下：",
      top5ServiceCost: "Top5服务花费",
      accountingThird: "此图来自御云者e-Billing，旨在告知每项服务在AWS账户花费中所占的比例，数据为经过四舍五入的。",
      //实例优化建议
      instanceOptimizeTitle: "2. 实例优化建议",
      ec2OptimizeTitle: "2.1 EC2优化建议",
      ec2PreviewTitle: "{month}月份EC2实例运行状况预览及优化建议",
      instanceName: "实例名称",
      instanceType: "实例类型",
      cpuUtilizationRate: "CPU使用率(%)",
      memoryUtilizationRate: "内存使用率(%)",
      optimizeSuggestion: "优化建议",
      ec2SuggestionLabel: "EC2优化建议：",
      rdsOptimizeTitle: "2.2 RDS优化建议",
      rdsPreviewTitle: "{month}月份RDS实例运行状况预览及优化建议",
      databaseName: "数据库名称",
      databaseInstanceType: "数据库实例类型",
      freememory: "剩余内存(MB)",
      freeDisk: "剩余磁盘(GB)",
      rdsSuggestionLabel: "RDS优化建议：",
      instanceCostSavePreview: "2.3 实例花费节省预览",
      exampleFirst: "如果基于以上的优化建议（实例降级）进行调整，可以在很大程度上节省贵公司的账务花费，优化之后年度总共可以节省花费{saveMoney}，详细如下：",
      costComparisonTitle: "2.3.1 降级前后花费对比",
      instanceCostComparison: "实例（EC2和RDS）降级前后花费对比",
      optimizeType: "优化类型",
      resourceBefore: "实例调整前",
      resourceAfter: "实例调整后",
      unitPriceBefore: "调整前单价",
      unitPriceAfter: "调整后单价",
      saveCost: "可节省花费",
      riCostComparisonTitle: "2.3.2 预留实例推荐花费对比",
      instanceRiCostComparison: "实例（EC2和RDS）购买预留实例前后花费对比",
      accountId: "账号ID",
      accountName: "账号名称",
      accountGroupName: "账户组名称",
      instanceTenancy: "租赁类型",
      productDescription: "实例系统",
      recommendBuyRI: "推荐购买RI",
      onDemandCost: "按需年度花费",
      noUpfrontCost: "无前期RI年度花费",
      partUpfrontCost: "部分前期RI年度花费",
      allUpfrontCost: "全部前期年度花费",
      //其他优化建议
      otherOptimizeTitle: "3. 其他优化建议",
      riMatchingTitle: "4. RI匹配情况",
      riMatchingText: "贵公司账户购买了{count}台预留实例，经过后台检测，目前全部匹配，详细如下：",
      totalBuyRI: "总共购买RI(单位:台)",
      unmatchRI: "未匹配RI(单位:台)",
      //运维工作
      operationTitle: "5. 运维工作",
      operationEventsTitle: "5.1 本月运维事件",
      time: "时间",
      level: "级别",
      eventDescribe: "事件描述",
      eventProgress: "事件进度",
      priorityNote: "详细P1/P2/P3/P4 如何划分，见 备注一",
      eventsPendingTitle: "5.2 上月待处理事件",
      eventsPendingText: "根据上月度运维报告，贵公司还有部分优化事件待处理，如下：",
      pendingEvent: "待优化事件",
      belongType: "所属类型",
      problemReason: "问题原因",
      //重大事件
      majorEventTitle: "6. 重大事件",
      subjectLabel: "主题: ",
      problemDescribeLabel: "问题描述:",
      eventProgressLabel: "事件进展:",
      eventResultLabel: "事件结果:",
      remarkOne: "备注一：",
      eventPriorityPolicy: "事件优先级分级政策如下：",
      claim: "要求",
      explanation: "说明",
      serviceIndicators: "服务指标",
      remarks: "备注",
      //图表
      eventOverview: "事件总览",
      alertAnalysis: "警报分析",
      alarm: "报警",
      //备注表内容
      remarkClaimP1: "一级事件（P1级事件）",
      remarkExplanationP1: "系统的事件紧急程度高或影响程度大的事件",
      remarkServiceP1: "15分钟内响应",
      remarkRemarksP1: "如:服务器宕机,网络事件导致服务不可用等",
      remarkClaimP2: "二级事件（P2级事件）",
      remarkExplanationP2: "系统的事件紧急程度中等或影响程度中等",
      remarkServiceP2: "1小时内响应",
      remarkRemarksP2: "如:由于服务器性能下降导致部分用户访问响应变慢等",
      remarkClaimP3: "三级事件（P3级事件）",
      remarkExplanationP3: "系统的事件紧急程度低或影响程度小",
      remarkServiceP3: "6小时内响应",
      remarkRemarksP3: "如:个别用户无法访问服务",
      remarkClaimP4: "四级事件（P4级事件）",
      remarkExplanationP4: "对客户系统无影响的事件",
      remarkServiceP4: "24小时内响应",
      remarkRemarksP4: "客户服务请求,不影响当前服务运行"
    }
  },
  approvalFlowConfigManagement: {
    //审批流配置管理
    Node: {
      //节点
      title: "节点",
      addNode: "添加节点",
      nodeName: "节点名称",
      nodeCompany: "节点所属公司",
      user: "用户",
      role: "角色",
      operation: "操作",
      confirmAddNode: "确认添加节点",
      type: "类型",
      nodeType: '节点类型',
      companyName: '公司名称',
      queryByNodeName: '请输入节点名称',
      nodeNameNotEmpty: '节点名称不能为空',
      nodeNameValidateMsg: '节点名称为4-20个字符',
      pleaseSelectNodeType: '请选择类型',
      pleaseSelectUser: '请选择用户',
      pleaseSelectRole: '请选择角色',
      pleaseSelectCompany: '请选择公司',
      editNode: '编辑节点',
      nodeContent: '节点内容'
    },
    approvalFlow: {
      //审批流
      title: "审批流",
      addApprovalFlow: "添加审批流",
      approvalFlowName: "审批流名称",
      approvalFlowCompany: "审批流所属公司",
      companyName: "公司名称",
      pleaseSelectCompany: "请选择公司",
      type: "类型",
      status: "状态",
      operation: "操作",
      delete: "删除",
      editButton: '编辑',
      queryByFlowName: '请输入审批流名称',
      editApprovalFlow: '编辑审批流',
      flowNameNotEmpty: '审批流名称不能为空',
      flowNameValidateMsg: '审批流名称为4-20个字符',
      pleaseSelectType: '请选择类型',
      connectionSucceeded: '连接成功',
      nodeNotConnectingItself: '节点不支持连接自己',
      relationAlreadyExist: '该关系已存在,不允许重复创建',
      nodeNotSupportLookBack: '不支持两个节点之间连线回环',
      flowDataInfo: '流程数据信息',
      confirmDeleteLine: '确定删除所点击的线吗?',
      confirmDeleteNode: '确定要删除该节点吗?',
      dragNodeToCanvas: '请把节点拖入到画布中'
    }
  },

  LabelConfig: {
    LabelSynchronization: {
      synchronizationType: "同步类型",
      tag: "标签",
      rule: "规则",
      contact: "联系人",
      pleaseInputAccount: "请输入账户",
      pleaseSelectContact: "请选择联系人",
      pleaseSelectTag: "请选择标签",
      pleaseSelectRule: "请选择规则",
      fileSync: "文件同步",
      ruleSync: "规则同步",
      exportFileName: "导出的AWS资源标签表.xls",
      syncTagSuccess: "同步标签成功",
      title: "标签同步",
      company: "公司",
      account: "账号",
      resourceType: "资源类型",
      attachment: "附件",
      Keys: "密钥文件",
      attention: "注意：将根据文件中的资源标签覆盖原有标签!",
      updateTag: "更新标签",
      synchronizingTag: "同步标签",
    }
  },
  smartMonitor: {
    //智能监控
    dashboard: {
      //仪表盘
      title: "仪表盘",
      applicationHealthStatus: "应用健康状态",
      instanceResourceName: "资源名称(实例)",
      databaseResourceName: "资源名称(数据库)",
      resourceList: "资源列表",
      accountID: "账户ID",
      accountName: "账户名称",
      instanceName: "实例名称",
      instanceID: "实例ID",
      weight: "权重",
      rating: "评分",
      operation: "操作",
      database: "数据库",
      databaseName: "数据库名称",
      databaseID: "数据库ID",
      resourceIndexConfig: "资源指标配置",
      resourceType: "资源类型",
      resourceName: "资源名称",
      resourceID: "资源ID",
      index: "指标",
      fittingDegreeEstimation: "拟合度参考值",
      MonitorIndexAlert: "监控指标告警",
      currentFittingDegree: "当前拟合度",
      currentIndexRating: "当前指标评分",
      caseID: "案例ID",
      detail: "详情",
      smartMonitorTitle: "智能监控数据库"
    },
    applicationSystem: {
      //应用系统
      title: "应用系统",
      addApplication: "添加应用",
      name: "名称",
      config: "配置",
      operation: "操作",
      applicationConfig: "应用配置",
      addInstance: "添加实例",
      addDatabase: "添加数据库",
      instanceName: "名称",
      account: "账户",
      instanceID: "实例ID",
      region: "区域",
      privateIP: "私有IP",
      status: "状态"
    },
    applicationSystemAlert: {
      //应用系统告警
      title: "应用系统告警",
      applicationName: "应用名称",
      resourceType: "资源类型",
      resourceName: "资源名称",
      resourceID: "资源ID",
      caseID: "案例ID",
      Index: "指标",
      launchTime: "创建时间",
      setIgnorance: "是否忽略",
      operation: "操作",
      detail: "详情",
      CPUUtilization: "CPU使用率",
      CPUUtilizationPrediction: "CPU使用率预测",
      cache: "内存",
      cacheUtilization: "内存使用率",
      cacheUtilizationPrediction: "内存使用率预测",
      networkInput: "网络流入(字节)",
      networkInputPrediction: "网络流入预测",
      networkOutput: "网络流出(字节)",
      networkOutputPrediction: "网络流出预测",
      index: "指标",
      indexRating: "指标评分",
      indexFittingDegree: "指标拟合度",
      predictionValue: "预测值",
      currentValue: "当前值",
      monitorTitle: "智能监控实例"
    }
  },
  aiMonitor: {
    applicationSystem: "应用系统",
    searchByApplicationName: "按应用名称查询",
    query: "查询",
    addApplication: "添加应用",
    enterAlertRuleName: "请输入报警规则名称",
    enterBusinessAppName: "请输入业务应用名称",
    companyName: "公司名称",
    appName: "应用名称",
    alertRuleName: "告警名称",
    config: "配置",
    applicationConfig: "应用配置",
    start: "开启",
    close: "关闭",
    company: "公司",
    ruleName: "规则名称",
    notificationObject: "通知对象",
    alarmWay: "报警方式",
    emailTemplate: "邮箱模板",
    wechatTemplate: "企业微信模板",
    description: "描述",
    companyRequired: "公司不能为空",
    nameRequired: "名称不能为空",
    nameLength: "名称为4-20个字符",
    selectNotificationObject: "请选择通知对象",
    selectAlarmWay: "请选择报警方式",
    enterDescription: "请输入描述",
    maxChars10000: "最多输入10000个字符",
    alertResourceDetail: "告警资源详情",
    resourceId: "资源ID",
    resourceName: "资源名称",
    metricName: "指标名称",
    threshold: "阈值",
    currentValue: "当前值",
    instance: "实例",
    database: "数据库",
    disk: "磁盘",
    account: "账户",
    region: "存储区域",
    tags: "标签",
    enterValue: "请输入值",
    addInstanceTitle: "添加实例",
    addDatabaseTitle: "添加数据库",
    addElasticsearch: "添加Elasticsearch",
    cloudPlatform: "云平台",
    databaseEngine: "数据库引擎",
    selectCloudPlatform: "请选择云平台",
    selectAccountName: "请选择账户名称",
    selectRegion: "请选择存储区域",
    selectDatabaseEngine: "请选择数据库引擎",
    selectAccount: "请选择账户",
    detail: "详情",
    configMonitorIndex: "配置监控指标",
    configWeight: "配置权重",
    instanceWeight: "实例权重",
    databaseWeight: "数据库权重",
    cpuUsageWeight: "CPU使用率权重",
    fitting: "拟合度",
    memoryUsageWeight: "内存使用率权重",
    memoryAvailableWeight: "可用内存权重",
    networkInflowWeight: "网络流入权重",
    networkOutflowWeight: "网络流出权重",
    readIopsWeight: "读IOPS权重",
    writeIopsWeight: "写IOPS权重",
    update: "更新",
    enterInstanceWeight: "请输入实例权重",
    enterDatabaseWeight: "请输入数据库权重",
    enterCpuUsageWeight: "请输入CPU使用率权重",
    enterFitting: "请输入拟合度",
    enterMemoryUsageWeight: "请输入内存使用率权重",
    enterMemoryAvailableWeight: "请输入可用内存权重",
    enterNetworkInflowWeight: "请输入网络流入权重",
    enterNetworkOutflowWeight: "请输入网络流出权重",
    enterReadIopsWeight: "请输入读IOPS权重",
    enterWriteIopsWeight: "请输入写IOPS权重",
    monitorIndex: "监控指标",
    alertThreshold: "告警阈值",
    selectMonitorIndex: "请选择监控指标",
    selectDate: "请选择日期",
    return: "返回",
    applicationNamePlaceholder: "应用名称",
    detailTitleInstance: "智能监控实例",
    detailTitleDatabase: "智能监控数据库",
    detailTitleDisk: "智能监控磁盘",
    detailTitleEs: "智能监控Elasticsearch",
    metrics: {
      cpuUsage: "CPU使用率",
      instanceMemoryUsage: "实例内存使用率",
      instanceNetworkInput: "实例网络输入",
      instanceNetworkOutput: "实例网络输出",
      instanceHealthCheck: "实例健康状态检查",
      systemHealthCheck: "系统健康状态检查",
      rdsCpuUsage: "RDS CPU使用率",
      rdsMemoryUsage: "RDS内存使用率",
      rdsDiskSpaceUsage: "RDS磁盘空间使用率",
      rdsDatabaseConnections: "RDS数据库连接数",
      rdsReadIops: "RDS 读IOPS",
      rdsWriteIops: "RDS 写IOPS",
      diskUsage: "磁盘使用率",
      readIops: "读IOPS",
      writeIops: "写IOPS",
      readThroughput: "读吞吐量",
      writeThroughput: "写吞吐量",
      messageProducers: "消息生产者数量",
      messageConsumers: "消息使用者数量",
      totalMessages: "消息总数",
      totalQueued: "排队总数",
      awsEsRedClusterStatus: "AWS ES 红色集群状态",
      awsEsYellowClusterStatus: "AWS ES 黄色集群状态",
      clusterAvailableStorage: "AWS ES 集群可用存储空间",
      clusterNode: "AWS ES 集群节点"
    },
    charts: {
      cpuUsage: "CPU使用率",
      cpuUsagePrediction: "CPU使用率预测值",
      instanceMemoryUsage: "实例内存使用率",
      instanceMemoryUsagePrediction: "实例内存使用率预测值",
      instanceNetworkInput: "实例网络输入",
      instanceNetworkInputPrediction: "预测实例网络输入",
      instanceNetworkOutput: "实例网络输出",
      instanceNetworkOutputPrediction: "预测实例网络输出",
      instanceHealthCheck: "实例健康状态检查",
      instanceHealthCheckPrediction: "实例健康状态检查预测值",
      systemHealthCheck: "系统健康状态检查",
      systemHealthCheckPrediction: "系统健康状态检查预测值",
      rdsDiskSpaceUsage: "RDS磁盘空间使用率",
      rdsDiskSpaceUsagePrediction: "预测RDS磁盘空间使用率",
      rdsDatabaseConnections: "RDS数据库连接数",
      rdsDatabaseConnectionsPrediction: "预测RDS数据库连接数",
      rdsCpuUsage: "rds CPU使用率",
      rdsCpuUsagePrediction: "rds CPU使用率预测值",
      rdsMemoryUsage: "RDS内存使用率",
      rdsMemoryUsagePrediction: "预测RDS内存使用率",
      rdsReadIops: "rds 读IOPS",
      rdsReadIopsPrediction: "预测rds 读IOPS",
      rdsWriteIops: "rds 写IOPS",
      rdsWriteIopsPrediction: "预测rds 写IOPS",
      readIops: "读IOPS",
      readIopsPrediction: "读IOPS预测值",
      writeIops: "写IOPS",
      writeIopsPrediction: "写IOPS预测值",
      readThroughput: "读吞吐量",
      readThroughputPrediction: "预测读吞吐量",
      writeThroughput: "写吞吐量",
      writeThroughputPrediction: "预测写吞吐量",
      diskUsage: "磁盘使用率",
      diskUsagePrediction: "预测磁盘使用率",
      messageProducers: "消息生产者数量",
      messageProducersPrediction: "消息生产者数量预测值",
      messageConsumers: "消息使用者数量",
      messageConsumersPrediction: "消息使用者数量预测值",
      totalMessages: "消息总数",
      totalMessagesPrediction: "预测消息总数",
      totalQueued: "排队总数",
      totalQueuedPrediction: "预测排队总数",
      awsEsRedClusterStatus: "AWS ES 红色集群状态",
      awsEsRedClusterStatusPrediction: "AWS ES 红色集群状态预测值",
      awsEsYellowClusterStatus: "AWS ES 黄色集群状态",
      awsEsYellowClusterStatusPrediction: "AWS ES 黄色集群状态预测值",
      clusterAvailableStorage: "AWS ES 集群可用存储空间",
      clusterAvailableStoragePrediction: "预测AWS ES 集群可用存储空间",
      clusterNode: "AWS ES 集群节点",
      clusterNodePrediction: "预测AWS ES 集群节点"
    }
  },
  tag: {
    labelCorrection: {
      title: "标签纠正",
      addLabelCorrection: "添加标签纠正",
      editLabelCorrection: "编辑标签纠正",
      standardTagKey: "标准标签key",
      standardTagValue: "标准标签value",
      pleaseSelectStandardTagKey: "请选择标准标签key",
      pleaseInputStandardTagValue: "请输入标准标签value",
      duplicateCorrectionData: "当前Tag的纠正数据已存在!",
      originalTag: "原标签",
      standardTagName: "标准标签名称",
      standardTagCorrectedValue: "标准标签纠正后的值",
      standardTagAssociatedValues: "标准标签纠正关联标签的值",
      sureDeleteRecord: "您确定删除该记录吗 ?",
    },
    monitoring: {
      title: "标签监控",
      addTagMonitoring: "添加标签监控",
      executeImmediately: "立即执行",
      sureDeleteRecord: "您确定删除该记录吗 ?",
      addTagAlarm: "添加标签告警",
      editTagAlarm: "编辑标签告警",
      autoExecuteTip: "标签告警会从零点开始每三个小时自动执行一次",
      cloudPlatform: "云平台",
      company: "公司",
      accountField: "账户",
      region: "区域",
      resourceType: "资源类型",
      key: "键",
      value: "值",
      relation: "关系",
      ruleName: "规则名称",
      ruleDescription: "规则描述",
      notificationTarget: "通知对象",
      contact: "联系人",
      account: "账号",
      pleaseSelectCloudPlatform: "请选择云平台",
      pleaseSelectCompany: "请选择公司",
      pleaseSelectAccountName: "请选择账户名称",
      pleaseSelectResourceType: "请选择资源类型",
      pleaseSelectRelation: "请选择关系",
      pleaseInputRuleName: "请输入规则名称",
      executeSuccess: "执行成功!",
      executeFail: "执行失败!",
    },
    pleaseSelectCompany: "请选择公司",
    pleaseSelectAccount: "请选择账号",
    pleaseSelectResourceType: "请选择资源类型",
    tagNameRequired: "标签名称不能为空",
    resourceTagFileName: "资源标签.xls",
    addMappingTagSuccess: "添加标签映射成功",
    tag: '标签',
    labelProcessing:'标签处理 (Under Construction)',
    setUpTagMapping: "设置标签映射",
    searchTagMapping: "查询标签映射",
    search: "查询",
    standardTag: '标准标签',
    resourceTag: '资源标签',
    tagMapping: '标签映射',
    pleaseInputTag: '请输入标签',
    addTag: '添加标签',
    tagName: '标签名称',
    thisTag: '该标签吗',
    thisMappingTag: '该标签映射吗',
    editTag: '编辑标签',
    pleaseSelectAwsResourceType: '请选择AWS资源类型',
    resourceId: '资源ID',
    resourceName: '资源名称',
    pleaseSelectStandardTag: '请选择标准标签',
    mappingTag: '映射标签',
    addMappingTag: '添加标签映射',
    update:'更新'
  },
  resourceLifecycle: {
    purchaseAllUpfrontOneYearPrice: "购买RI价格（一年|All Upfront）",
    purchaseNoUpfrontOneYearPrice: "购买RI价格 （No Upfront）",
    //Common
    queryByPurpose: "请输入用途",
    queryByResourceName: "请输入资源名称",
    filterByResourceType: "请输入资源类型",
    attachment: "附件",
    keyNameCannotBeName: "键名不能为Name",
    editResourcePriceCoefficient: "编辑资源价格系数",
    clickOrDragFileHere: "单击或拖动文件到此处上传",
    submit: "提交",
    process: "流程",
    virtualMachine: "虚拟机",
    virtualNetwork: "虚拟网络",
    objectStorage: "对象存储",
    database: "托管数据库",
    elasticIP: "弹性IP",
    azureMySQLServer: "Azure MySQL 服务器",
    azureMariaDBServer: "Azure MariaDB 服务器",
    azureRedisServer: "Azure Redis 服务器",
    select: "选择",
    view: "查看",
    fileName: "文件名",
    fileType: "文件类型",
    change: "变更",
    renew: "续约",
    recycle: "回收",
    use: "用途",
    platform: "平台",
    cloudPlatform: "云平台",
    region: "区域",
    resourceName: "资源名称",
    resourceType: "资源类型",
    resourceState: "资源状态",
    resourceConfig: "资源配置",
    environment: "环境",
    term: "期限（月）",
    startDate: "开始日期",
    endDate: "结束日期",
    estimatedCost: "预估花费（元）",
    download: "下载",
    basicInformation: "基本信息",
    accountId: "账号",
    resourceGroup: "资源组",
    pleaseEnter: "请输入",
    pleaseSelect: "请选择",
    periodOfUse: "使用期限",
    months: "个月",
    clickordragfilestouploadhere: "单击或拖动文件到此处上传",
    remark: "备注",
    application: "申请",
    produce: "生产",
    development: "测试",
    name: "名称",
    databaseName: "数据库名称",
    databaseEngine: "数据库引擎",
    databaseVersion: "数据库版本",
    databaseEngineVersion: "数据库引擎版本",
    databaseInstanceType: "数据库实例类型",

    //资源服务目录
    resourceServiceDirectory: "资源服务目录",
    addResource: "添加资源",
    //资源申请
    pleasechoosecloudplatform: "请选择云平台",
    pleaseselectanaccount: "请选择账号",
    pleaseselectaregion: "请选择区域",
    useCannotbeempty: "用途不能为空",
    theexpirationdatecannotbeempty: "使用期限不能为空",
    pleaseselectresourcetype: "请选择资源类型",
    pleaseselectresourcegroup: "请选择资源组",
    pleaseselectresourceenvironment: "请选择环境",
    pleaseselectresourceprocess: "请选择流程",
    pleaseenterabackup: "请输入备份",
    successfulApplication: "申请成功",
    resourceApplication: "资源申请",
    namecannotbeempty: "名称不能为空",
    basicinformationElasticIP: "基本信息 (弹性IP)",
    multiAZDeployment: "多可用区部署",
    allocatedStorageSpace: "分配存储空间",
    storageType: "存储类型",
    presetIOPS: "预置IOPS",
    masterUsername: "主用户名",
    masterPassword: "主密码",
    databaseParameterGroup: "数据库参数组",
    optionGroup: "选项组",
    iamDatabaseAuthentication: "IAM数据库身份验证",
    publicAvailability: "公开可用性",
    availabilityZone: "可用区",
    subnetGroup:"子网组",
    vpcSecurityGroup:"VPC 安全组",
    existingSecurityGroup:"现有安全组",
    selectAll:"全选",
    copyTagsToSnapshot:"是否复制标签给快照",
    enableDeleteProtection:"是否开启删除保护",
    universalSSD:"universalSSD",
    presetIOPSSSD:"预置IOPS(SSD)",
    createcopiesindifferentregions:"在不同区域创建副本",
    no:"否",
    basicinformationhosteddatabase:"基本信息（托管数据库）",
    yes:"是",
    enableIAMdatabaseauthentication:"启用IAM数据库身份验证",
    disable:"禁用",
    createanewVPCsecuritygroup:"创建新的VPC安全组",
    selectanexistingVPCsecuritygroup:"选择现有VPC安全组",
    databasenamecannotbeempty:"数据库名称不能为空",
    pleaseselectadatabaseengine:"请选择数据库引擎",
    pleaseselectthedatabaseengineversion:"请选择数据库引擎版本",
    pleaseselectthedatabaseversion:"请选择数据库版本",
    pleaseselectthedatabaseinstancetype:"请选择数据库实例类型",
    pleaseselectmultizonedeployment:"请选择多可用区部署",
    pleaseselectstoragetype:"请选择存储类型",
    pleaseentertheallocatedstoragespace:"请输入分配的存储空间",
    pleaseenterthepresetIOPS:"请输入预置IOPS",
    themainusernamecannotbeempty:"主用户名不能为空",
    masterpasswordcannotbeempty:"主密码不能为空",
    pleaseentertheport:"请输入端口",
    account:"账号:",
    area:"区域:",
    uses:"用途:",
    periodofuse:"使用期限:",
    flow:"流程:",
    resourceConfiguration:"资源配置",
    dBInstanceClass:"数据库实例类:",
    allottedstorage:"分配的存储空间:",
    ports:"端口:",
    databaseParameterGroups:"数据库参数组:",
    optionGroups:"选项组:",
    iAMDatabaseAuthentication:"IAM数据库身份验证:",
    vPCSecurityGroup:"VPC 安全组:",
    existingSecurityGroups:"现有安全组:",
    copylabelforsnapshot:"是否复制标签给快照:",
    enabledeleteprotection:"是否启用删除保护:",
    exhibits:"附件",
    remarkation:"备注:",
    estimatedcost:"预估费用:",
    filenames:"文件名",
    bucketName:"存储桶名称",
    pleaseenter:"请输入",
    copysettingsfromanexistingbucket:"从现有存储桶复制设置",
    basicinformationobjectstorage:"基本信息 (对象存储)",
    bucketname:"存储桶名称:",
    estimatedcosts:"预估费用",
    enableTerminationProtection:"启用终止保护",
    numberofinstances:"实例数量",
    keypair:"密钥对",
    surveillance:"监控",
    webs:"网络",
    securityGroup:"安全组",
    automaticdistributionofpublicIP:"自动分配公网IP",
    disks:"磁盘",
    calculationSpecifications:"计算规格",
    cloudPlatformSpecifications:"云平台规格",
    operatingsystem:"操作系统",
    tags:"标签",
    pleaseselectEnableTerminationProtection:"请选择启用终止保护",
    pleaseenterthenumberofinstances:"请输入实例数量",
    pleaseselectakeypair:"请选择密钥对",
    pleaseselectMonitoring:"请选择监控",
    pleaseselectCalculationSpecification:"请选择计算规格",
    pleaseselecttheoperatingsystem:"请选择操作系统",
    pleaseselectamirror:"请选择镜像",
    pleaseselectsubnet:"请选择子网",
    pleaseselectnetwork:"请选择网络",
    pleaseselectAutoAssignPublicIP:"请选择自动分配公网IP",
    pleaseselectasecuritygroup:"请选择安全组",
    selects:"选择",
    models:"机型",
    numberofCPUcores:"CPU数量(核)",
    memoryGB:"内存(GB)",
    volumeType:"卷类型",
    availabilityZones:"可用区域",
    sizeGiB:"大小（GiB）",
    whethertoencrypt:"是否加密",
    operations:"操作",
    basicInformationVirtualMachine:"基本信息 (虚拟机)",
    keyPair:"密钥对:",
    monitoring:"监控:",
    network:"网络:",
    disk:"磁盘:",
    numberofCPUs:"CPU数量:",
    memory:"内存:",
    rAM:"内存",
    vPCName:"VPC名称",
    vPCIPv4CIDRblock:"VPC IPV4 CIDR块",
    iPv6CIDRblock:"IPV6 CIDR块",
    hardwareRental:"硬件租赁",
    subnetNameLabel:"子网名称标签",
    subnetIPv4CIDRblock:"子网 IPV4 CIDR块",
    vPCIPV4CIDRblockcannotbeempty:"VPC IPV4 CIDR块不能为空",
    subnetIPv4CIDRblockcannotbeempty:"子网 IPV4 CIDR块不能为空",
    pleaseselectIPv6CIDRblock:"请选择IPV6 CIDR块",
    pleaseselectHardwareRental:"请选择硬件租赁",
    subnetnametagcannotbeempty:"子网名称标签不能为空",
    basicInformationVirtualNetwork:"基本信息 (虚拟网络)",
    subnetNameTag:"子网名称标签:",
    assign:"分配",
    pleaseselectSKU:"请选择SKU",
    pleaseselectAssignment:"请选择分配",
    basicInformationElasticIP:"基本信息(弹性IP)",
    assignment:"分配:",
    databaseTypes:"数据库类型",
    serverName:"服务器名称",
    versions:"版本",
    serverTypes:"服务器类型",
    storing:"存储",
    storageAutomatedGrowth:"存储自动增长",
    backuphold:"备份保持期",
    backupredundancy:"备份冗余",
    username:"用户名",
    passwords:"密码",
    pricingLayer:"定价层",
    whethertoenableunencryptedSSL:"是否启用非加密的SSL",
    enabling:"启用",
    donotenable:"不启用",
    disabling:"禁用",
    localredundancy:"本地冗余",
    districtredundancy:"地区冗余",
    pleaseselecttheversion:"请选择版本",
    pleaseselecttheservertype:"请选择服务器类型",
    pleaseselectthedatabasetype:"请选择数据库类型",
    usernamecannotbeempty:"用户名不能为空",
    pleaseenterapassword:"请输入密码",
    dNSnamecannotbeempty:"DNS名称不能为空",
    pleaseselectPricingLevel:"请选择定价层",
    pleaseselectwhethertoenablenonsslRedisserverport:"请选择是否启用是否启用非ssl Redis服务器端口",
    pleaseentervCore:"请输入vCore",
    pleaseenterstorage:"请输入存储",
    pleaseenterthebackuphold:"请输入备份保持期",
    pleaseselectthestorageforautogrowth:"请选择存储自动增长",
    pleaseselectBackupRedundancy:"请选择备份冗余",
    basicinformationmanageddatabase:"基本信息 (托管数据库)",
    databaseType:"数据库类型:",
    version:"版本:",
    serverType:"服务器类型:",
    storage:"存储:",
    password:"密码:",
    dNSName:"DNS名称:",
    pricingTier:"定价层:",
    whethertoenablenonencryptedSSL:"是否启用非加密的SSL:",
    publicaccesslevel:"公共访问级别",
    storageAccounts:"存储账户",
    pleaseselectPublicAccessLevel:"请选择公共访问级别",
    pleaseselectastorageaccount:"请选择存储账户",
    publicAccessLevel:"公共访问级别:",
    storageAccount:"存储账户:",
    oSDiskType:"OS磁盘类型",
    pleaseselectOSDiskType:"请选择OS磁盘类型",
    addressrangecannotbeempty:"地址范围不能为空",
    subnetName:"子网名称",
    addressRange:"地址范围:",
    noIPv6CIDRblock:"无IPv6 CIDR块",
    ipv6CIDRblockprovidedbyAmazon:"Amazon 提供的IPv6 CIDR块",

    //资源变更
    queryResources:"查询资源",
    querybyPurpose:"请输入用途",
    querybyResourceName:"请输入资源名称",
    filterbyresourcetype:"请输入资源类型",
    clickordragthefiletouploadhere:"单击或拖动文件到此处上传",
    pleaseselecttheflow:"请选择流程",
    platforms:"平台",
    zones:"区域",
    surroundings:"环境",
    periodmonths:"期限（月）",
    startdate:"开始日期",
    estimatedcostyuan:"预估花费（元）",
    resourceChange:"资源变更",
    resourcechangeinformation:"资源变更信息",
    subnet:"子网:",
    add:"添加",
    delete:"删除",
    keyupto128characters:"键 （最多128个字符）",
    valueupto256characters:"值 （最多256个字符）",
    addTag:"添加标签",
    atleastonesubdimensionisrequired:"至少需要一个子维度",
    filterbyResourceType:"请选择资源类型",
    renewationPeriod:"续约期限",
    vMs:"虚拟机",
    objectstorage:"对象存储",
    manageddatabase:"托管数据库",
    resourceRenew:"资源续约",
    resourceRenewationInformation:"资源续约信息",
    renewerPeriod:"续约期限:",
    base:"基础",
    generalPurpose:"常规用途",
    memoryOptimization:"内存优化",


    //资源回收
    resourceRecycle:"资源回收",
    searchResource:"查询资源",
    resourceAllocation:"资源配置",
    resourceReturnOrRecycleReason:"资源返还/回收原因",
    blobonlyanonymousreadaccessBlob:"Blob(仅匿名读取访问Blob)",
    containeranonymousreadaccessblob:"容器（匿名读取访问Blob）",
    dedicatednoanonymousaccess:"专用（无匿名访问）",
    usingCIDRnotation:"虚拟网络的地址空间，采用 CIDR 表示法(例如 192.168.1.0/24)指定为一个或多个地址前缀。",
    addresourcepricecoefficient:"添加资源价格系数",

    //资源服务运营报告
    resourceRecycleInfo:"资源回收信息",
    resourcespendmonthstatistics:"资源花费月统计图",
    listofresources:"资源列表",
    resourcesspentthismonth:"本月资源花费",
    fees:"费用:",
    numberofresources:"资源数量",
    totalresourcecost$:"资源总花费(￥)",
    incorporation:"公司",
    coefficients:"系数",
    picturing:"描述",
    lastPrice:"最后价格",
    pleaseselectacompany:"请选择公司",
    pleaseselectthecloudplatform:"请选择云平台",
    pleaseselecttheresourcetype:"请选择资源类型",
    pleaseenterthecoefficient:"请输入系数",
    pleaseenteradescription:"请输入描述",
    filterbycloudplatform:"请输入云平台",
    companyName:"公司名称",
    resourcepricefactorconfiguration:"资源价格系数配置",
    resourceServiceOperationsReport:"资源服务运营报告",
    pleaseselectDatabaseParameterGroup:"请选择数据库参数组",
    pleaseselectanoptiongroup:"请选择选项组",
    pleaseselectIAMDatabaseAuthentication:"请选择IAM数据库身份验证",
    pleaseselectvpc:"请选择vpc",
    pleaseselectSubnetGroup:"请选择子网组",
    pleaseselectPublicAvailability:"请选择公开可用性",
    pleaseselectanAvailabilityZone:"请选择可用区",
    pleaseselectVPCSecurityGroup:"请选择VPC 安全组",
    pleaseselectanexistingsecuritygroup:"请选择现有安全组",
    bucketnamecannotbeempty:"存储桶名称不能为空",
    pleasechoosetocopysettingsfromanexistingbucket:"请选择从现有存储桶复制设置",
    //Input Validation
    inputValidation: {
      requiredProcess: "请选择流程",
      requiredResourceReturnOrRecycleReason: "请填写资源返还/回收原因",
    },

    //UI Response
    response: {
      uploadSuccess: "上传成功",
      uploadFail: "上传失败",
      deleteSuccess: "删除成功",
      recycleSuccess: "回收成功",
      downloadSuccess: "下载成功",
      renewSuccess: "续约成功",
      addSuccess: "添加成功",
      addFail: "添加失败",
      editSuccess: "编辑成功",
      editFail: "编辑失败",
    },

    blobAnonymousReadAccess: 'Blob（仅针对 Blob 的匿名读取访问）',
    containerAnonymousReadAccess: '容器（针对容器和 Blob 的匿名读取访问）',
    dedicatedNoAnonymousAccess: '专用（无匿名访问）',
    port: '端口',
    pleaseSelectAutoAssignPublicIP: '请选择自动分配公网IP',
    basics: '基本',
    standards: '标准',
    dynamically: '动态',
    statically: '静态',
    series: '系列',
  },
  OriginalBillEntry:{
    BillingBucketConfiguration:'账单存储桶配置',
    uploadbill:'上传账单',
    company:'公司',
    account:'账户',
    PaymentAccount:'付款账号',
    select:'查询',
    config:'配置',
    accountName:'账户名称',
    accountNumberName:'账号名称',
    accountID:'账号id',
    bucketName:'桶名称',
    SynchronizeRecords:'同步记录',
    del:'删除',
    cancel:'取消',
    confirm:'确认',
    region:'区域',
    month:'月份',
    upload:'上传',
    fileName:'文件名称',
    startTime:'开始时间',
    endTime:'结束时间',
    syncStatus:'同步状态',
    syncMsg:'同步信息',
    syncTime:'同步时间',
    syncType: '同步类型',
    syncRecord:'同步记录',
    uploadMsg:'单击或拖动文件到此处上传',
    uploadAttachment: "上传附件：",
    pleaseEnterPayAccount: "请输入付款账号",
    domestic: "国内",
    overseas: "国外",
    pleaseUploadAttachment: "请上传附件",
    pleaseInputComplete: "请输入完整"
  },
  aiChat: {
    title: '数字运维工程师',
    thinking: '思考中',
    content: '由ETOOLINING提供的AI数字运维工程师，可以帮您查询实例数据，检查资源状态，筛选性能指标，快速定位日志等。',
    questionText: '可以试着问：',
    questionOne: '查询北京区域所有运行中的EC2实例CPU使用率？',
    questionTwo: '当前待处理的P1级案例有哪些？',
    questionThree: '列出AWS中连续3个月CPU利用率低于30%的EC2实例。',
    createNewConversation: '创建新的对话',
    pleaseEnterYourQuestion: '请输入问题',
    historicalConversationRecords: '历史对话记录',
    conversationDetails: '对话详情',
    areYouSureToDeleteThisChatRecord: '是否确认删除该对话？删除后不可恢复。',
    copyText: '复制文字',
    answerAgain: '重新回答',
    like: '点赞',
    cancelLike: '取消点赞',
    dislike: '点踩',
    cancelDislike: '取消点踩',
    thinkText: '分析中...',
    deepThinking: '已深度思考',
    timeSpent: '用时',
    seconds: '秒',
    user: '用户',
    assistant: 'AI助手',
    inputPlaceholder: '在这里输入消息，按 Enter 发送',
    loading: '加载中...',
    noMoreData: '没有更多数据了'
  }


};




// WEBPACK FOOTER //
// ./src/i18n/lang/zh.js